import React, { Fragment, useState, useEffect, forwardRef as forwardRef$1, useRef, useMemo, useCallback } from 'react';
import { Text as Text$1, Breadcrumb as Breadcrumb$1, BreadcrumbItem, BreadcrumbLink, Button as Button$1, Icon as Icon$1, Box, Heading, Divider, FormLabel, Flex, Checkbox as Checkbox$1, FormControl, CheckboxGroup as CheckboxGroup$1, Stack, CircularProgress as CircularProgress$1, CircularProgressLabel, Menu as Menu$1, theme as theme$1, MenuButton as MenuButton$1, MenuItem as MenuItem$1, forwardRef, MenuList as MenuList$1, MenuGroup as MenuGroup$1, Link, IconButton as IconButton$1, Input as Input$2, FormHelperText, FormErrorMessage, Spinner as Spinner$1, Alert, AlertIcon, AlertTitle, AlertDescription, CloseButton as CloseButton$2, PinInput as PinInput$1, PinInputField, Radio as Radio$1, RadioGroup as RadioGroup$1, Table as Table$1, Tag as Tag$1, TagLabel, TagCloseButton, Thead as Thead$1, Th as Th$1, Tr as Tr$1, Tbody as Tbody$1, Td as Td$1, Textarea, ChakraProvider, Tooltip, ModalHeader, ModalCloseButton, ModalBody as ModalBody$1, ModalFooter as ModalFooter$1, Modal as Modal$1, ModalOverlay, ModalContent, Drawer, DrawerOverlay, DrawerContent, DrawerBody, useToast as useToast$1, Tabs as Tabs$1, Tab as Tab$1, TabList as TabList$1, TabPanels as TabPanels$1, TabPanel as TabPanel$1, UnorderedList, ListItem, Accordion as Accordion$1, AccordionItem, AccordionButton, AccordionPanel } from '@chakra-ui/react';
export { Box, Container, Flex, Grid, GridItem, Image, Link, MenuDivider } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { keyframes, Global, css } from '@emotion/react';
import dayjs from 'dayjs';
import { useTranslation, initReactI18next } from 'react-i18next';
export { useTranslation, withTranslation } from 'react-i18next';
import isYesterday from 'dayjs/plugin/isYesterday';
import isToday from 'dayjs/plugin/isToday';
import { usePopper } from 'react-popper';
import { motion } from 'framer-motion';
import Downshift from 'downshift';
import { SearchIcon as SearchIcon$1, CloseIcon as CloseIcon$1 } from '@chakra-ui/icons';
import i18n, { t } from 'i18next';
export { changeLanguage } from 'i18next';
import lottie from 'lottie-web';
import { createPortal } from 'react-dom';
import ReactInfiniteScroll from 'react-infinite-scroll-component';
import { useSensors, useSensor, PointerSensor, KeyboardSensor, DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, useSortable, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
export { arrayMove } from '@dnd-kit/sortable';
import { restrictToVerticalAxis, restrictToWindowEdges } from '@dnd-kit/modifiers';
import { CSS } from '@dnd-kit/utilities';

const ABTester = ({
  optionA,
  optionB,
  isOptionB
}) => /*#__PURE__*/React.createElement(Fragment, null, !isOptionB && optionA, isOptionB && optionB);

const Text = ({
  children,
  fontWeight = "regular",
  fontFamily = "paragraphs",
  ...props
}) => /*#__PURE__*/React.createElement(Text$1, Object.assign({
  fontWeight: fontWeight,
  fontFamily: fontFamily
}, props), children);

const Breadcrumb = ({
  breadcrumbData,
  push,
  ...props
}) => /*#__PURE__*/React.createElement(Breadcrumb$1, Object.assign({}, props, {
  mb: "sp8",
  separator: /*#__PURE__*/React.createElement(Text, {
    color: "text.paragraph.light"
  }, "/")
}), breadcrumbData.map(({
  isActive,
  title,
  url = "#"
}) => /*#__PURE__*/React.createElement(BreadcrumbItem, {
  key: title,
  color: isActive ? "neutrals.200" : "brand.500"
}, push && !isActive && /*#__PURE__*/React.createElement(BreadcrumbLink, {
  onClick: () => push(url),
  cursor: "pointer"
}, title), !push && !isActive && /*#__PURE__*/React.createElement(BreadcrumbLink, {
  href: url
}, title), isActive && /*#__PURE__*/React.createElement(Text, {
  fontFamily: "links",
  fontSize: "sm",
  fontWeight: "regular"
}, title))));

const rotateSpinner = keyframes`
0% {
  transform: rotate(0); }
100% {
  transform: rotate(360deg); } 
`;
const SpinnerContainer = styled.div`
  height: 1.5em;
  width: 1.5em;
  position: relative;
  display: inline-block;
  border: 2px solid;
  border-radius: 50%;
  border-top-color: transparent;
  animation: ${rotateSpinner} 1s linear infinite;
`;
const LoadingSpinner = () => /*#__PURE__*/React.createElement(SpinnerContainer, null);

const Button = /*#__PURE__*/React.forwardRef(({
  children,
  spinner,
  size,
  ...props
}, ref) => /*#__PURE__*/React.createElement(Button$1, Object.assign({
  ref: ref,
  type: "button",
  size: size,
  spinner: /*#__PURE__*/React.createElement(LoadingSpinner, null),
  bgColor: props.isLoading && !props.isDisabled && props.variant === "primary" ? "brand.500" : props.isLoading && !props.isDisabled && props.variant === "secondary" ? "brand.200" : ""
}, props), children));

const variantToFontAwesomeStyle = {
  solid: "fas",
  regular: "fas",
  light: "fal",
  duotone: "fad"
};
const Icon = ({
  variant = "regular",
  icon,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Icon$1, Object.assign({}, props), /*#__PURE__*/React.createElement("i", {
    className: `${variantToFontAwesomeStyle[variant]} ${icon}`
  }));
};

const Container = /*#__PURE__*/styled(Box)`
  width: fit-content;
`;
const ChakraHeading = /*#__PURE__*/styled(Heading)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 20px;
`;
const StyledIcon = /*#__PURE__*/styled(Icon)`
  padding: 0;
  height: 12px;
  width: 12px;
`;
const ActionIcon = /*#__PURE__*/styled(Box)`
  cursor: pointer;
`;
const HeaderIcon = /*#__PURE__*/styled(Icon)`
  padding: 0;
  &:first-child {
    height: 16px;
    width: 16px;
  }
  &:last-child {
    height: 12px;
    width: 16px;
  }
`;
const HeadingWrapper = /*#__PURE__*/styled(Box)`
  display: flex;
  align-items: center;
`;
const Card = ({
  children,
  heading,
  actionText,
  actionIcon,
  headerLeftIcon,
  headerRightIcon,
  headerDivider,
  onActionBtnClick = () => {},
  ...props
}) => /*#__PURE__*/React.createElement(Container, Object.assign({
  boxShadow: "30",
  borderRadius: "sm",
  p: "sp16"
}, props), heading && /*#__PURE__*/React.createElement(ChakraHeading, {
  fontFamily: "heading",
  fontSize: "lg",
  fontWeight: "medium",
  mb: "sp8"
}, /*#__PURE__*/React.createElement(HeadingWrapper, null, headerLeftIcon && /*#__PURE__*/React.createElement(HeaderIcon, {
  icon: headerLeftIcon,
  variant: "solid",
  "data-testid": "header-left_icon",
  color: "neutrals.200",
  mr: "sp8"
}), heading, headerRightIcon && /*#__PURE__*/React.createElement(HeaderIcon, {
  icon: headerRightIcon,
  variant: "solid",
  "data-testid": "header-right_icon",
  color: "neutrals.200",
  ml: "sp8"
})), heading && actionText && /*#__PURE__*/React.createElement(Button, {
  onClick: onActionBtnClick,
  variant: "ghost",
  size: "sm",
  "data-testid": "card-action-icon-button"
}, actionText), heading && actionIcon && /*#__PURE__*/React.createElement(ActionIcon, {
  onClick: onActionBtnClick,
  "data-testid": "card-action-button"
}, /*#__PURE__*/React.createElement(StyledIcon, {
  icon: actionIcon,
  variant: "solid",
  color: "neutrals.200"
}))), headerDivider && /*#__PURE__*/React.createElement(Divider, {
  orientation: "horizontal"
}), children);

const errorMessageStylingProps = {
  color: "accent.red.500",
  fontSize: "sm",
  fontFamily: "paragraphs",
  fontWeight: "regular"
};
const StyledChakraFormLabel = /*#__PURE__*/styled(FormLabel)`
  line-height: 16px;
  margin: 0;
`;
const Label = ({
  isRequired,
  name,
  children
}) => /*#__PURE__*/React.createElement(FormControl, {
  isRequired: isRequired
}, /*#__PURE__*/React.createElement(StyledChakraFormLabel, {
  htmlFor: name
}, children));
const Checkbox = ({
  children,
  isRequired,
  name,
  errorMessage,
  labelPlacement = "right",
  isReadOnly,
  ...props
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex, {
  alignItems: "center"
}, labelPlacement && labelPlacement == "left" && /*#__PURE__*/React.createElement(Label, {
  isRequired: isRequired,
  name: name
}, children), /*#__PURE__*/React.createElement(Checkbox$1, Object.assign({}, props, {
  isInvalid: !!errorMessage,
  isReadOnly: !!errorMessage || isReadOnly
}), labelPlacement && labelPlacement == "right" && /*#__PURE__*/React.createElement(Label, {
  isRequired: isRequired,
  name: name
}, children))), !!errorMessage && /*#__PURE__*/React.createElement(Box, Object.assign({}, errorMessageStylingProps), errorMessage));

const CheckboxGroup = ({
  children,
  direction = "row",
  ...props
}) => /*#__PURE__*/React.createElement(CheckboxGroup$1, Object.assign({}, props), /*#__PURE__*/React.createElement(Stack, {
  direction: direction,
  spacing: direction == "column" ? "sp12" : "sp24"
}, children));

const CircularProgress = ({
  children,
  isIndeterminate,
  value,
  size,
  thickness,
  trackColor,
  color,
  capIsRound,
  max,
  min,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(CircularProgress$1, Object.assign({}, props, {
    isIndeterminate: isIndeterminate,
    value: value,
    size: size,
    thickness: thickness,
    trackColor: trackColor,
    color: color,
    capIsRound: capIsRound,
    max: max,
    min: min
  }), /*#__PURE__*/React.createElement(CircularProgressLabel, null, children));
};

const Menu = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Menu$1, Object.assign({}, props), children);

const brand = {
  100: "#F5FCFF",
  200: "#E7F9FF",
  300: "#C9EDFF",
  400: "#0075DB",
  500: "#094C99",
  600: "#0613CF"
};
const neutrals = {
  0: "#FFFFFF",
  10: "#FAFBFC",
  15: "#F8F9FA",
  20: "#F4F5F7",
  30: "#EBECF0",
  40: "#DFE1E6",
  50: "#C1C7D0",
  60: "#B3BAC5",
  70: "#A5ADBA",
  80: "#97A0AF",
  90: "#8993A4",
  100: "#7A869A",
  200: "#6B778C",
  300: "#5E6C84",
  400: "#505F79",
  500: "#42526E",
  600: "#344563",
  700: "#253858",
  800: "#172B4D",
  900: "#051839"
};
const accent = {
  turquoise: {
    100: "#E3FAF8",
    200: "#95F1EB",
    300: "#0BDBCE",
    400: "#00998F",
    500: "#09736D"
  },
  green: {
    100: "#E1F5DC",
    200: "#B4EDB0",
    300: "#76DE6D",
    400: "#34A44A",
    500: "#177335"
  },
  orange: {
    100: "#FFEDD3",
    200: "#FFD79D",
    300: "#FFB240",
    400: "#DB7901",
    500: "#9E4200"
  },
  red: {
    100: "#FFE8EA",
    200: "#FFC6CB",
    300: "#F4767F",
    400: "#CC3746",
    500: "#AD1F1F",
    600: "#8e030f"
  },
  yellow: {
    100: "#FCFFD6",
    200: "#FFFFA6",
    300: "#FFF03F"
  }
};
const text = {
  white: neutrals[0],
  paragraph: {
    light: neutrals[200],
    regular: neutrals[500]
  },
  title: neutrals[900],
  link: {
    default: brand[500],
    hover: brand[400]
  }
};
const info = {
  background: accent.turquoise[100],
  icon: accent.turquoise[400],
  title: accent.turquoise[500],
  paragraph: text.paragraph.regular,
  link: text.link.default
};
const success = {
  background: accent.green[100],
  icon: accent.green[400],
  title: accent.green[500],
  paragraph: text.paragraph.regular,
  plainText: accent.green[500],
  link: text.link.default
};
const warning = {
  background: accent.orange[100],
  icon: accent.orange[400],
  title: accent.orange[500],
  paragraph: text.paragraph.regular,
  plainText: accent.orange[500],
  link: text.link.default
};
const error = {
  background: accent.red[100],
  icon: accent.red[400],
  title: accent.red[500],
  paragraph: text.paragraph.regular,
  plainText: accent.red[500],
  link: text.link.default
};
const form = {
  disabled: {
    background: neutrals[40],
    text: neutrals[400]
  },
  outline: {
    light: neutrals[50],
    dark: neutrals[100]
  }
};
const colors = {
  brand,
  neutrals,
  accent,
  info,
  success,
  warning,
  error,
  form,
  text
};

const poppinsFont = 'Poppins, "Times New Roman", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
const robotoFont = 'Roboto, "Times New Roman", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
const fonts = {
  heading: poppinsFont,
  paragraphs: robotoFont,
  forms: robotoFont,
  buttons: robotoFont,
  links: robotoFont
};
const fontSizes = {
  xs: "10px",
  sm: "12px",
  md: "14px",
  lg: "16px",
  xl: "18px",
  xxl: "22px"
};
const fontWeights = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700
};

const space = {
  sp2: "2px",
  sp4: "4px",
  sp8: "8px",
  sp12: "12px",
  sp16: "16px",
  sp24: "24px",
  sp32: "32px",
  sp64: "64px",
  sp96: "96px"
};

const button = {
  baseStyle: {
    color: "text.title",
    bg: "neutrals.50",
    py: "sp12",
    px: "sp16",
    borderRadius: "sm",
    _focus: {
      boxShadow: "outline"
    },
    fontFamily: "buttons",
    fontWeight: "medium",
    fontSize: "md",
    lineHeight: "16px",
    _disabled: {
      bg: "form.disabled.background",
      color: "neutrals.100",
      _hover: {
        bg: "form.disabled.background",
        cursor: "not-allowed"
      }
    }
  },
  variants: {
    primary: {
      bg: "brand.400",
      color: "text.white",
      _hover: {
        bg: "brand.500"
      }
    },
    secondary: {
      bg: "brand.200",
      color: "text.link.default",
      _hover: {
        bg: "brand.300"
      }
    },
    outline: {
      bg: "transparent",
      color: "text.link.default",
      borderColor: "brand.400",
      borderWidth: "1px",
      borderStyle: "solid",
      _hover: {
        bg: "brand.200"
      },
      _disabled: {
        borderColor: "transparent"
      }
    },
    ghost: {
      bg: "transparent",
      color: "text.link.default",
      _hover: {
        bg: "brand.200"
      }
    },
    warning: {
      bg: "accent.orange.300",
      color: "neutrals.900",
      _hover: {
        bg: "accent.orange.200"
      }
    },
    danger: {
      bg: "accent.red.400",
      color: "text.white",
      _hover: {
        bg: "accent.red.600"
      },
      _focus: {
        boxShadow: `0px 0px 0px 3px accent.red.200`
      }
    },
    success: {
      bg: "accent.green.300",
      color: "text.title",
      _hover: {
        bg: "accent.green.200"
      },
      _focus: {
        boxShadow: `0px 0px 0px 3px accent.green.200`
      }
    },
    elevated: {
      bg: "brand.500",
      color: "text.white",
      boxShadow: `0px 3px 5px brand.200`,
      _hover: {
        bg: "brand.400"
      }
    },
    elevatedSubtle: {
      bg: "neutrals.0",
      borderColor: "neutrals.20",
      borderWidth: "1px",
      borderStyle: "solid",
      color: "text.link.default",
      boxShadow: "0px 3px 5px rgba(9, 30, 66, 0.05)",
      _hover: {
        bg: "brand.200"
      }
    }
  },
  sizes: {
    sm: {
      py: "10px",
      px: "sp12",
      fontSize: "sm",
      lineHeight: "14px"
    },
    compact: {
      padding: "sp8",
      fontSize: "sm",
      lineHeight: "14px",
      ".chakra-button__icon": {
        mr: "sp4"
      }
    }
  }
};

const checkbox = {
  baseStyle: {
    control: {
      height: "16px",
      width: "16px",
      borderRadius: "2px",
      position: "relative",
      border: "1px solid",
      borderColor: "neutrals.100",
      svg: {
        zIndex: 9
      },
      _invalid: {
        border: "1px solid",
        borderColor: "accent.red.400"
      },
      _disabled: {
        borderColor: "neutrals.40",
        background: "neutrals.40"
      },
      _checked: {
        borderColor: "brand.400",
        _before: {
          content: "''",
          position: "absolute",
          width: "100%",
          height: "100%",
          background: "brand.400"
        },
        _disabled: {
          svg: {
            color: "neutrals.100"
          },
          _before: {
            background: "neutrals.50"
          },
          border: "1px solid accent.neutrals.50"
        }
      },
      _focus: {
        boxShadow: "outline"
      }
    },
    icon: {
      height: "11px",
      width: "8px",
      marginBottom: "1px",
      color: "neutrals.0"
    },
    label: {
      _checked: {
        _disabled: {
          color: "text.title"
        }
      },
      _disabled: {
        color: "neutrals.100"
      }
    }
  }
};

const radio = {
  baseStyle: {
    label: {
      fontFamily: "paragraphs",
      marginLeft: "8px"
    },
    control: {
      height: "14px",
      width: "14px",
      borderRadius: "lg",
      border: "1px solid",
      borderColor: "neutrals.100",
      position: "relative",
      _invalid: {
        border: "1px solid",
        borderColor: "accent.red.400"
      },
      _disabled: {
        background: "neutrals.40",
        border: "1px solid neutrals.40"
      },
      _checked: {
        _before: {
          content: "''",
          position: "absolute",
          width: "8px",
          height: "8px",
          margin: "3px",
          borderRadius: "lg",
          background: "brand.400"
        },
        _disabled: {
          _before: {
            content: "''",
            position: "absolute",
            width: "8px",
            height: "8px",
            borderRadius: "lg",
            background: "neutrals.100"
          },
          borderColor: "neutrals.40"
        },
        border: "1px solid brand.400"
      },
      _focus: {
        boxShadow: "0px 0px 0px 1px #0075DB, 0px 0px 0px 4px #C9EDFF"
      }
    }
  }
};

const input = {
  parts: ["addon", "field", "element"],
  baseStyle: {
    field: {
      width: "100%",
      minWidth: 0,
      outline: 0,
      position: "relative",
      appearance: "none",
      transitionProperty: "common",
      transitionDuration: "normal",
      border: "1px solid",
      borderColor: "neutrals.50",
      borderRadius: "6px",
      p: "sp12",
      fontSize: "md",
      fontFamily: "forms",
      color: "neutrals.900",
      lineHeight: 1,
      _invalid: {
        border: "1px solid",
        borderColor: "accent.red.300",
        bg: "rgba(255, 232, 234, 0.4) none repeat scroll 0% 0%"
      },
      _disabled: {
        bg: "form.disabled.background",
        color: "neutrals.100"
      },
      _focus: {
        outline: "none",
        zIndex: 1,
        bg: "neutrals.0",
        boxShadow: "0px 0px 3px 0px var(--chakra-colors-brand-400)",
        border: "1px solid",
        borderColor: "brand.400"
      }
    }
  }
};

const formLabel = {
  baseStyle: {
    fontFamily: "forms",
    fontWeight: "regular",
    color: "neutrals.900",
    marginBottom: "0"
  }
};

const formErrorText = {
  baseStyle: {
    text: {
      fontFamily: "forms",
      fontWeight: "medium",
      fontSize: "sm",
      color: "accent.red.500"
    }
  }
};

const form$1 = {
  baseStyle: {
    position: "relative",
    requiredIndicator: {
      color: "accent.red.500",
      marginLeft: "sp4"
    },
    helperText: {
      fontFamily: "forms",
      fontSize: "sm"
    }
  }
};

const link = {
  baseStyle: {
    color: "text.link.default",
    _hover: {
      color: "text.link.hover"
    }
  }
};

const pinInput = {
  baseStyle: {
    border: "1px solid",
    borderColor: "neutrals.50",
    borderRadius: "6px",
    margin: "6px",
    width: "40px",
    height: "40px",
    textAlign: "center",
    alignItems: "center",
    fontSize: "xl",
    fontFamily: "forms",
    color: "neutrals.900",
    _invalid: {
      border: "1px solid",
      borderColor: "accent.red.300",
      bg: "accent.red.100"
    },
    _disabled: {
      bg: "form.disabled.background",
      color: "neutrals.100"
    },
    _focus: {
      outline: "none",
      zIndex: 1,
      bg: "neutrals.0",
      boxShadow: "0px 0px 3px 0px var(--chakra-colors-brand-400)",
      border: "1px solid var(--chakra-colors-brand-400)"
    }
  }
};

const tag = {
  baseStyle: {
    container: {
      borderRadius: "lg",
      fontFamily: "forms",
      height: "30px"
    },
    label: {
      fontSize: "md"
    },
    closeButton: {
      width: "sp8",
      height: "sp8",
      borderRadius: "md"
    }
  },
  variants: {
    brand: {
      container: {
        background: "brand.400",
        color: "neutrals.0"
      }
    },
    subtle: {
      container: {
        background: "neutrals.40",
        color: "neutrals.900",
        svg: {
          color: "neutrals.200"
        }
      }
    },
    dark: {
      container: {
        background: "neutrals.200",
        color: "neutrals.0"
      }
    },
    green: {
      container: {
        background: "accent.green.100",
        color: "neutrals.900",
        svg: {
          color: "accent.green.500"
        }
      }
    },
    orange: {
      container: {
        background: "accent.orange.100",
        color: "neutrals.900",
        svg: {
          color: "accent.orange.500"
        }
      }
    },
    red: {
      container: {
        background: "accent.red.400",
        color: "neutrals.0"
      }
    }
  },
  sizes: {
    default: {
      container: {
        p: "sp4",
        px: "sp12"
      },
      closeButton: {
        p: "sp4"
      }
    },
    compact: {
      container: {
        px: "sp8",
        py: "sp4",
        borderRadius: "lg",
        height: "24px"
      },
      label: {
        fontSize: "sm"
      },
      closeButton: {
        p: "sp8"
      }
    }
  },
  defaultProps: {
    size: "default",
    variant: "primary"
  }
};

const notification = {
  baseStyle: {
    container: {
      minHeight: "33px",
      fontFamily: "forms",
      fontSize: "fontSizes.md",
      borderRadius: "xs",
      display: "flex",
      alignItems: "start",
      py: "sp8"
    },
    title: {
      display: "block",
      fontFamily: "paragraphs",
      fontWeight: "medium",
      fontSize: "md",
      color: "neutrals.900"
    },
    description: {
      paddingBottom: "5px"
    },
    icon: {
      width: "12px",
      height: "12px",
      mx: "sp8",
      my: "sp4"
    }
  },
  variants: {
    info: {
      container: {
        bg: "accent.turquoise.100"
      },
      icon: {
        color: "accent.turquoise.400"
      }
    },
    success: {
      container: {
        bg: "accent.green.100"
      },
      icon: {
        color: "accent.green.400"
      }
    },
    error: {
      container: {
        bg: "accent.red.100"
      },
      icon: {
        color: "accent.red.400"
      }
    },
    warning: {
      container: {
        bg: "accent.orange.100"
      },
      icon: {
        color: "accent.orange.400"
      }
    }
  }
};

const textArea = {
  baseStyle: {
    border: "1px solid",
    borderColor: "neutrals.50",
    borderRadius: "6px",
    height: "100%",
    width: "100%",
    resize: "none",
    padding: "8px",
    fontSize: "md",
    fontFamily: "forms",
    color: "neutrals.900",
    _invalid: {
      border: "1px solid",
      borderColor: "accent.red.300",
      bg: "accent.red.100"
    },
    _disabled: {
      bg: "form.disabled.background",
      color: "neutrals.100"
    },
    _focus: {
      outline: "none",
      zIndex: 1,
      bg: "neutrals.0",
      boxShadow: "0px 0px 3px 0px var(--chakra-colors-brand-400)",
      border: "1px solid",
      borderColor: " brand.400"
    }
  }
};

const closeButton = {
  sizes: {
    lg: {
      fontSize: "16px"
    },
    md: {
      fontSize: "12px"
    },
    sm: {
      fontSize: "10px"
    }
  }
};

const table = {
  parts: ["table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption"],
  baseStyle: {
    table: {
      borderCollapse: "unset",
      width: "full",
      border: "1px solid",
      borderColor: "neutrals.30",
      borderRadius: "sm",
      borderSpacing: 0
    },
    thead: {
      boxShadow: 20
    },
    tbody: {},
    tr: {
      _odd: {
        bg: "neutrals.15"
      }
    },
    th: {
      bg: "neutrals.0",
      textAlign: "start",
      color: "text.title",
      fontSize: "md",
      p: "sp12"
    },
    td: {
      verticalAlign: "middle",
      textAlign: "start",
      p: "sp12"
    }
  }
};

const modal = {
  parts: ["overlay", "dialogContainer", "dialog", "header", "closeButton", "body", "footer"],
  baseStyle: {
    overlay: {
      width: "100%",
      bg: "#000000",
      opacity: "0.6",
      zIndex: "5000"
    },
    dialogContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: "5000"
    },
    dialog: {
      bg: "neutrals.0",
      borderRadius: "8px",
      px: "32px",
      py: "32px"
    },
    body: {
      height: "100%",
      width: "100%",
      mt: "16px",
      overflow: "scroll",
      "::-webkit-scrollbar": {
        display: "none"
      }
    },
    header: {
      flex: "1",
      color: "colors.text.title",
      fontSize: "22px",
      fontFamily: "heading",
      fontWeight: "medium",
      lineHeight: "28px"
    },
    footer: {
      display: "block",
      mt: "16px"
    }
  },
  sizes: {
    sm: {
      dialog: {
        width: "450px",
        maxHeight: "calc(100% - 64px)"
      }
    },
    md: {
      dialog: {
        width: "600px",
        maxHeight: "calc(100% - 64px)"
      }
    },
    lg: {
      dialog: {
        width: "1000px",
        maxHeight: "calc(100% - 64px)"
      }
    },
    xl: {
      dialog: {
        width: "calc(100% - 16px)",
        height: "calc(100% - 16px)"
      },
      footer: {
        display: "flex",
        width: "calc(100% - 16px)",
        justifyContent: "center"
      }
    }
  }
};

const drawer = {
  parts: ["header", "overlay", "dialogContainer", "dialog", "closeButton", "body", "footer"],
  baseStyle: {
    overlay: {
      width: "100%",
      bg: "#000000",
      opacity: "0.6",
      zIndex: "5000"
    },
    dialogContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: "5000"
    },
    dialog: {
      bg: "neutrals.0",
      maxWidth: "500px"
    },
    body: {
      height: "100%",
      overflow: "scroll",
      "::-webkit-scrollbar": {
        display: "none"
      }
    },
    header: {
      flex: "1",
      color: "colors.text.title",
      fontSize: "22px",
      fontFamily: "heading",
      fontWeight: "medium",
      lineHeight: "28px"
    },
    footer: {
      display: "block",
      mt: "16px"
    }
  },
  sizes: {
    sm: {
      dialog: {
        width: "450px",
        maxHeight: "calc(100%)"
      }
    },
    md: {
      dialog: {
        width: "600px",
        maxHeight: "calc(100%)"
      }
    },
    lg: {
      dialog: {
        width: "1000px",
        maxHeight: "calc(100%)"
      }
    },
    xl: {
      dialog: {
        width: "calc(100%)",
        height: "calc(100%)"
      },
      footer: {
        display: "flex",
        width: "calc(100%)",
        justifyContent: "center"
      }
    }
  }
};

const menu = {
  parts: ["button", "list", "item", "groupTitle", "command", "divider"],
  baseStyle: {
    list: {
      bg: "neutrals.0",
      borderRadius: "sm",
      boxShadow: "dropdown"
    },
    item: {
      color: "text.paragraph.title",
      fontFamily: "paragraphs",
      px: "sp16",
      py: "sp8",
      _hover: {
        bg: "neutrals.20"
      },
      _first: {
        borderTopRadius: "sm"
      },
      _last: {
        borderBottomRadius: "sm"
      },
      _disabled: {
        opacity: 0.5,
        cursor: "not-allowed",
        _hover: {
          bg: "none"
        }
      },
      svg: {
        color: "neutrals.200"
      }
    },
    groupTitle: {
      mx: "sp8",
      px: "sp8",
      pt: "sp16",
      pb: "sp12",
      borderTop: "1px solid",
      borderColor: "neutrals.30",
      color: "text.paragraph.light",
      textTransform: "uppercase",
      fontWeight: "bold",
      fontSize: "xs"
    }
  }
};

const spinner = {
  baseStyle: {
    color: "neutrals.200"
  },
  sizes: {
    xs: {
      width: "8px",
      height: "8px"
    },
    sm: {
      width: "16px",
      height: "16px"
    },
    md: {
      width: "24px",
      height: "24px"
    },
    lg: {
      width: "40px",
      height: "40px"
    }
  },
  defaultProps: {
    size: "sm"
  }
};

const breadcrumb = {
  baseStyle: {
    link: {
      fontFamily: "links",
      fontSize: "sm",
      fontWeight: "medium",
      _hover: {
        color: "text.link.hover"
      },
      _focus: {
        boxShadow: "0px 0px 0px 1px #0075DB, 0px 0px 0px 4px #C9EDFF",
        borderRadius: "2px"
      }
    }
  }
};

const tabs = {
  parts: ["root", "tab", "tablist", "tabpanel", "tabpanels", "indicator"],
  baseStyle: {
    fontFamily: "buttons",
    tab: {
      fontWeight: "regular"
    },
    tabpanels: {
      width: "100%",
      height: "100%"
    },
    tabpanel: {
      width: "100%",
      height: "100%"
    }
  },
  variants: {
    line: {
      tablist: {
        borderBottom: `2px solid ${colors.neutrals[30]}`
      },
      tab: {
        p: `${space.sp16}`,
        borderRadius: `${space.sp4} ${space.sp4} 0 0`,
        position: "relative",
        borderBottom: `2px solid transparent`,
        _before: {
          content: '""',
          transition: ".5s ease",
          position: "absolute",
          bgColor: "brand.400",
          top: "100%",
          bottom: "0",
          left: "0",
          right: "0",
          transform: "scaleY(0)"
        },
        _after: {
          content: '""',
          transition: ".2s ease",
          position: "absolute",
          bgColor: `${colors.brand[400]}10`,
          top: "100%",
          bottom: "0",
          left: "0",
          right: "0"
        },
        _focus: {
          borderBottom: `2px solid ${colors.brand[400]}`
        },
        _active: {
          borderRadius: `${space.sp4} ${space.sp4} 0 0`
        },
        _selected: {
          transition: "200ms ease",
          borderBottom: `2px solid ${colors.brand[400]}`,
          marginBottom: "-2px",
          _after: {
            top: "0",
            transform: "scaleY(1)"
          }
        }
      },
      indicator: {
        bg: "brand.400",
        width: "100%",
        height: "2px"
      }
    },
    rounded: {
      tablist: {
        display: "inline-flex",
        bg: "neutrals.30",
        borderRadius: "xl"
      },
      tab: {
        m: "sp4",
        borderRadius: "xl",
        p: `${space.sp12} ${space.sp24}`,
        _focus: {
          boxShadow: "10",
          bg: "neutrals.0"
        },
        _active: {
          bg: "neutrals.0"
        },
        _selected: {
          boxShadow: "10",
          bg: "neutrals.0"
        }
      }
    },
    enclosed: {
      tablist: {
        display: "flex",
        bg: "transparent"
      },
      tab: {
        m: "sp4",
        mb: "0px",
        borderTopStartRadius: "sm",
        borderTopEndRadius: "sm",
        p: `${space.sp12} ${space.sp24}`,
        position: "relative",
        _after: {
          content: '""',
          transition: ".2s ease",
          position: "absolute",
          bgColor: `${colors.neutrals[0]}10`,
          top: "100%",
          bottom: "0",
          left: "0",
          right: "0"
        },
        _focus: {
          boxShadow: "10",
          bg: "neutrals.0"
        },
        _active: {
          bg: "neutrals.0"
        },
        _selected: {
          boxShadow: "10",
          bg: "neutrals.0",
          transition: "200ms ease",
          _after: {
            top: "0",
            transform: "scaleY(1)"
          }
        }
      },
      tabpanels: {
        bg: "neutrals.0"
      }
    },
    removable: {
      tablist: {
        borderBottom: `2px solid ${colors.neutrals[500]}`
      },
      tab: {
        p: `${space.sp12} ${space.sp24}`,
        bg: "neutrals.30",
        marginRight: "sp4",
        borderRadius: `${space.sp4} ${space.sp4} 0 0`,
        _focus: {
          boxShadow: "10",
          bg: "neutrals.500",
          color: "neutrals.0"
        },
        _active: {
          bg: "neutrals.500",
          color: "neutrals.0"
        },
        _selected: {
          bg: "neutrals.500",
          color: "neutrals.0"
        }
      }
    }
  },
  defaultProps: {
    variant: "line"
  }
};

const divider = {
  baseStyle: {
    borderWidth: "1px",
    borderColor: "neutrals.20"
  },
  variants: {
    solid: {
      borderStyle: "solid"
    },
    dashed: {
      borderStyle: "dashed"
    }
  },
  defaultProps: {
    variant: "solid"
  }
};

const tooltip = {
  baseStyle: {
    fontWeight: "medium",
    fontSize: "sm",
    py: "sp8",
    px: "sp12",
    borderRadius: "xs",
    textOverflow: "ellipsis",
    maxWidth: "160px",
    margin: "2px",
    zIndex: 5000
  },
  variants: {
    dark: {
      bg: "neutrals.700",
      color: "text.white",
      boxShadow: `shadows.60`,
      alignItems: "center",
      ".chakra-tooltip__arrow": {
        bg: "var(--chakra-colors-neutrals-700) !important",
        boxShadow: "shadows.60"
      }
    },
    light: {
      bg: "neutrals.0",
      color: "text.title",
      boxShadow: "shadows.60",
      alignItems: `center`,
      ".chakra-tooltip__arrow": {
        bg: "var(--chakra-colors-neutrals-0) !important",
        boxShadow: "shadows.60"
      }
    }
  }
};

const components = {
  Button: button,
  Radio: radio,
  Checkbox: checkbox,
  Input: input,
  FormLabel: formLabel,
  FormError: formErrorText,
  Form: form$1,
  Link: link,
  PinInput: pinInput,
  Tag: tag,
  Alert: notification,
  Textarea: textArea,
  CloseButton: closeButton,
  Table: table,
  Modal: modal,
  Drawer: drawer,
  Menu: menu,
  Spinner: spinner,
  Breadcrumb: breadcrumb,
  Tabs: tabs,
  Divider: divider,
  Tooltip: tooltip
};

const radii = {
  none: "0",
  xxs: "2px",
  xs: "4px",
  sm: "6px",
  md: "8px",
  lg: "16px",
  xl: "50px",
  round: "50%"
};

const shadows = {
  10: "0px 1px 1px rgba(9, 30, 66, 0.25)",
  20: "0px 3px 5px rgba(9, 30, 66, 0.05)",
  30: "0px 8px 12px rgba(9, 30, 66, 0.03)",
  40: "0px 10px 18px rgba(9, 30, 66, 0.03)",
  50: "0px 18px 30px rgba(9, 30, 66, 0.03)",
  60: "0px 18px 30px rgba(9, 30, 67, 0.03)",
  outline: `0px 0px 0px 3px ${colors.brand[300]}`,
  dropdown: "0px 0px 1px rgba(9, 30, 67, 0.2), 0px 18px 28px rgba(9, 30, 67, 0.1)"
};

const theme = {
  ...theme$1,
  colors,
  fonts,
  fontSizes,
  fontWeights,
  space,
  components,
  shadows,
  radii,
  styles: {
    global: {
      "html, body": {
        bg: "white",
        fontSize: "14px"
      }
    }
  }
};

const StyledButton = /*#__PURE__*/styled(Button)`
  background-color: ${colors.neutrals[0]};
  border: 1px solid ${colors.neutrals[50]};
  border-radius: 6px;

  :hover {
    background-color: ${colors.neutrals[20]};
  }
  :focus {
    box-shadow: ${shadows.outline};
    border-color: ${colors.brand[400]};
  }
`;
const MenuButton = ({
  children,
  as = StyledButton,
  ...props
}) => /*#__PURE__*/React.createElement(MenuButton$1, Object.assign({
  _expanded: {
    borderColor: "brand.400",
    backgroundColor: "brand.100"
  },
  as: as
}, props), children);

const MenuItem = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(MenuItem$1, Object.assign({}, props), children);

const MenuList = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Box, {
  zIndex: "1"
}, /*#__PURE__*/React.createElement(MenuList$1, Object.assign({
  ref: ref
}, props), props.children)));

const MenuGroup = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(MenuGroup$1, Object.assign({}, props), children);

const MenuLink = ({
  children,
  href,
  ...props
}) => /*#__PURE__*/React.createElement(MenuItem, Object.assign({}, props), /*#__PURE__*/React.createElement(Link, {
  color: "text.paragraph.regular",
  _hover: {
    color: "text.paragraph.regular",
    textDecoration: "none"
  },
  href: href
}, children));

const StyledChakraButton = /*#__PURE__*/styled(IconButton$1)`
  padding: ${props => props.size === "default" ? "12px" : props.size === "sm" ? "10px" : "8px"};
  font-size: ${props => props.size === "default" ? "16px" : props.size === "sm" ? "12px" : "8px"};
`;
const IconButton = props => /*#__PURE__*/React.createElement(StyledChakraButton, Object.assign({
  isDisabled: props.disabled,
  type: "button"
}, props));

const DateDisplay = ({
  title,
  date = undefined,
  useUSDateFormat,
  focused
}) => {
  const dateDisplayFormat = useUSDateFormat ? "MMM DD, YYYY" : "DD MMM, YYYY";
  const text = date ? date.format(dateDisplayFormat) : "Select date";
  const color = date ? "text.title" : "neutrals.200";
  return /*#__PURE__*/React.createElement(Flex, {
    flexDir: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    fontFamily: "paragraphs",
    fontWeight: "500",
    fontSize: "12px",
    color: "text.title",
    mb: "sp8"
  }, title), /*#__PURE__*/React.createElement(Box, {
    px: "sp12",
    py: "sp8",
    boxShadow: focused ? "0px 0px 0px 1px #0075DB, 0px 0px 0px 4px #C9EDFF" : "",
    border: "1px solid",
    borderColor: "neutrals.50",
    borderRadius: "4px",
    height: "36px",
    width: "115px"
  }, /*#__PURE__*/React.createElement(Text, {
    color: color
  }, text)));
};

const CalendarItem = ({
  content = "",
  state = "default",
  onClick = () => {}
}) => {
  const backgroundColors = {
    start: "brand.400",
    end: "brand.400",
    startandend: "brand.400",
    between: "brand.200",
    today: "neutrals.0",
    outofrange: "neutrals.0",
    default: "neutrals.0"
  };
  const borderColors = {
    start: "brand.400",
    end: "brand.400",
    startandend: "brand.400",
    between: "brand.200",
    today: "brand.400",
    outofrange: "neutrals.0",
    default: "neutrals.0"
  };
  const borderRadius = {
    start: "4px",
    end: "4px",
    startandend: "4px",
    between: "0",
    today: "4px",
    outofrange: "0",
    default: "0"
  };
  const fontColor = {
    start: "neutrals.0",
    end: "neutrals.0",
    startandend: "neutrals.0",
    between: "text.title",
    today: "text.title",
    outofrange: "neutrals.40",
    default: "text.title"
  };
  const fontWeights = {
    start: "600",
    end: "600",
    startandend: "600",
    between: "400",
    today: "600",
    outofrange: "400",
    default: "400"
  };
  const displayedContent = typeof content === "string" ? /*#__PURE__*/React.createElement(Text, {
    fontSize: "12px",
    fontWeight: "500"
  }, content) : /*#__PURE__*/React.createElement(Box, {
    cursor: "pointer"
  }, /*#__PURE__*/React.createElement(Text, {
    fontFamily: "paragraphs",
    fontWeight: fontWeights[state]
  }, content.format("D")));
  return /*#__PURE__*/React.createElement(Flex, {
    w: "30px",
    h: "30px",
    alignItems: "center",
    justifyContent: "center",
    color: fontColor[state],
    border: "1px solid",
    borderColor: borderColors[state],
    bgColor: backgroundColors[state],
    borderRadius: borderRadius[state],
    onClick: () => onClick(content)
  }, displayedContent);
};

// Converts dayjs's currentMonth.day(), which ranges from 0 (Sunday) to 6 (Saturday)
// To a 0 (Monday) to 6 (Sunday) range
// Returns -1 if day is less than 0 or more than 6
const mondayBasedWeekDay = day => {
  if (day < 0 || day > 6) {
    return -1;
  }
  if (day === 0) {
    return 6;
  }
  return day - 1;
};
const calendarBody = ({
  currentMonth,
  calculateState,
  onCalendarItemClick
}) => {
  const firstWeekDayOfMonth = mondayBasedWeekDay(currentMonth.day());
  const numberOfDaysInMonth = currentMonth.daysInMonth();
  let result = [];
  let currentDayOfMonth = 1;
  while (currentDayOfMonth <= numberOfDaysInMonth) {
    let weekDays = [];
    for (let day = 0; day < 7; day++) {
      if (currentDayOfMonth === 1 && day !== firstWeekDayOfMonth || currentDayOfMonth > numberOfDaysInMonth) {
        weekDays.push( /*#__PURE__*/React.createElement(CalendarItem, null));
        continue;
      }
      const currentDate = dayjs(currentMonth).set("D", currentDayOfMonth);
      weekDays.push( /*#__PURE__*/React.createElement(CalendarItem, {
        state: calculateState(currentDate),
        content: currentDate,
        onClick: onCalendarItemClick
      }));
      currentDayOfMonth++;
    }
    result.push( /*#__PURE__*/React.createElement(Flex, {
      flexDir: "row"
    }, React.Children.toArray(weekDays)));
  }
  return React.Children.toArray(result);
};

const Input = /*#__PURE__*/React.forwardRef(({
  type = "text",
  placeholder,
  value,
  ...props
}, ref) => /*#__PURE__*/React.createElement(Input$2, Object.assign({
  ref: ref,
  type: type,
  value: value,
  placeholder: placeholder ? String(placeholder) : ""
}, props)));

const FormWrapper = ({
  isRequired,
  errorMessage,
  name,
  label,
  helperLinkText,
  helperLinkURL,
  helperText,
  isHelperLinkExternal,
  isDisabled,
  children
}) => /*#__PURE__*/React.createElement(FormControl, {
  isInvalid: !!errorMessage,
  isRequired: isRequired,
  isDisabled: isDisabled
}, /*#__PURE__*/React.createElement(FormLabel, {
  htmlFor: name,
  fontWeight: "medium"
}, label), /*#__PURE__*/React.createElement(FormHelperText, null, helperText, helperText && /*#__PURE__*/React.createElement(Link, {
  href: helperLinkURL,
  isExternal: isHelperLinkExternal
}, helperLinkText)), children, /*#__PURE__*/React.createElement(FormErrorMessage, {
  fontWeight: "regular"
}, errorMessage));

const TextInput = ({
  isRequired,
  errorMessage,
  name,
  label,
  helperLinkText,
  helperLinkURL,
  helperText,
  isHelperLinkExternal,
  isDisabled,
  ...props
}) => /*#__PURE__*/React.createElement(FormWrapper, {
  isRequired: isRequired,
  isDisabled: isDisabled,
  errorMessage: errorMessage,
  name: name,
  label: label,
  helperText: helperText,
  helperLinkText: helperLinkText,
  helperLinkURL: helperLinkURL,
  isHelperLinkExternal: isHelperLinkExternal
}, /*#__PURE__*/React.createElement(Input, Object.assign({
  isDisabled: isDisabled,
  isRequired: isRequired,
  name: name,
  "aria-label": label
}, props)));

const CalendarPicker = ({
  initialStartDate,
  initialEndDate,
  onSelect,
  useUSDateFormat,
  maxSpan,
  showTime = true
}) => {
  const [startDate, setStartDate] = useState(initialStartDate);
  const [endDate, setEndDate] = useState(initialEndDate);
  const [currentMonth, setCurrentMonth] = useState(dayjs().startOf("month"));
  // Takes a number 0-23, returns a string "1"-"12"
  const initialHour = hour => {
    if (hour === 0) {
      return "12";
    }
    return (hour % 12).toString();
  };
  // Takes a number 0-60, returns a string "00"-"60"
  const initialMinute = minute => {
    if (minute < 10) {
      return `0${minute}`;
    }
    return minute.toString();
  };
  const [currentHour, setCurrentHour] = useState(initialHour(initialStartDate.hour()));
  const [currentMinute, setCurrentMinute] = useState(initialMinute(initialStartDate.minute()));
  const [isTimeAm, setIsTimeAm] = useState(initialStartDate.hour() < 12);
  const [initialSelection, setInitialSelection] = useState(true);
  const canSelect = () => {
    return startDate && endDate && (startDate.isSame(endDate, "second") || startDate.isBefore(endDate, "second"));
  };
  const pickingEndTime = () => {
    return !initialSelection && startDate !== undefined && endDate !== undefined;
  };
  const onCalendarItemClick = date => {
    if (initialSelection || !startDate || date.isBefore(startDate, "day") || endDate) {
      if (initialSelection) {
        setInitialSelection(false);
        // Keep the existing time since it may have been edited before clicking
        setStartDate(dayjs(startDate).year(date.year()).month(date.month()).date(date.date()));
        setEndDate(undefined);
        return;
      }
      setStartDate(dayjs(date).startOf("day"));
      setEndDate(undefined);
      setCurrentHour("12");
      setCurrentMinute("00");
      setIsTimeAm(true);
      return;
    }
    const endOfSelectedDay = dayjs(date).endOf("day");
    if (maxSpan) {
      const endOfSpan = startDate.add(maxSpan.value, maxSpan.unit);
      if (endOfSelectedDay.isAfter(endOfSpan)) {
        setStartDate(dayjs(date).startOf("day"));
        setEndDate(undefined);
        setCurrentHour("12");
        setCurrentMinute("00");
        setIsTimeAm(true);
        return;
      }
    }
    setEndDate(endOfSelectedDay);
    setCurrentHour("11");
    setCurrentMinute("59");
    setIsTimeAm(false);
  };
  const calculateState = date => {
    if (startDate && date.isSame(startDate, "day") && endDate && date.isSame(endDate, "day")) {
      return "startandend";
    }
    if (startDate && date.isSame(startDate, "day")) {
      return "start";
    }
    if (endDate && date.isSame(endDate, "day")) {
      return "end";
    }
    if (startDate && endDate && date.isAfter(startDate, "day") && date.isBefore(endDate, "day")) {
      return "between";
    }
    if (maxSpan && startDate && !endDate) {
      if (date.isBefore(startDate, "day")) {
        return "outofrange";
      }
      if (startDate) {
        const lastDay = startDate.add(maxSpan.value, maxSpan.unit);
        const endOfSelectedDay = date.endOf("day");
        if (endOfSelectedDay.isSame(lastDay) || endOfSelectedDay.isAfter(lastDay)) {
          return "outofrange";
        }
      }
    }
    if (date.isSame(dayjs(), "day")) {
      return "today";
    }
    return "default";
  };
  const validateHour = e => {
    let hour = undefined;
    if (e.target.value === "") {
      setCurrentHour("");
      hour = 0;
    } else {
      let newHour = parseInt(e.target.value);
      if (!isNaN(newHour) && newHour >= 1 && newHour <= 12) {
        hour = newHour;
        setCurrentHour(newHour.toString());
      }
    }
    if (hour && hour === 12 && isTimeAm) {
      hour = 0;
    } else if (hour && hour !== 12 && !isTimeAm) {
      hour += 12;
    }
    updateStoredTime(hour);
  };
  const validateMinute = e => {
    let minute = undefined;
    if (e.target.value === "") {
      setCurrentMinute("");
      minute = 0;
    } else {
      let newMinute = parseInt(e.target.value);
      if (!isNaN(newMinute) && newMinute >= 0 && newMinute <= 59) {
        minute = newMinute;
        let stringMinute = newMinute.toString();
        if (stringMinute.length === 1) {
          stringMinute = `0${stringMinute}`;
        }
        setCurrentMinute(stringMinute);
      }
    }
    updateStoredTime(undefined, minute);
  };
  const getHourIfDefined = fallback => {
    if (pickingEndTime()) {
      if (endDate) {
        return endDate.hour();
      }
    } else if (startDate) {
      return startDate.hour();
    }
    return fallback;
  };
  const setTimeAm = () => {
    if (!isTimeAm) {
      setIsTimeAm(true);
      let hour = getHourIfDefined(12);
      updateStoredTime(hour - 12);
    }
  };
  const setTimePm = () => {
    if (isTimeAm) {
      setIsTimeAm(false);
      let hour = getHourIfDefined(0);
      updateStoredTime(hour + 12);
    }
  };
  const updateStoredTime = (hour, minute) => {
    let currentDate = pickingEndTime() ? dayjs(endDate) : dayjs(startDate);
    if (hour !== undefined) {
      currentDate = dayjs(currentDate).hour(hour);
    }
    if (minute !== undefined) {
      currentDate = dayjs(currentDate).minute(minute);
    }
    if (pickingEndTime()) {
      setEndDate(currentDate);
    } else {
      setStartDate(currentDate);
    }
  };
  const onReset = () => {
    setStartDate(initialStartDate);
    setEndDate(initialEndDate);
  };
  const showErrorMessage = () => startDate && endDate && startDate.isAfter(endDate);
  const timeErrorMessage = () => showErrorMessage() ? " " : "";
  return /*#__PURE__*/React.createElement(Flex, {
    flexDir: "column",
    borderRadius: "6px",
    w: "274px",
    boxShadow: "0px 20px 90px rgba(5, 24, 57, 0.2)",
    bgColor: "neutrals.0"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDir: "column",
    pt: "sp16"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDir: "row",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    mr: "sp12"
  }, /*#__PURE__*/React.createElement(DateDisplay, {
    title: "Start Date",
    date: initialSelection ? undefined : startDate,
    useUSDateFormat: useUSDateFormat,
    focused: !pickingEndTime()
  })), /*#__PURE__*/React.createElement(DateDisplay, {
    title: "End Date",
    date: endDate,
    useUSDateFormat: useUSDateFormat,
    focused: pickingEndTime()
  })), /*#__PURE__*/React.createElement(Flex, {
    mt: "sp16",
    flexDir: "row",
    alignItems: "center",
    justifyContent: "space-between",
    bgColor: "neutrals.10",
    w: "210px",
    mx: "auto",
    borderRadius: "6px"
  }, /*#__PURE__*/React.createElement(IconButton, {
    variant: "ghost",
    size: "default",
    "aria-label": "Left Arrow",
    icon: /*#__PURE__*/React.createElement(Icon, {
      icon: "fa-angle-left"
    }),
    onClick: () => {
      setCurrentMonth(dayjs(currentMonth).subtract(1, "month"));
    }
  }), /*#__PURE__*/React.createElement(Text, {
    fontFamily: "paragraphs",
    fontSize: "14px",
    color: "text.title",
    fontWeight: "500"
  }, currentMonth.format("MMMM YYYY")), /*#__PURE__*/React.createElement(IconButton, {
    size: "default",
    variant: "ghost",
    "aria-label": "Right Arrow",
    icon: /*#__PURE__*/React.createElement(Icon, {
      icon: "fa-angle-right"
    }),
    onClick: () => {
      setCurrentMonth(dayjs(currentMonth).add(1, "month"));
    }
  })), /*#__PURE__*/React.createElement(Flex, {
    flexDir: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDir: "row"
  }, /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Mo"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Tu"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "We"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Th"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Fr"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Sa"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Su"
  })), calendarBody({
    currentMonth,
    calculateState,
    onCalendarItemClick
  }), showTime && /*#__PURE__*/React.createElement(Flex, {
    flexDir: "row",
    mt: "sp24",
    justifyContent: "start",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    w: "62px",
    mr: "sp4"
  }, /*#__PURE__*/React.createElement(Text, {
    fontFamily: "paragraphs",
    fontSize: "12px",
    fontWeight: "500",
    color: "text.title",
    mb: "sp8"
  }, pickingEndTime() ? "End Time" : "Start Time"), /*#__PURE__*/React.createElement(Box, {
    h: "33px"
  }, /*#__PURE__*/React.createElement(TextInput, {
    placeholder: "HH",
    value: currentHour,
    onChange: validateHour,
    errorMessage: timeErrorMessage()
  }))), /*#__PURE__*/React.createElement(Text, {
    mt: "sp32"
  }, ":"), /*#__PURE__*/React.createElement(Box, {
    w: "62px",
    h: "32px",
    ml: "sp4",
    mt: "sp24",
    mr: "sp12"
  }, /*#__PURE__*/React.createElement(TextInput, {
    placeholder: "MM",
    value: currentMinute,
    onChange: validateMinute,
    errorMessage: timeErrorMessage()
  })), /*#__PURE__*/React.createElement(Box, {
    mt: "sp24",
    h: "32px"
  }, /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(MenuButton, null, isTimeAm ? "AM" : "PM"), /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => setTimeAm()
  }, "AM"), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => setTimePm()
  }, "PM"))))), /*#__PURE__*/React.createElement(Flex, {
    h: "16px",
    w: "202px",
    mt: "sp16",
    mb: "sp12",
    justifyContent: "left"
  }, showErrorMessage() && /*#__PURE__*/React.createElement(Text, {
    fontFamily: "paragraphs",
    color: "error.plainText",
    fontSize: "sm"
  }, "End time must be after start time"))), /*#__PURE__*/React.createElement(Flex, {
    borderRadius: "0px 0px 4px 4px",
    m: "sp4",
    px: "sp16",
    py: "sp12",
    flexDir: "row",
    bgColor: "neutrals.20"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "sm",
    isDisabled: !canSelect(),
    onClick: () => {
      onSelect(startDate, endDate);
    }
  }, "Select"), /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    size: "sm",
    onClick: onReset
  }, "Reset"))));
};

/**
 * Hook that hits a callback on clicks outside of the passed refs
 */
function useOutsideDetector(refs, onClickOutside) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of all elements
     */
    function handleClickOutside(event) {
      let inside = false;
      refs.forEach(ref => {
        if (!inside && ref && ref.contains(event.target)) {
          inside = true;
        }
      });
      if (!inside) {
        onClickOutside();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [refs]);
}

const SingleDatePicker = ({
  initialStartDate,
  onSelect
}) => {
  const [currentMonth, setCurrentMonth] = useState(dayjs().startOf("month"));
  const onCalendarItemClick = date => {
    const start = dayjs(date).startOf("day");
    const end = start;
    onSelect(start, end);
  };
  const calculateState = date => {
    if (date.isSame(initialStartDate, "day")) {
      return "startandend";
    }
    if (date.isSame(dayjs(), "day")) {
      return "today";
    }
    return "default";
  };
  return /*#__PURE__*/React.createElement(Flex, {
    flexDir: "column",
    borderRadius: "6px",
    w: "274px",
    boxShadow: "0px 20px 90px rgba(5, 24, 57, 0.2)",
    bgColor: "neutrals.0"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDir: "column",
    pt: "sp16"
  }, /*#__PURE__*/React.createElement(Flex, {
    mt: "sp16",
    flexDir: "row",
    alignItems: "center",
    justifyContent: "space-between",
    bgColor: "neutrals.10",
    w: "210px",
    mx: "auto",
    borderRadius: "6px"
  }, /*#__PURE__*/React.createElement(IconButton, {
    variant: "ghost",
    size: "default",
    "aria-label": "Left Arrow",
    icon: /*#__PURE__*/React.createElement(Icon, {
      icon: "fa-angle-left"
    }),
    onClick: () => {
      setCurrentMonth(dayjs(currentMonth).subtract(1, "month"));
    }
  }), /*#__PURE__*/React.createElement(Text, {
    fontFamily: "paragraphs",
    fontSize: "14px",
    color: "text.title",
    fontWeight: "500"
  }, currentMonth.format("MMMM YYYY")), /*#__PURE__*/React.createElement(IconButton, {
    size: "default",
    variant: "ghost",
    "aria-label": "Right Arrow",
    icon: /*#__PURE__*/React.createElement(Icon, {
      icon: "fa-angle-right"
    }),
    onClick: () => {
      setCurrentMonth(dayjs(currentMonth).add(1, "month"));
    }
  })), /*#__PURE__*/React.createElement(Flex, {
    flexDir: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDir: "row"
  }, /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Mo"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Tu"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "We"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Th"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Fr"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Sa"
  }), /*#__PURE__*/React.createElement(CalendarItem, {
    content: "Su"
  })), calendarBody({
    currentMonth,
    calculateState,
    onCalendarItemClick
  })), /*#__PURE__*/React.createElement(Flex, {
    borderRadius: "0px 0px 4px 4px",
    m: "sp4",
    px: "sp16",
    py: "sp12",
    flexDir: "row",
    bgColor: "neutrals.0"
  })));
};

dayjs.extend(isYesterday);
dayjs.extend(isToday);
const DateTimePicker = ({
  onDateChange,
  useUSDateFormat,
  singleDate = false,
  initialStart = dayjs().startOf("day"),
  initialEnd = dayjs().endOf("day"),
  direction = "left",
  customRanges = ["today", "yesterday", "last7Days", "last30Days", "thisMonth", "lastMonth"],
  maxSpan,
  horizontalOffSet = 0,
  display = "date",
  showTime = true,
  earliestDate = dayjs().set("year", 1900).set("month", 0).set("date", 1),
  placement = "bottom"
}) => {
  const {
    t
  } = useTranslation();
  const [start, setStart] = useState(customRanges.includes("allTime") ? earliestDate : initialStart);
  const [end, setEnd] = useState(initialEnd);
  const [showMenu, setShowMenu] = useState(false);
  const [showCalendarPicker, setShowCalendarPicker] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const onSelect = (start, end) => {
    const externalDateFormat = "YYYY-MM-DD HH:mm:ss";
    setStart(start);
    setEnd(end);
    onDateChange(start.format(externalDateFormat), end.format(externalDateFormat));
    hide();
  };
  const hide = () => {
    setShowMenu(false);
    setShowCalendarPicker(false);
    setShowDatePicker(false);
  };
  const ranges = [{
    icon: "fa-solid fa-calendar-check",
    title: t("Today"),
    start: dayjs().startOf("day"),
    end: dayjs().endOf("day")
  }, {
    icon: "fa-solid fa-calendar-day",
    title: t("Yesterday"),
    start: dayjs().subtract(1, "days").startOf("day"),
    end: dayjs().subtract(1, "days").endOf("day")
  }, {
    icon: "fa-solid fa-calendar-week",
    title: t("Last 7 Days"),
    start: dayjs().subtract(6, "days").startOf("day"),
    end: dayjs().endOf("day")
  }, {
    icon: "fa-solid fa-calendar-days",
    title: t("Last 30 Days"),
    start: dayjs().subtract(29, "days").startOf("day"),
    end: dayjs().endOf("day")
  }, {
    icon: "fa-solid fa-calendar-lines",
    title: t("This Month"),
    start: dayjs().startOf("month").startOf("day"),
    end: dayjs().endOf("month")
  }, {
    icon: "fa-solid fa-calendar-arrow-up",
    title: t("Last Month"),
    start: dayjs().subtract(1, "month").startOf("month"),
    end: dayjs().subtract(1, "month").endOf("month")
  }, {
    icon: "fa-solid fa-clock",
    title: t("Last 1 Hour"),
    start: dayjs().subtract(1, "hour"),
    end: dayjs()
  }, {
    icon: "fa-solid fa-clock",
    title: t("Last 2 Hours"),
    start: dayjs().subtract(2, "hours"),
    end: dayjs()
  }, {
    icon: "fa-solid fa-clock",
    title: t("Last 6 Hours"),
    start: dayjs().subtract(6, "hours"),
    end: dayjs()
  }, {
    icon: "fa-solid fa-clock",
    title: t("Last 12 Hours"),
    start: dayjs().subtract(12, "hours"),
    end: dayjs()
  }, {
    icon: "fa-solid fa-clock",
    title: t("Last 24 Hours"),
    start: dayjs().subtract(24, "hours"),
    end: dayjs()
  }, {
    icon: "fa-solid fa-calendar-check",
    title: t("All Time"),
    start: earliestDate,
    end: dayjs().endOf("day")
  }, {
    icon: "fa-solid fa-calendar-check",
    title: t("Last Year to Date"),
    start: dayjs().subtract(364, "days").startOf("day"),
    end: dayjs().endOf("day")
  }];
  const getDisplayString = () => {
    const timeFormat = "h:mm A";
    const dateTimeFormat = "MMM DD, h:mm A";
    const dateFormat = "MMM DD, YYYY";
    if (display === "time") {
      if (start.isToday() && end.isToday()) {
        return `${start.format(timeFormat)} ${t("to")} ${end.format(timeFormat)}`;
      }
      if (start.isYesterday() && end.isToday()) {
        return `${t("Yesterday")} ${start.format(timeFormat)} ${t("to")} ${t("Today")} ${end.format(timeFormat)}`;
      }
      if (start.isYesterday() && end.isYesterday()) {
        return `${t("Yesterday")} ${start.format(timeFormat)} ${t("to")} ${end.format(timeFormat)}`;
      }
      if (start.isSame(end, "date")) {
        return `${start.format(dateTimeFormat)} ${t("to")} ${end.format(timeFormat)}`;
      }
      return `${start.format(dateTimeFormat)} ${t("to")} ${end.format(dateTimeFormat)}`;
    }
    if (datesMatchRange(0)) {
      return `${t("Today")}, ${start.format(dateFormat)}`;
    }
    if (datesMatchRange(1)) {
      return `${t("Yesterday")}, ${start.format(dateFormat)}`;
    }
    if (start.isSame(end)) {
      return `${start.format(dateFormat)}`;
    }
    if (start.isSame(earliestDate, "day")) {
      return `All Time`;
    }
    return `${start.format(dateFormat)} ${t("to")} ${end.format(dateFormat)}`;
  };
  const toggleCalendarPicker = () => setShowCalendarPicker(!showCalendarPicker);
  const datesMatchRange = rangeIndex => {
    return ranges[rangeIndex].start.isSame(start) && ranges[rangeIndex].end.isSame(end);
  };
  const datesAreCustom = () => {
    for (let i = 0; i < ranges.length; i++) {
      if (datesMatchRange(i)) {
        return false;
      }
    }
    return true;
  };
  const getMenuItem = rangeIndex => {
    const r = ranges[rangeIndex];
    return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(MenuItem, {
      bgColor: !showCalendarPicker && datesMatchRange(rangeIndex) ? "brand.200" : "",
      icon: /*#__PURE__*/React.createElement(Icon, {
        color: "neutrals.500",
        icon: r.icon
      }),
      onClick: () => {
        onSelect(r.start, r.end);
      }
    }, r.title));
  };
  const showMenuOptions = () => {
    if (!singleDate) {
      if (shouldSkipMenu) {
        toggleCalendarPicker();
      } else {
        setShowMenu(!showMenu);
        setShowCalendarPicker(false);
      }
    } else {
      setShowDatePicker(!showDatePicker);
    }
  };
  // Popup refs & settings
  const [menuRef, setMenuRef] = useState(null);
  const [menuListRef, setMenuListRef] = useState(null);
  const [calendarRef, setCalendarRef] = useState(null);
  const [menuButtonRef, setMenuButtonRef] = useState(null);
  // If it's a single date or there's no custom ranges set, then we should skip
  // the menu and display the picker relative to the button; otherwise, we should 
  // display it relative to the menu
  const shouldSkipMenu = singleDate || customRanges.length === 0;
  const [offsetX, offsetY] = [horizontalOffSet, shouldSkipMenu ? 12 : 0];
  const {
    styles,
    attributes
  } = usePopper(shouldSkipMenu ? menuButtonRef : menuListRef, calendarRef, {
    placement: shouldSkipMenu ? placement : `${direction}-start`,
    modifiers: [{
      name: "offset",
      options: {
        // For some reason, x and y are inverted when using the calendar picker with menu
        offset: shouldSkipMenu ? [offsetX, offsetY] : [offsetY, offsetX]
      }
    }]
  });
  const refs = [menuRef, calendarRef, menuButtonRef];
  useOutsideDetector(refs, hide);
  return /*#__PURE__*/React.createElement(Menu, {
    isOpen: showMenu,
    placement: placement
  }, /*#__PURE__*/React.createElement(Box, {
    ref: setMenuButtonRef
  }, /*#__PURE__*/React.createElement(MenuButton, {
    onClick: showMenuOptions
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Icon, {
    icon: `fa-solid ${display === "time" ? "fa-clock" : "fa-calendar-days"}`,
    color: "neutrals.200",
    mr: "sp8"
  }), /*#__PURE__*/React.createElement(Text, {
    fontWeight: "400",
    "data-testid": "displayedDate"
  }, getDisplayString()))), showCalendarPicker && /*#__PURE__*/React.createElement(Box, Object.assign({
    zIndex: 1,
    ref: setCalendarRef,
    style: styles.popper
  }, attributes.popper), /*#__PURE__*/React.createElement(CalendarPicker, {
    initialStartDate: start,
    initialEndDate: end,
    useUSDateFormat: useUSDateFormat,
    onSelect: onSelect,
    maxSpan: maxSpan,
    showTime: showTime
  })), showDatePicker && /*#__PURE__*/React.createElement(Box, Object.assign({
    ref: setCalendarRef,
    style: styles.popper
  }, attributes.popper), /*#__PURE__*/React.createElement(SingleDatePicker, {
    initialStartDate: start,
    useUSDateFormat: useUSDateFormat,
    onSelect: onSelect
  }))), !singleDate && /*#__PURE__*/React.createElement(Box, {
    ref: setMenuRef
  }, /*#__PURE__*/React.createElement(MenuList, {
    ref: setMenuListRef,
    p: "sp8"
  }, customRanges.includes("allTime") && getMenuItem(11), customRanges.includes("last1hour") && getMenuItem(6), customRanges.includes("last2Hours") && getMenuItem(7), customRanges.includes("last6Hours") && getMenuItem(8), customRanges.includes("last12Hours") && getMenuItem(9), customRanges.includes("last24Hours") && getMenuItem(10), customRanges.includes("today") && getMenuItem(0), customRanges.includes("yesterday") && getMenuItem(1), (customRanges.includes("today") || customRanges.includes("yesterday")) && /*#__PURE__*/React.createElement(Box, {
    my: "sp8",
    borderTop: "1px solid",
    borderColor: "neutrals.30"
  }), customRanges.includes("last7Days") && getMenuItem(2), customRanges.includes("last30Days") && getMenuItem(3), customRanges.includes("thisMonth") && getMenuItem(4), customRanges.includes("lastMonth") && getMenuItem(5), /*#__PURE__*/React.createElement(Box, {
    my: "sp8",
    borderTop: "1px solid",
    borderColor: "neutrals.30"
  }), customRanges.includes("lastYear") && getMenuItem(12), customRanges.includes("lastYear") && /*#__PURE__*/React.createElement(Box, {
    my: "sp8",
    borderTop: "1px solid",
    borderColor: "neutrals.30"
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(MenuItem, {
    bgColor: showCalendarPicker || datesAreCustom() ? "brand.200" : "",
    icon: /*#__PURE__*/React.createElement(Icon, {
      icon: `fa-solid ${display === "time" ? "fa-clock" : "fa-calendar-range"}`
    }),
    onClick: toggleCalendarPicker
  }, "Custom Range")))));
};

const TimePicker = ({
  initialStartMinute = dayjs().minute(),
  initialStartHour = dayjs().hour(),
  onSelect
}) => {
  const [currentHour, setCurrentHour] = useState(initialStartHour <= 12 ? initialStartHour : initialStartHour % 12);
  const [currentMinute, setCurrentMinute] = useState(initialStartMinute);
  const [isTimeAm, setIsTimeAm] = useState(initialStartHour < 12);
  const setTime = (hour, minute, isAm) => {
    const time = new Date();
    time.setHours(isAm ? hour : hour + 12);
    time.setMinutes(minute);
    return time;
  };
  const validateHour = e => {
    let hour = parseInt(e.target.value);
    if (isNaN(hour) || hour < 0 || hour > 12) return;
    if (hour === 12 && isTimeAm) {
      hour = 0;
    } else if (hour === 0 && !isTimeAm) {
      hour = 12;
    }
    setCurrentHour(hour);
    onSelect(setTime(hour, currentMinute, isTimeAm));
  };
  const validateMinute = e => {
    let minute = 0;
    if (e.target.value === "") {
      setCurrentMinute(0);
      minute = 0;
      onSelect(setTime(currentHour, minute, isTimeAm));
    } else {
      let newMinute = parseInt(e.target.value);
      if (!isNaN(newMinute) && newMinute >= 0 && newMinute <= 59) {
        minute = newMinute;
        setCurrentMinute(newMinute);
        onSelect(setTime(currentHour, minute, isTimeAm));
      }
    }
  };
  const setMeridiem = ampm => {
    setIsTimeAm(ampm);
    onSelect(setTime(currentHour, currentMinute, ampm));
  };
  return /*#__PURE__*/React.createElement(Flex, {
    flexDir: "row",
    justifyContent: "start",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    w: "48px",
    mr: "sp4"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Input, {
    value: currentHour.toString(),
    onChange: validateHour,
    textAlign: "right"
  }))), /*#__PURE__*/React.createElement(Text, null, ":"), /*#__PURE__*/React.createElement(Box, {
    w: "48px",
    ml: "sp4",
    mr: "sp12"
  }, /*#__PURE__*/React.createElement(Input, {
    value: currentMinute.toString().padStart(2, "0"),
    onChange: validateMinute,
    textAlign: "right"
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(MenuButton, null, isTimeAm ? "AM" : "PM"), /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => setMeridiem(true)
  }, "AM"), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => setMeridiem(false)
  }, "PM")))));
};

const FamilyZoneLogo = ({
  width = "105px",
  height = "64px",
  ...props
}) => /*#__PURE__*/React.createElement(Icon$1, Object.assign({
  width: width,
  height: height,
  viewBox: "0 0 105 64"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M69.063 39.29c0 9.124-7.396 16.52-16.52 16.52-9.125 0-16.52-7.396-16.52-16.52 0-9.125 7.395-16.52 16.52-16.52 9.124 0 16.52 7.395 16.52 16.52ZM56.908 61.288c0 1.13-2.003 2.055-4.451 2.055-2.465 0-4.451-.925-4.451-2.055 0-1.13 1.986-2.054 4.451-2.054 2.448 0 4.451.924 4.451 2.054Zm-14.483-.856c.068 1.096-1.832 2.089-4.246 2.226-2.397.137-4.4-.633-4.468-1.712-.069-1.096 1.832-2.089 4.246-2.226 2.396-.137 4.4.634 4.468 1.712Zm-12.943-2.105c.103.993-1.746 2.003-4.142 2.26-2.397.273-4.434-.309-4.537-1.302-.103-.993 1.746-2.003 4.143-2.26 2.396-.273 4.434.309 4.536 1.302ZM19.28 55.45c.12.84-1.678 1.798-4.023 2.14-2.328.343-4.331-.068-4.451-.907-.12-.839 1.678-1.797 4.023-2.14 2.328-.342 4.331.069 4.451.907Zm74.899 1.233c-.12.839-2.123 1.25-4.451.907-2.346-.342-4.144-1.3-4.024-2.14.12-.838 2.123-1.25 4.451-.907 2.346.343 4.143 1.301 4.024 2.14Zm6.676-3.201c-.102.702-1.969 1.01-4.16.685-2.208-.309-3.903-1.148-3.8-1.85.102-.701 1.968-1.01 4.16-.684 2.208.308 3.903 1.147 3.8 1.849Zm-88.765-1.164c.103.702-1.592 1.54-3.8 1.849-2.192.325-4.058.017-4.16-.685-.103-.702 1.591-1.541 3.8-1.85 2.191-.324 4.057-.016 4.16.686Zm-4.006-3.356c.068.616-1.524 1.335-3.595 1.61-2.055.29-3.784.034-3.87-.583-.085-.616 1.507-1.335 3.579-1.609 2.054-.29 3.8-.034 3.886.582Zm96.212 1.027c-.085.617-1.832.873-3.886.582-2.071-.273-3.663-.992-3.578-1.609.086-.616 1.815-.873 3.869-.582 2.072.274 3.664.993 3.595 1.61Zm.685-3.338c-.068.514-1.643.736-3.509.514-1.884-.24-3.356-.856-3.287-1.37.068-.514 1.643-.736 3.509-.514 1.883.24 3.356.856 3.287 1.37Zm-98.181-.856c.068.514-1.404 1.13-3.287 1.37-1.866.222-3.441 0-3.51-.514-.068-.514 1.404-1.13 3.287-1.37 1.866-.222 3.441 0 3.51.514Zm.941-2.893c-.017.445-1.42.941-3.15 1.13-1.729.188-3.115-.017-3.098-.462 0-.446 1.42-.942 3.133-1.13 1.729-.189 3.115.017 3.115.462Zm89.485 0c0 .445 1.404.941 3.133 1.13 1.729.188 3.116-.017 3.116-.462-.018-.446-1.421-.942-3.15-1.13-1.73-.189-3.116.017-3.1.462Zm-2.602-2.568c0 .377 1.284.804 2.859.959 1.575.154 2.842-.017 2.842-.394-.018-.377-1.302-.805-2.877-.959-1.575-.171-2.841.017-2.824.394Zm-84.28 0c-.017.377-1.301.804-2.876.959-1.575.154-2.842-.017-2.825-.394 0-.377 1.284-.805 2.859-.959 1.575-.171 2.842.017 2.842.394ZM84.18 59.285c-.103.993-2.14 1.575-4.537 1.301-2.397-.256-4.246-1.266-4.143-2.26.103-.992 2.14-1.574 4.537-1.3 2.396.256 4.245 1.266 4.143 2.26Zm-12.909 1.66c-.068 1.08-2.071 1.85-4.468 1.713-2.414-.137-4.314-1.13-4.245-2.226.068-1.078 2.071-1.849 4.468-1.712 2.414.137 4.314 1.13 4.246 2.226Zm-7.857-50.074c0 6.009-4.88 10.87-10.871 10.87a10.864 10.864 0 0 1-10.871-10.87A10.864 10.864 0 0 1 52.542 0c5.992 0 10.872 4.862 10.872 10.871ZM94.657 32.87c0 5.478-4.485 9.93-10.015 9.93-5.547 0-10.015-4.452-10.015-9.93 0-5.479 4.468-9.93 10.015-9.93 5.53 0 10.015 4.451 10.015 9.93Zm-3.51-17.12c0 3.595-2.927 6.506-6.505 6.506a6.502 6.502 0 0 1-6.505-6.506 6.503 6.503 0 0 1 6.505-6.505c3.578 0 6.505 2.91 6.505 6.505ZM30.458 32.87c0 5.478-4.485 9.93-10.015 9.93-5.547 0-10.015-4.452-10.015-9.93 0-5.479 4.468-9.93 10.015-9.93 5.53 0 10.015 4.451 10.015 9.93Zm-3.51-17.12c0 3.595-2.927 6.506-6.505 6.506a6.503 6.503 0 0 1-6.505-6.506 6.503 6.503 0 0 1 6.505-6.505c3.578 0 6.506 2.91 6.506 6.505ZM9.505 38.16c-.36.137-.565.29-.565.428 0 .205.394.342 1.027.393-.188-.29-.36-.599-.462-.821Zm85.957 0c.343.137.548.29.548.428.017.205-.393.342-1.01.393.172-.29.343-.599.463-.821Zm-24.258-5.684c-.48 0-.942.017-1.318.068.085.223.171.463.257.702.325.017.684.035 1.061.035.496 0 .959-.017 1.335-.069 0-.222 0-.445.017-.668a14.809 14.809 0 0 0-1.352-.068Zm-37.338 0c.496 0 .959.017 1.335.068-.085.223-.17.463-.256.702a20 20 0 0 1-1.079.035c-.48 0-.942-.017-1.318-.069 0-.222 0-.445-.017-.668.376-.034.839-.068 1.335-.068Z",
  fill: "currentColor"
}));

const FamilyZoneLogoWithText = ({
  width = "382px",
  height = "65px",
  ...props
}) => /*#__PURE__*/React.createElement(Icon$1, Object.assign({
  width: width,
  height: height,
  viewBox: "0 0 382 65"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M135.958 12.172c0 .839-.257 1.524-.77 2.054-.514.531-1.233.805-2.192.805-.428 0-.787-.069-1.061-.205-.274-.12-.668-.189-1.181-.189-.48 0-.873.12-1.182.36-.308.24-.565.548-.736.924a4.404 4.404 0 0 0-.394 1.267c-.068.462-.102.89-.102 1.284 0 .873.102 1.712.359 2.5.24.787.531 1.472.908 2.054h4.536c.771 0 1.164.377 1.164 1.147v2.089c0 .753-.393 1.146-1.164 1.146h-4.16v22.838c0 .77-.359 1.147-1.095 1.147h-5.804c-.77 0-1.147-.377-1.147-1.147V27.408h-2.791c-.77 0-1.164-.393-1.164-1.146v-2.09c0-.77.394-1.146 1.164-1.146h2.791c0-2.86.325-5.187.959-6.985.65-1.815 1.472-3.236 2.465-4.28.993-1.044 2.071-1.763 3.253-2.157 1.164-.41 2.294-.6 3.338-.6 1.438 0 2.448.326 3.082.977.616.667.924 1.386.924 2.191Zm16.538 24.978c-1.062.222-2.072.479-3.065.753-.976.274-1.866.65-2.619 1.147-.771.496-1.387 1.096-1.849 1.797-.445.72-.685 1.627-.685 2.722 0 1.233.411 2.277 1.216 3.1.804.82 1.951 1.232 3.441 1.232.924 0 1.746-.206 2.465-.582.736-.377 1.096-1.079 1.096-2.106V37.15Zm7.738 8.714c0 1.18-.154 2.088-.445 2.739-.291.667-.856 1.25-1.695 1.763-.326.205-.822.428-1.455.65-.634.223-1.37.411-2.158.583-.804.154-1.677.29-2.585.376-.907.086-1.831.137-2.739.137-1.609 0-3.15-.137-4.656-.41-1.49-.275-2.825-.72-3.989-1.319-1.181-.6-2.123-1.404-2.825-2.414-.719-.993-1.078-2.225-1.078-3.698 0-1.849.513-3.39 1.54-4.622a11.64 11.64 0 0 1 3.869-2.979c1.541-.77 3.253-1.37 5.119-1.78a145.43 145.43 0 0 1 5.359-1.13v-3.612c0-1.165-.309-2.089-.959-2.74-.634-.667-1.438-.992-2.431-.992-.616 0-1.164.12-1.644.325-.479.222-.89.513-1.232.89a6.21 6.21 0 0 0-.873 1.164 6.22 6.22 0 0 0-.531 1.233c-.205.702-.651 1.267-1.284 1.678-.633.427-1.387.633-2.277.633-.941 0-1.763-.274-2.431-.805-.685-.513-1.01-1.3-1.01-2.328 0-.65.223-1.387.685-2.191.445-.788 1.181-1.541 2.157-2.243.993-.685 2.26-1.267 3.835-1.746 1.575-.48 3.475-.72 5.701-.72 1.386 0 2.687.172 3.92.532 1.215.342 2.277.873 3.167 1.575.907.719 1.609 1.609 2.14 2.687.531 1.079.805 2.346.805 3.818v14.946Zm45.024 4.382c0 .77-.359 1.147-1.095 1.147h-5.804c-.77 0-1.147-.377-1.147-1.147V31.038c0-1.438-.342-2.534-1.027-3.321-.668-.788-1.695-1.182-3.082-1.182-1.438 0-2.448.394-3.047 1.199-.599.804-.907 1.883-.907 3.235v19.277c0 .77-.377 1.147-1.147 1.147h-5.752c-.771 0-1.148-.377-1.148-1.147V31.038c0-1.438-.342-2.534-1.01-3.321-.667-.788-1.694-1.182-3.081-1.182-1.335 0-2.328.274-2.962.822-.633.548-.941 1.421-.941 2.637v20.252c0 .77-.394 1.147-1.165 1.147h-5.786c-.736 0-1.113-.377-1.113-1.147V27.46c0-1.027.171-1.764.497-2.226.325-.445.907-.873 1.763-1.284.942-.428 2.243-.821 3.886-1.147 1.644-.325 3.441-.496 5.376-.496 2.225 0 4.04.29 5.427.856 1.404.565 2.568 1.318 3.509 2.277.993-.959 2.277-1.712 3.869-2.277 1.592-.565 3.578-.856 5.958-.856 1.13 0 2.294.154 3.475.445 1.199.291 2.26.77 3.219 1.455a7.95 7.95 0 0 1 2.328 2.602c.599 1.062.907 2.346.907 3.886v19.551Zm12.977 0c0 .77-.377 1.147-1.147 1.147h-5.804c-.736 0-1.095-.377-1.095-1.147V24.173c0-.77.359-1.147 1.095-1.147h5.804c.77 0 1.147.377 1.147 1.147v26.073Zm.394-34.565c0 .96-.411 1.764-1.216 2.432-.804.684-1.883 1.027-3.218 1.027-1.353 0-2.431-.343-3.219-1.027-.77-.668-1.164-1.473-1.164-2.431 0-.942.394-1.747 1.164-2.414.788-.65 1.866-.976 3.219-.976 1.335 0 2.414.325 3.218.976.805.667 1.216 1.472 1.216 2.413Zm12.874 34.565c0 .77-.394 1.147-1.147 1.147h-5.821c-.719 0-1.096-.377-1.096-1.147V10.648c0-.77.377-1.164 1.096-1.164h5.821c.753 0 1.147.394 1.147 1.164v39.598Zm29.685-26.073c0 .154-.017.29-.051.445a2.355 2.355 0 0 1-.171.48l-10.409 30.13a24.234 24.234 0 0 1-1.661 3.766 13.034 13.034 0 0 1-2.311 3.013 9.398 9.398 0 0 1-3.116 1.986c-1.181.48-2.568.72-4.143.72-2.071 0-3.578-.377-4.485-1.13-.907-.737-1.37-1.695-1.37-2.877 0-.976.292-1.729.908-2.26.599-.53 1.318-.804 2.157-.804.479 0 .873.051 1.215.137.326.102.617.205.891.325.274.137.547.24.821.342.274.086.582.137.908.137.445 0 .839-.102 1.181-.308.342-.205.651-.462.924-.787.274-.343.531-.702.754-1.096.205-.41.376-.788.479-1.164l.822-2.346-10.238-27.785c-.068-.17-.137-.342-.171-.479a1.987 1.987 0 0 1-.051-.445c0-.77.393-1.147 1.147-1.147h5.974c.737 0 1.182.342 1.37 1.044l4.605 14.894c.223.736.394 1.455.548 2.157.137.72.257 1.37.325 1.952.12.65.189 1.318.223 1.969h.103c.034-.65.137-1.319.273-1.969.12-.582.24-1.233.394-1.952.137-.702.326-1.42.548-2.157l4.314-14.894c.189-.702.668-1.044 1.438-1.044h4.708c.771 0 1.147.377 1.147 1.147Zm34.633 26.073c0 .77-.411 1.147-1.215 1.147h-18.353c-.838 0-1.249-.377-1.249-1.147 0-.137.034-.29.102-.428.069-.154.137-.308.223-.496l10.511-21.914h-8.816c-.771 0-1.147-.393-1.147-1.146v-2.09c0-.77.376-1.146 1.147-1.146h17.479c.805 0 1.198.36 1.198 1.096 0 .137-.034.325-.102.513-.086.206-.154.394-.223.582l-10.237 21.64h9.467c.804 0 1.215.376 1.215 1.146v2.243Zm20.698-13.096c0-1.524-.103-2.928-.308-4.212-.189-1.284-.514-2.38-.942-3.321-.445-.925-1.01-1.66-1.678-2.191a3.857 3.857 0 0 0-2.379-.788c-1.798 0-3.099.907-3.921 2.74-.821 1.831-1.232 4.262-1.232 7.292 0 1.524.102 2.945.291 4.246.205 1.284.531 2.414.976 3.355.428.959.975 1.695 1.643 2.226.651.53 1.438.787 2.345.787.959 0 1.747-.24 2.414-.736.651-.496 1.199-1.181 1.61-2.054.428-.873.719-1.935.907-3.167.188-1.25.274-2.637.274-4.177Zm8.217 0c0 2.242-.308 4.262-.924 6.094-.634 1.815-1.524 3.39-2.688 4.708-1.164 1.318-2.585 2.328-4.246 3.065-1.66.736-3.526 1.095-5.615 1.095-2.088 0-3.954-.36-5.615-1.096-1.661-.736-3.065-1.746-4.212-3.064-1.164-1.318-2.037-2.893-2.67-4.708-.617-1.832-.925-3.852-.925-6.094 0-2.226.308-4.246.925-6.078.633-1.815 1.523-3.39 2.688-4.674a11.79 11.79 0 0 1 4.245-3.013c1.661-.719 3.51-1.078 5.564-1.078 2.037 0 3.903.36 5.564 1.078a11.94 11.94 0 0 1 4.246 3.013c1.164 1.284 2.071 2.86 2.705 4.674.633 1.832.958 3.852.958 6.078Zm28.487 13.096c0 .77-.359 1.147-1.095 1.147h-5.855c-.736 0-1.096-.377-1.096-1.147V31.038c0-.6-.085-1.164-.222-1.712a3.469 3.469 0 0 0-.771-1.421c-.359-.41-.839-.736-1.421-.993-.582-.257-1.318-.377-2.191-.377-.873 0-1.592.086-2.14.274-.548.171-.959.428-1.233.736a2.307 2.307 0 0 0-.547 1.079 5.92 5.92 0 0 0-.137 1.25v20.372c0 .77-.377 1.147-1.147 1.147h-5.804c-.736 0-1.096-.377-1.096-1.147V27.46c0-.942.154-1.678.463-2.157.308-.497.907-.942 1.78-1.353.976-.462 2.38-.856 4.194-1.18 1.798-.31 3.767-.463 5.89-.463 1.711 0 3.321.154 4.844.445 1.507.291 2.825.77 3.938 1.455a7.718 7.718 0 0 1 2.653 2.602c.668 1.062.993 2.346.993 3.886v19.551Zm20.664-17.753a13.455 13.455 0 0 0-.308-2.157c-.172-.72-.428-1.352-.805-1.917a4.18 4.18 0 0 0-1.421-1.37c-.582-.342-1.284-.514-2.123-.514-.958 0-1.763.223-2.448.685a5.36 5.36 0 0 0-1.66 1.78c-.446.72-.771 1.541-.976 2.466a16.423 16.423 0 0 0-.343 2.739l10.084-1.712Zm7.601 10.357c0 1.028-.274 2.089-.822 3.185-.548 1.095-1.318 2.088-2.328 2.979-.993.907-2.191 1.643-3.578 2.225-1.387.582-2.928.873-4.605.873-1.832 0-3.544-.29-5.153-.873a11.039 11.039 0 0 1-4.212-2.722c-1.215-1.216-2.157-2.773-2.859-4.674-.684-1.9-1.027-4.177-1.027-6.848 0-2.55.342-4.759 1.062-6.608.719-1.832 1.677-3.372 2.893-4.57 1.232-1.199 2.636-2.09 4.228-2.654a14.846 14.846 0 0 1 5.016-.856c1.712 0 3.27.308 4.657.907 1.387.6 2.568 1.404 3.561 2.414a10.601 10.601 0 0 1 2.277 3.527c.513 1.352.787 2.773.787 4.28 0 .804-.171 1.352-.496 1.643-.326.291-.839.497-1.524.6l-15.082 2.465c.119 1.06.359 2.054.719 2.978a8.372 8.372 0 0 0 1.455 2.466 6.033 6.033 0 0 0 2.225 1.677c.874.411 1.884.6 3.065.6.804 0 1.524-.12 2.191-.36a7.437 7.437 0 0 0 1.798-.924 8.492 8.492 0 0 0 1.438-1.233c.394-.445.736-.856 1.027-1.267a2.43 2.43 0 0 1 .685-.702c.274-.188.616-.274 1.027-.274.428 0 .805.154 1.113.497.308.325.462.736.462 1.25ZM69.063 39.29c0 9.124-7.396 16.52-16.52 16.52-9.125 0-16.52-7.396-16.52-16.52 0-9.125 7.395-16.52 16.52-16.52 9.124 0 16.52 7.395 16.52 16.52ZM56.908 61.288c0 1.13-2.003 2.055-4.451 2.055-2.465 0-4.451-.925-4.451-2.055 0-1.13 1.986-2.054 4.451-2.054 2.448 0 4.451.924 4.451 2.054Zm-14.483-.856c.068 1.096-1.832 2.089-4.246 2.226-2.397.137-4.4-.633-4.468-1.712-.069-1.096 1.832-2.089 4.246-2.226 2.396-.137 4.4.634 4.468 1.712Zm-12.943-2.105c.103.993-1.746 2.003-4.142 2.26-2.397.273-4.434-.309-4.537-1.302-.103-.993 1.746-2.003 4.143-2.26 2.396-.273 4.434.309 4.536 1.302ZM19.28 55.45c.12.84-1.678 1.798-4.023 2.14-2.328.343-4.331-.068-4.451-.907-.12-.839 1.678-1.797 4.023-2.14 2.328-.342 4.331.069 4.451.907Zm74.899 1.233c-.12.839-2.123 1.25-4.451.907-2.346-.342-4.144-1.3-4.024-2.14.12-.838 2.123-1.25 4.451-.907 2.346.343 4.143 1.301 4.024 2.14Zm6.676-3.201c-.102.702-1.969 1.01-4.16.685-2.208-.309-3.903-1.148-3.8-1.85.102-.701 1.968-1.01 4.16-.684 2.208.308 3.903 1.147 3.8 1.849Zm-88.765-1.164c.103.702-1.592 1.54-3.8 1.849-2.192.325-4.058.017-4.16-.685-.103-.702 1.591-1.541 3.8-1.85 2.191-.324 4.057-.016 4.16.686Zm-4.006-3.356c.068.616-1.524 1.335-3.595 1.61-2.055.29-3.784.034-3.87-.583-.085-.616 1.507-1.335 3.579-1.609 2.054-.29 3.8-.034 3.886.582Zm96.212 1.027c-.085.617-1.832.873-3.886.582-2.071-.273-3.663-.992-3.578-1.609.086-.616 1.815-.873 3.869-.582 2.072.274 3.664.993 3.595 1.61Zm.685-3.338c-.068.514-1.643.736-3.509.514-1.884-.24-3.356-.856-3.287-1.37.068-.514 1.643-.736 3.509-.514 1.883.24 3.356.856 3.287 1.37Zm-98.181-.856c.068.514-1.404 1.13-3.287 1.37-1.866.222-3.441 0-3.51-.514-.068-.514 1.404-1.13 3.287-1.37 1.866-.222 3.441 0 3.51.514Zm.941-2.893c-.017.445-1.42.941-3.15 1.13-1.729.188-3.115-.017-3.098-.462 0-.446 1.42-.942 3.133-1.13 1.729-.189 3.115.017 3.115.462Zm89.485 0c0 .445 1.404.941 3.133 1.13 1.729.188 3.116-.017 3.116-.462-.018-.446-1.421-.942-3.15-1.13-1.73-.189-3.116.017-3.1.462Zm-2.602-2.568c0 .377 1.284.804 2.859.959 1.575.154 2.842-.017 2.842-.394-.018-.377-1.302-.805-2.877-.959-1.575-.171-2.841.017-2.824.394Zm-84.28 0c-.017.377-1.301.804-2.876.959-1.575.154-2.842-.017-2.825-.394 0-.377 1.284-.805 2.859-.959 1.575-.171 2.842.017 2.842.394ZM84.18 59.285c-.103.993-2.14 1.575-4.537 1.301-2.397-.256-4.246-1.266-4.143-2.26.103-.992 2.14-1.574 4.537-1.3 2.396.256 4.245 1.266 4.143 2.26Zm-12.909 1.66c-.068 1.08-2.071 1.85-4.468 1.713-2.414-.137-4.314-1.13-4.245-2.226.068-1.078 2.071-1.849 4.468-1.712 2.414.137 4.314 1.13 4.246 2.226Zm-7.857-50.074c0 6.009-4.88 10.87-10.871 10.87a10.864 10.864 0 0 1-10.871-10.87A10.864 10.864 0 0 1 52.542 0c5.992 0 10.872 4.862 10.872 10.871ZM94.657 32.87c0 5.478-4.485 9.93-10.015 9.93-5.547 0-10.015-4.452-10.015-9.93 0-5.479 4.468-9.93 10.015-9.93 5.53 0 10.015 4.451 10.015 9.93Zm-3.51-17.12c0 3.595-2.927 6.506-6.505 6.506a6.502 6.502 0 0 1-6.505-6.506 6.503 6.503 0 0 1 6.505-6.505c3.578 0 6.505 2.91 6.505 6.505ZM30.458 32.87c0 5.478-4.485 9.93-10.015 9.93-5.547 0-10.015-4.452-10.015-9.93 0-5.479 4.468-9.93 10.015-9.93 5.53 0 10.015 4.451 10.015 9.93Zm-3.51-17.12c0 3.595-2.927 6.506-6.505 6.506a6.503 6.503 0 0 1-6.505-6.506 6.503 6.503 0 0 1 6.505-6.505c3.578 0 6.506 2.91 6.506 6.505ZM9.505 38.16c-.36.137-.565.29-.565.428 0 .205.394.342 1.027.393-.188-.29-.36-.599-.462-.821Zm85.957 0c.343.137.548.29.548.428.017.205-.393.342-1.01.393.172-.29.343-.599.463-.821Zm-24.258-5.684c-.48 0-.942.017-1.318.068.085.223.171.463.257.702.325.017.684.035 1.061.035.496 0 .959-.017 1.335-.069 0-.222 0-.445.017-.668a14.809 14.809 0 0 0-1.352-.068Zm-37.338 0c.496 0 .959.017 1.335.068-.085.223-.17.463-.256.702a20 20 0 0 1-1.079.035c-.48 0-.942-.017-1.318-.069 0-.222 0-.445-.017-.668.376-.034.839-.068 1.335-.068Z",
  fill: "currentColor"
}));

const Spinner = ({
  ...props
}) => /*#__PURE__*/React.createElement(Spinner$1, Object.assign({}, props));

var UploadState;
(function (UploadState) {
  UploadState[UploadState["Pending"] = 0] = "Pending";
  UploadState[UploadState["Uploading"] = 1] = "Uploading";
  UploadState[UploadState["Uploaded"] = 2] = "Uploaded";
})(UploadState || (UploadState = {}));
const FileListItemContainer = props => {
  return /*#__PURE__*/React.createElement(Flex, Object.assign({
    flexDirection: "row",
    alignItems: "center",
    py: theme.space.sp8,
    px: theme.space.sp16,
    backgroundColor: theme.colors.brand[100],
    borderRadius: theme.radii.sm
  }, props));
};
const FileIcon = () => /*#__PURE__*/React.createElement(Icon, {
  icon: "fa-file-alt",
  variant: "solid",
  boxSize: "12px",
  color: theme.colors.text.paragraph.light,
  mr: theme.space.sp8
});
const FileName = props => /*#__PURE__*/React.createElement(Text, Object.assign({
  flexGrow: 1,
  overflowWrap: "anywhere",
  color: theme.colors.text.title
}, props));
const UploadButton = props => /*#__PURE__*/React.createElement(Button, Object.assign({
  variant: "primary",
  size: "sm",
  ml: theme.space.sp8
}, props));
const FileListItem = ({
  file,
  autoUpload,
  onUpload
}) => {
  const {
    t
  } = useTranslation();
  const [uploadState, setUploadState] = useState(UploadState.Pending);
  useEffect(() => {
    if (file.uploaded) {
      setUploadState(UploadState.Uploaded);
    } else if (autoUpload) {
      setUploadState(UploadState.Uploading);
      setTimeout(executeUpload, 0);
    }
  }, [file, autoUpload]);
  const executeUpload = () => {
    onUpload(file, success => {
      if (success === false) {
        setUploadState(UploadState.Pending);
      } else {
        setUploadState(UploadState.Uploaded);
      }
    });
  };
  const handleUpload = () => {
    setUploadState(UploadState.Uploading);
    executeUpload();
  };
  return /*#__PURE__*/React.createElement(FileListItemContainer, null, /*#__PURE__*/React.createElement(FileIcon, null), /*#__PURE__*/React.createElement(FileName, null, file.name), /*#__PURE__*/React.createElement(UploadButton, {
    isDisabled: uploadState !== UploadState.Pending,
    onClick: handleUpload
  }, uploadState === UploadState.Pending && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    icon: "fa-cloud-arrow-up",
    variant: "solid",
    boxSize: "12px"
  }), /*#__PURE__*/React.createElement(Text, {
    ml: "sp8"
  }, t("Upload"))), uploadState === UploadState.Uploading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
    size: "xs",
    color: "brand.400"
  }), /*#__PURE__*/React.createElement(Text, {
    ml: "sp8"
  }, t("Uploading"))), uploadState === UploadState.Uploaded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    icon: "fa-check",
    color: "success.icon",
    variant: "solid",
    boxSize: "12px"
  }), /*#__PURE__*/React.createElement(Text, {
    ml: "sp8"
  }, t("Uploaded")))));
};

const containerMotionVariants = {
  default: {
    backgroundColor: theme.colors.neutrals[20],
    borderColor: theme.colors.neutrals[20],
    borderStyle: "solid",
    borderWidth: "2px",
    borderRadius: theme.radii.sm
  },
  acceptDrop: {
    backgroundColor: theme.colors.brand[100],
    borderColor: theme.colors.brand[400],
    borderStyle: "dashed",
    borderWidth: "2px",
    borderRadius: theme.radii.sm
  },
  forbidDrop: {
    backgroundColor: theme.colors.error.background,
    borderColor: theme.colors.error.icon,
    borderStyle: "dashed",
    borderWidth: "2px",
    borderRadius: theme.radii.sm
  }
};
const iconMotionVariants = {
  initial: {
    color: theme.colors.neutrals[80]
  },
  acceptDrop: {
    color: theme.colors.brand[400]
  },
  forbidDrop: {
    color: theme.colors.error.icon
  }
};
const FilePickerContainer = ({
  animate,
  ...props
}) => /*#__PURE__*/React.createElement(motion.div, {
  variants: containerMotionVariants,
  initial: "initial",
  animate: animate
}, /*#__PURE__*/React.createElement(Flex, Object.assign({
  flexDirection: "row",
  alignItems: "center",
  p: theme.space.sp16,
  backgroundColor: theme.colors.neutrals[20],
  borderRadius: theme.radii.sm
}, props)));
const UploadIconContainer = ({
  animate
}) => /*#__PURE__*/React.createElement(motion.div, {
  variants: iconMotionVariants,
  initial: "initial",
  animate: animate
}, /*#__PURE__*/React.createElement(Icon, {
  "data-testid": "upload-icon",
  icon: "fa-cloud-arrow-up",
  variant: "light",
  boxSize: "28px"
}));
const UploadTextContainer = props => /*#__PURE__*/React.createElement(Flex, Object.assign({
  flexDirection: "column",
  flexGrow: 1,
  justifyContent: "center",
  ml: theme.space.sp16
}, props));
const PrimaryText = props => /*#__PURE__*/React.createElement(Text$1, Object.assign({
  color: theme.colors.text.title,
  fontSize: theme.fontSizes.sm,
  fontWeight: theme.fontWeights.medium
}, props));
const SecondaryText = props => /*#__PURE__*/React.createElement(Text$1, Object.assign({
  color: theme.colors.text.paragraph.regular,
  fontSize: theme.fontSizes.xs,
  fontWeight: theme.fontWeights.regular
}, props));
const FileRawInput = /*#__PURE__*/forwardRef$1((props, ref) => /*#__PURE__*/React.createElement(Input$2, Object.assign({
  ref: ref,
  type: "file",
  position: "absolute",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  padding: "0",
  border: "0",
  opacity: "0"
}, props)));
const FilePicker = /*#__PURE__*/forwardRef$1(({
  primaryText = "Drag files here to upload or click Select File",
  secondaryText,
  accept,
  disabled = false,
  multiple = false,
  dragAndDrop = true,
  onSelect
}, ref) => {
  const {
    t
  } = useTranslation();
  const targetCounter = useRef(0);
  const [dragging, setDragging] = useState(false);
  const [allowDrop, setAllowDrop] = useState(true);
  const isAcceptable = items => {
    if (!multiple && items.length > 1) {
      return false;
    }
    if (!accept) {
      return true;
    }
    const acceptableTypes = accept.split(",");
    for (let i = 0; i < items.length; i++) {
      if (!acceptableTypes.find(t => t === items[i].type)) {
        return false;
      }
    }
    return true;
  };
  const onDragEnter = e => {
    e.preventDefault();
    const acceptable = isAcceptable(e.dataTransfer.items);
    if (!acceptable) {
      e.dataTransfer.dropEffect = "none";
    }
    setAllowDrop(acceptable);
    setDragging(over => {
      if (!over) {
        targetCounter.current = 0;
      }
      targetCounter.current++;
      return true;
    });
  };
  const onDragOver = e => {
    e.preventDefault();
    if (!allowDrop) {
      e.dataTransfer.dropEffect = "none";
    }
  };
  const onDragLeave = _e => {
    if (--targetCounter.current === 0) {
      setDragging(false);
    }
  };
  const onDrop = e => {
    e.preventDefault();
    if (!allowDrop) {
      return;
    }
    const selected = [];
    for (let i = 0; i < e.dataTransfer.files.length; i++) {
      selected.push(e.dataTransfer.files[i]);
    }
    onSelect(multiple ? selected : selected.slice(0, 1));
    targetCounter.current = 0;
    setDragging(false);
  };
  const onChange = e => {
    if (e.target.files && e.target.files.length > 0) {
      if (!isAcceptable(e.target.files)) {
        return;
      }
      const selected = [];
      for (let i = 0; i < e.target.files.length; i++) {
        selected.push(e.target.files[i]);
      }
      onSelect(selected);
    }
  };
  const activeMotionVariant = dragging ? allowDrop ? "acceptDrop" : "forbidDrop" : "default";
  return /*#__PURE__*/React.createElement(FilePickerContainer, Object.assign({
    animate: activeMotionVariant,
    cursor: allowDrop ? "default" : "not-allowed"
  }, !disabled && dragAndDrop && {
    onDragEnter: onDragEnter,
    onDragOver: onDragOver,
    onDragLeave: onDragLeave,
    onDrop: onDrop
  }), /*#__PURE__*/React.createElement(UploadIconContainer, {
    animate: activeMotionVariant
  }), /*#__PURE__*/React.createElement(UploadTextContainer, null, /*#__PURE__*/React.createElement(PrimaryText, {
    "data-testid": "upload-primary-text"
  }, primaryText), secondaryText && /*#__PURE__*/React.createElement(SecondaryText, {
    "data-testid": "upload-secondary-text"
  }, secondaryText)), /*#__PURE__*/React.createElement(Button, {
    variant: "outline",
    size: "sm",
    isDisabled: disabled
  }, multiple ? t("Select Files") : t("Select File"), /*#__PURE__*/React.createElement(FileRawInput, Object.assign({
    ref: ref,
    isDisabled: disabled,
    multiple: multiple,
    onChange: onChange,
    "aria-hidden": true
  }, accept && {
    accept: accept
  }, {
    "data-testid": "upload-input"
  }))));
});

const FileUploadContainer = props => /*#__PURE__*/React.createElement(Box, Object.assign({
  maxWidth: "580px"
}, props));
const FileUpload = /*#__PURE__*/forwardRef$1(({
  autoUpload,
  clearOnUpload,
  initialFiles = [],
  multiple,
  onUpload,
  ...pickerProps
}, ref) => {
  const [files, setFiles] = useState([]);
  const onFileSelect = selected => {
    setFiles(files => multiple ? [...files, ...selected] : selected);
  };
  const onFileUpload = (file, done) => {
    onUpload(file, success => {
      if (success !== false && clearOnUpload) {
        setFiles(files => files.filter(f => f != file));
      } else {
        done(success);
      }
    });
  };
  return /*#__PURE__*/React.createElement(FileUploadContainer, null, /*#__PURE__*/React.createElement(FilePicker, Object.assign({
    ref: ref
  }, pickerProps, {
    multiple: multiple,
    onSelect: onFileSelect
  })), (initialFiles.length > 0 || files.length > 0) && /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    mt: "sp8",
    gridGap: "sp8",
    "data-testid": "upload-file-list"
  }, initialFiles.map(file => /*#__PURE__*/React.createElement(FileListItem, {
    key: file.name,
    file: file,
    onUpload: onFileUpload
  })), files.map(file => /*#__PURE__*/React.createElement(FileListItem, {
    key: file.name,
    file: file,
    autoUpload: autoUpload,
    onUpload: onFileUpload
  }))));
});

const InlineNotification = ({
  isRemovable,
  notificationDescription,
  onCloseButtonClick,
  notificationTitle,
  status,
  ...props
}) => /*#__PURE__*/React.createElement(Alert, Object.assign({
  status: status,
  variant: status
}, props), /*#__PURE__*/React.createElement(Box, {
  alignItems: "center",
  display: "flex"
}, /*#__PURE__*/React.createElement(AlertIcon, null)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(AlertTitle, {
  mr: 2
}, notificationTitle), /*#__PURE__*/React.createElement(AlertDescription, null, notificationDescription)), isRemovable && /*#__PURE__*/React.createElement(CloseButton$2, {
  position: "absolute",
  size: "sm",
  right: "8px",
  top: "8px",
  onClick: onCloseButtonClick
}));

const LinewizeLogo = ({
  width = "71px",
  height = "71px",
  ...props
}) => /*#__PURE__*/React.createElement(Icon$1, Object.assign({
  width: width,
  height: height,
  viewBox: "0 0 71 71"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70.114 0h-70v71h70V0Zm-54 54.801h37.39v-7.055H23.17V16h-7.055v38.801ZM38.337 16h-7.055v24.339h7.055V16Zm15.167 24.339H46.45V16h7.054v24.339Z",
  fill: "currentColor"
}));

const LinewizeLogoWithFamilyZone = ({
  width = "318px",
  height = "72px",
  ...props
}) => /*#__PURE__*/React.createElement(Icon$1, Object.assign({
  width: width,
  height: height,
  viewBox: "0 0 318 78"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M130.31 18.687c.217-.451.325-.946.317-1.447a3.724 3.724 0 0 0-.317-1.481 4.278 4.278 0 0 0-.847-1.235 3.606 3.606 0 0 0-1.199-.81 3.495 3.495 0 0 0-1.482-.318c-.499 0-.992.108-1.446.317-.446.195-.852.47-1.199.811-.354.35-.63.771-.812 1.235a3.759 3.759 0 0 0-.317 1.482c-.008.5.1.995.317 1.446.174.457.452.868.812 1.199.345.352.752.639 1.199.847.456.197.949.294 1.446.282a3.459 3.459 0 0 0 1.482-.282 4.31 4.31 0 0 0 2.046-2.046ZM129.428 57.17V26.8h-5.326v30.37h5.326ZM117.929 52.267h-18.59v-38.06h-5.82v42.964h24.41v-4.904ZM138.846 57.17V26.8h3.175a1.34 1.34 0 0 1 1.446 1.093l.423 3.316a16.9 16.9 0 0 1 4.409-3.563 11.712 11.712 0 0 1 5.644-1.34 11.285 11.285 0 0 1 4.409.81 8.532 8.532 0 0 1 3.175 2.364 10.514 10.514 0 0 1 1.94 3.633c.45 1.523.676 3.104.67 4.692V57.17h-5.361V37.805c0-2.293-.529-4.057-1.552-5.327-1.023-1.27-2.681-1.904-4.833-1.904a8.818 8.818 0 0 0-4.409 1.128 14.887 14.887 0 0 0-3.81 3.104V57.17h-5.326Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.252 27.223a13.79 13.79 0 0 0-5.044-.917 14.566 14.566 0 0 0-5.926 1.164 13.273 13.273 0 0 0-4.48 3.175 13.904 13.904 0 0 0-2.786 4.762 17.458 17.458 0 0 0-.988 5.961 20.1 20.1 0 0 0 1.094 6.95 14.445 14.445 0 0 0 2.998 5.079 12.736 12.736 0 0 0 4.585 3.104 15.562 15.562 0 0 0 5.821 1.093 17.882 17.882 0 0 0 3.315-.317 16.884 16.884 0 0 0 3.246-.847 14.463 14.463 0 0 0 2.963-1.446 10.347 10.347 0 0 0 2.363-2.081l-1.482-1.94a1.2 1.2 0 0 0-1.023-.53 2.68 2.68 0 0 0-1.234.46c-.556.373-1.133.715-1.729 1.022a15.43 15.43 0 0 1-2.504.988c-1.131.344-2.31.51-3.492.494a10.546 10.546 0 0 1-3.88-.706 8.251 8.251 0 0 1-2.998-2.152 9.633 9.633 0 0 1-1.976-3.562 16.026 16.026 0 0 1-.776-4.974h20.212a1.06 1.06 0 0 0 .988-.423c.211-.282.282-.847.282-1.693.032-1.97-.291-3.93-.952-5.785a11.46 11.46 0 0 0-2.611-4.233 10.973 10.973 0 0 0-3.986-2.646Zm-11.005 5.256c1.481-1.517 3.492-2.257 6.102-2.257a7.933 7.933 0 0 1 3.245.635 6.524 6.524 0 0 1 2.399 1.728 7.7 7.7 0 0 1 1.517 2.68 11.36 11.36 0 0 1 .494 3.387h-16.508c.352-2.645 1.269-4.656 2.751-6.173Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M199.658 26.8h4.198c.378-.019.752.093 1.058.317.268.198.475.467.599.776l5.821 19.542c.141.74.282 1.41.423 2.08.155.676.272 1.359.353 2.047.176-.706.352-1.376.564-2.046.088-.278.169-.556.253-.839.117-.399.237-.809.382-1.242l6.42-19.648c.073-.306.247-.58.494-.776.28-.191.613-.29.952-.282h2.328a1.8 1.8 0 0 1 .988.282c.246.204.429.473.529.776l6.279 19.648c.167.56.313 1.119.454 1.66l.063.24.047.18c.176.67.353 1.341.494 2.011.076-.481.17-.963.269-1.47l.119-.61c.104-.55.248-1.042.387-1.518l.001-.003c.048-.164.096-.327.141-.49l5.926-19.542a1.62 1.62 0 0 1 .564-.811 1.8 1.8 0 0 1 .988-.283h4.021l-9.841 30.371h-4.233c-.494 0-.847-.352-1.058-1.023l-6.738-20.6c-.141-.458-.282-.917-.388-1.41a37.862 37.862 0 0 1-.122-.608l-.001-.001c-.05-.258-.099-.507-.159-.767l-.317 1.41a7.04 7.04 0 0 1-.388 1.412l-6.808 20.564c-.212.67-.6 1.023-1.199 1.023h-4.022l-9.841-30.37ZM256.379 18.687c.217-.45.325-.946.317-1.446a3.76 3.76 0 0 0-.317-1.482 4.28 4.28 0 0 0-.847-1.234 4.162 4.162 0 0 0-1.235-.812 3.452 3.452 0 0 0-1.446-.317c-.5-.008-.995.1-1.446.317a3.587 3.587 0 0 0-1.199.812 4.26 4.26 0 0 0-.847 1.234 3.655 3.655 0 0 0-.282 1.482c-.019.497.077.992.282 1.446a4.3 4.3 0 0 0 2.046 2.046 3.21 3.21 0 0 0 1.446.282c.497.012.991-.084 1.446-.282a4.25 4.25 0 0 0 1.235-.847 3.72 3.72 0 0 0 .847-1.199ZM255.497 57.17V26.8h-5.362v30.37h5.362ZM286.079 29.057c.002.375-.07.747-.212 1.094-.133.34-.311.66-.529.952l-16.437 21.87h16.578v4.198h-22.857v-2.223c.014-.312.073-.621.176-.917.139-.366.329-.71.565-1.023l16.508-22.01h-16.332V26.8h22.54v2.257Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M309.642 27.223a13.614 13.614 0 0 0-5.009-.917 14.6 14.6 0 0 0-5.961 1.164 13.127 13.127 0 0 0-4.445 3.174 13.974 13.974 0 0 0-2.822 4.762 18.41 18.41 0 0 0-.952 5.962c-.04 2.359.317 4.708 1.058 6.949a14.527 14.527 0 0 0 3.034 5.079 12.449 12.449 0 0 0 4.585 3.104 15.488 15.488 0 0 0 5.785 1.094 18.234 18.234 0 0 0 3.351-.318 17.614 17.614 0 0 0 3.246-.846 14.163 14.163 0 0 0 2.927-1.447 9.793 9.793 0 0 0 2.399-2.08l-1.517-1.94a1.166 1.166 0 0 0-1.023-.53c-.432.05-.845.207-1.199.459-.569.373-1.157.715-1.764 1.022-.802.408-1.64.739-2.504.988a11.01 11.01 0 0 1-3.457.494 10.62 10.62 0 0 1-3.916-.705 8.544 8.544 0 0 1-2.998-2.152 10.754 10.754 0 0 1-1.975-3.563 17.09 17.09 0 0 1-.776-4.973h20.212a1.13 1.13 0 0 0 1.023-.424c.176-.282.282-.846.282-1.693.032-1.97-.291-3.93-.953-5.785a12.44 12.44 0 0 0-2.61-4.233 11.106 11.106 0 0 0-4.021-2.645Zm-10.97 5.256c1.446-1.517 3.492-2.258 6.067-2.258a7.828 7.828 0 0 1 3.245.635 6.66 6.66 0 0 1 2.434 1.728 7.635 7.635 0 0 1 1.482 2.681 10.36 10.36 0 0 1 .529 3.387h-16.544c.388-2.646 1.341-4.657 2.787-6.173Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M192.004 74.913V61.686h2.751v5.044a4.338 4.338 0 0 1 1.164-.811 3.314 3.314 0 0 1 1.517-.318c.454-.004.903.106 1.305.318.422.215.785.53 1.058.917.325.433.564.924.706 1.446.177.643.26 1.308.247 1.975a6.753 6.753 0 0 1-.283 1.905 5.182 5.182 0 0 1-.811 1.517c-.327.423-.75.761-1.234.987a3.425 3.425 0 0 1-1.588.389 2.33 2.33 0 0 1-.741-.106 1.556 1.556 0 0 1-.564-.212 2.525 2.525 0 0 1-.494-.353l-.458-.423-.106.459a.599.599 0 0 1-.212.388.74.74 0 0 1-.423.105h-1.834Zm4.479-7.23h-.529l-.458.176a.982.982 0 0 0-.388.282l-.353.353v3.88c.18.217.41.386.67.494.239.08.489.128.741.14.246.001.489-.06.705-.176.227-.098.423-.256.565-.458.172-.27.291-.569.353-.882a4.53 4.53 0 0 0 .141-1.27 6.235 6.235 0 0 0-.106-1.235 3.297 3.297 0 0 0-.282-.776 1.423 1.423 0 0 0-.459-.458 1.657 1.657 0 0 0-.6-.07ZM205.972 77.277a.852.852 0 0 1-.282.388.848.848 0 0 1-.564.14h-2.046l1.763-3.703-3.668-8.36h2.434a.92.92 0 0 1 .494.141.824.824 0 0 1 .247.353l1.481 3.95c.154.352.273.719.353 1.094l.211-.564c.08-.181.139-.37.177-.564l1.375-3.916a.674.674 0 0 1 .283-.353.984.984 0 0 1 .423-.14h2.222l-4.903 11.534ZM224.385 62.038v2.293h-5.291v3.28h4.409v2.294h-4.409v5.008h-2.998V62.04h8.289ZM232.604 74.913a1.413 1.413 0 0 1-.6-.105.808.808 0 0 1-.317-.459l-.212-.494-.635.494a2.534 2.534 0 0 1-.67.388l-.706.247-.881.07a3.99 3.99 0 0 1-1.129-.176 2.22 2.22 0 0 1-.847-.494 2.113 2.113 0 0 1-.564-.776 2.649 2.649 0 0 1-.212-1.093c.015-.343.099-.679.247-.988.204-.39.508-.72.882-.952a5.85 5.85 0 0 1 1.623-.706c.855-.2 1.732-.295 2.61-.282V69.2a1.763 1.763 0 0 0-.318-1.164 1.269 1.269 0 0 0-.952-.353 2.645 2.645 0 0 0-.811.106l-.529.212-.494.247a1.165 1.165 0 0 1-.529.106.81.81 0 0 1-.494-.142 1.354 1.354 0 0 1-.318-.317l-.493-.882a5.821 5.821 0 0 1 1.869-1.058 6.136 6.136 0 0 1 2.152-.388 3.808 3.808 0 0 1 1.481.282c.43.153.817.407 1.129.74.328.325.57.725.706 1.165.176.461.259.953.246 1.446v5.714h-1.234Zm-3.14-1.693c.316.02.632-.04.918-.176.309-.14.586-.345.811-.6V71.21a6.855 6.855 0 0 0-1.341.106c-.291.046-.575.129-.846.246a.917.917 0 0 0-.423.388.867.867 0 0 0-.141.424.802.802 0 0 0 .282.67c.22.14.481.202.74.176ZM236.131 74.913v-9.17h1.693c.163.008.32.056.459.14a.53.53 0 0 1 .212.318l.176.494.459-.424.529-.352.635-.212c.228-.072.466-.108.705-.106.5-.027.992.137 1.376.459.383.288.676.68.846 1.129a2.3 2.3 0 0 1 .565-.741c.212-.185.45-.34.705-.459a3.18 3.18 0 0 1 .811-.282l.847-.106c.47 0 .935.084 1.376.247.394.13.746.361 1.023.67.285.317.501.69.635 1.094.147.48.218.98.211 1.481v5.82h-2.751v-5.82c0-.952-.388-1.41-1.199-1.41a1.2 1.2 0 0 0-.918.352 1.453 1.453 0 0 0-.388 1.058v5.82h-2.716v-5.82a1.516 1.516 0 0 0-.317-1.093 1.197 1.197 0 0 0-.917-.318 1.442 1.442 0 0 0-.67.141 2.905 2.905 0 0 0-.635.459v6.632h-2.752ZM254.826 63.238c.008.22-.041.438-.141.635a1.577 1.577 0 0 1-.352.494 1.98 1.98 0 0 1-.53.352 2.044 2.044 0 0 1-.67.106 1.653 1.653 0 0 1-.599-.106 1.98 1.98 0 0 1-.53-.352 1.577 1.577 0 0 1-.352-.494 1.85 1.85 0 0 1-.141-.635c.009-.207.057-.41.141-.6.075-.2.196-.382.352-.529a1.98 1.98 0 0 1 .53-.353c.191-.072.395-.108.599-.105.228-.003.454.033.67.105.195.088.373.208.53.353.156.147.276.328.352.53.1.183.149.39.141.599Zm-.317 2.504v9.171h-2.751v-9.17h2.751ZM259.871 61.686v13.227h-2.717V61.686h2.717ZM266.185 77.277a.707.707 0 0 1-.318.388.776.776 0 0 1-.564.14h-2.046l1.763-3.703-3.633-8.36h2.399a.917.917 0 0 1 .494.141.601.601 0 0 1 .247.353l1.516 3.95c.139.358.257.723.353 1.094.038-.194.097-.383.177-.564l.211-.564 1.341-3.916a.874.874 0 0 1 .282-.353.985.985 0 0 1 .458-.14h2.187l-4.867 11.534ZM285.691 62.038v1.094c.011.156-.013.313-.071.459a.852.852 0 0 1-.211.388l-6.032 8.642h6.138v2.293h-9.912v-1.165c.006-.131.03-.262.07-.388.044-.135.103-.265.177-.388l6.067-8.642h-5.82v-2.293h9.594ZM291.299 65.601a5.395 5.395 0 0 1 1.905.353 4.543 4.543 0 0 1 1.482.917c.397.438.719.938.952 1.482a5.62 5.62 0 0 1 .318 1.94 5.65 5.65 0 0 1-.318 1.975 5.041 5.041 0 0 1-.952 1.517c-.43.398-.933.71-1.482.917a4.69 4.69 0 0 1-1.905.353 4.933 4.933 0 0 1-1.904-.353 4.543 4.543 0 0 1-1.482-.917 4.44 4.44 0 0 1-.952-1.517 5.601 5.601 0 0 1 0-3.915c.22-.55.543-1.053.952-1.482.43-.398.933-.71 1.482-.917a5.71 5.71 0 0 1 1.904-.353Zm0 7.408a1.588 1.588 0 0 0 1.411-.67c.283-.424.424-1.094.424-2.011s-.141-1.588-.424-2.01a1.83 1.83 0 0 0-2.19-.49 1.83 1.83 0 0 0-.631.49 4.62 4.62 0 0 0 0 4.02 1.585 1.585 0 0 0 1.41.67ZM297.825 74.913v-9.17h1.693c.153.002.3.05.424.14a.563.563 0 0 1 .246.318l.142.529.564-.459c.187-.138.388-.256.6-.352.228-.092.464-.163.705-.212.264-.072.537-.108.811-.106.462-.002.919.094 1.341.282.359.174.682.413.952.706.282.327.487.712.6 1.129.144.444.215.908.211 1.375v5.82h-2.751v-5.82a1.582 1.582 0 0 0-.282-1.058 1.161 1.161 0 0 0-.917-.353c-.292 0-.58.06-.847.177a3.8 3.8 0 0 0-.776.529v6.525h-2.716ZM312.323 65.601a4.946 4.946 0 0 1 1.658.282c.484.198.927.485 1.305.847.369.372.657.816.846 1.305.205.565.3 1.163.282 1.764v.494c-.024.109-.059.215-.105.317a.427.427 0 0 1-.177.176h-5.608c.045.616.293 1.199.705 1.658.397.355.914.544 1.446.53.289.01.577-.038.847-.142l.6-.247.493-.247c.144-.068.3-.104.459-.105a.569.569 0 0 1 .494.211l.811.988c-.27.308-.578.58-.917.811a6.176 6.176 0 0 1-.988.459 5.74 5.74 0 0 1-1.058.247l-.988.07a5.076 5.076 0 0 1-1.798-.317 3.702 3.702 0 0 1-1.447-.953 4.285 4.285 0 0 1-1.023-1.516 5.758 5.758 0 0 1-.352-2.152 4.816 4.816 0 0 1 .317-1.728 3.922 3.922 0 0 1 2.328-2.4 4.41 4.41 0 0 1 1.87-.352Zm.035 1.905a1.55 1.55 0 0 0-1.199.459 2.146 2.146 0 0 0-.6 1.27h3.422a3.983 3.983 0 0 0-.071-.636 2.832 2.832 0 0 0-.282-.564 1.884 1.884 0 0 0-.494-.388 1.695 1.695 0 0 0-.776-.141Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70.114 1h-70v71h70V1Zm-54 54.801h37.39v-7.055H23.17V17h-7.055v38.801ZM38.337 17h-7.055v24.339h7.055V17Zm15.167 24.339H46.45V17h7.054v24.339Z",
  fill: "currentColor"
}));

const LinewizeLogoWithText = ({
  width = "318px",
  height = "72px",
  ...props
}) => /*#__PURE__*/React.createElement(Icon$1, Object.assign({
  width: width,
  height: height,
  viewBox: "0 0 318 78"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M130.196 18.687c.217-.451.325-.946.317-1.447a3.724 3.724 0 0 0-.317-1.481 4.278 4.278 0 0 0-.847-1.235 3.606 3.606 0 0 0-1.199-.81 3.495 3.495 0 0 0-1.482-.318c-.499 0-.992.108-1.446.317-.446.195-.852.47-1.199.811-.354.35-.63.771-.812 1.235a3.759 3.759 0 0 0-.317 1.482c-.008.5.1.995.317 1.446.174.457.452.868.812 1.199.345.352.752.639 1.199.847.456.197.949.294 1.446.282a3.459 3.459 0 0 0 1.482-.282 4.31 4.31 0 0 0 2.046-2.046ZM129.314 57.17V26.8h-5.327v30.37h5.327ZM117.815 52.267h-18.59v-38.06h-5.82v42.964h24.41v-4.904ZM138.732 57.17V26.8h3.175a1.34 1.34 0 0 1 1.446 1.093l.423 3.316a16.9 16.9 0 0 1 4.409-3.563 11.712 11.712 0 0 1 5.644-1.34 11.285 11.285 0 0 1 4.409.81 8.532 8.532 0 0 1 3.175 2.364 10.514 10.514 0 0 1 1.94 3.633c.45 1.523.676 3.104.67 4.692V57.17h-5.361V37.805c0-2.293-.529-4.057-1.552-5.327-1.023-1.27-2.681-1.904-4.833-1.904a8.818 8.818 0 0 0-4.409 1.128 14.887 14.887 0 0 0-3.81 3.104V57.17h-5.326Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.138 27.223a13.79 13.79 0 0 0-5.044-.917 14.566 14.566 0 0 0-5.926 1.164 13.273 13.273 0 0 0-4.48 3.175 13.904 13.904 0 0 0-2.786 4.762 17.458 17.458 0 0 0-.988 5.961 20.1 20.1 0 0 0 1.094 6.95 14.445 14.445 0 0 0 2.998 5.079 12.736 12.736 0 0 0 4.585 3.104 15.562 15.562 0 0 0 5.821 1.093 17.882 17.882 0 0 0 3.315-.317 16.903 16.903 0 0 0 3.246-.847 14.463 14.463 0 0 0 2.963-1.446 10.347 10.347 0 0 0 2.363-2.081l-1.482-1.94a1.2 1.2 0 0 0-1.023-.53 2.68 2.68 0 0 0-1.234.46c-.556.373-1.133.715-1.729 1.022a15.43 15.43 0 0 1-2.504.988c-1.131.344-2.31.51-3.492.494a10.546 10.546 0 0 1-3.88-.706 8.251 8.251 0 0 1-2.998-2.152 9.633 9.633 0 0 1-1.976-3.562 16.026 16.026 0 0 1-.776-4.974h20.212a1.06 1.06 0 0 0 .988-.423c.211-.282.282-.847.282-1.693.032-1.97-.291-3.93-.952-5.785a11.46 11.46 0 0 0-2.611-4.233 10.973 10.973 0 0 0-3.986-2.646Zm-11.005 5.256c1.481-1.517 3.492-2.257 6.102-2.257a7.933 7.933 0 0 1 3.245.635 6.524 6.524 0 0 1 2.399 1.728 7.7 7.7 0 0 1 1.517 2.68 11.36 11.36 0 0 1 .494 3.387h-16.508c.352-2.645 1.269-4.656 2.751-6.173Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M199.544 26.8h4.198c.378-.019.752.093 1.058.317.268.198.475.467.599.776l5.821 19.542c.141.74.282 1.41.423 2.08.155.676.272 1.359.353 2.047.176-.706.352-1.376.564-2.046.088-.278.169-.556.253-.839.117-.399.237-.809.382-1.242l6.42-19.648c.073-.306.247-.58.494-.776.28-.191.613-.29.952-.282h2.328a1.8 1.8 0 0 1 .988.282c.246.204.429.473.529.776l6.279 19.648c.167.56.313 1.119.454 1.66l.063.24.047.18c.176.67.353 1.341.494 2.011.076-.481.17-.963.269-1.47l.119-.61c.104-.55.248-1.042.387-1.518l.001-.003c.048-.164.096-.327.141-.49l5.926-19.542a1.62 1.62 0 0 1 .564-.811 1.8 1.8 0 0 1 .988-.283h4.021l-9.841 30.371h-4.233c-.494 0-.847-.352-1.058-1.023l-6.738-20.6c-.141-.458-.282-.917-.388-1.41a37.862 37.862 0 0 1-.122-.608l-.001-.001c-.05-.258-.099-.507-.159-.767l-.317 1.41a7.04 7.04 0 0 1-.388 1.412l-6.808 20.564c-.212.67-.6 1.023-1.199 1.023h-4.022l-9.841-30.37ZM256.265 18.687c.217-.45.325-.946.317-1.446a3.76 3.76 0 0 0-.317-1.482 4.28 4.28 0 0 0-.847-1.234 4.162 4.162 0 0 0-1.235-.812 3.452 3.452 0 0 0-1.446-.317c-.5-.008-.995.1-1.446.317a3.587 3.587 0 0 0-1.199.812 4.26 4.26 0 0 0-.847 1.234 3.655 3.655 0 0 0-.282 1.482c-.019.497.077.992.282 1.446a4.3 4.3 0 0 0 2.046 2.046 3.21 3.21 0 0 0 1.446.282c.497.012.991-.084 1.446-.282a4.25 4.25 0 0 0 1.235-.847 3.72 3.72 0 0 0 .847-1.199ZM255.383 57.17V26.8h-5.362v30.37h5.362ZM285.965 29.057c.002.375-.07.747-.212 1.094-.133.34-.311.66-.529.952l-16.437 21.87h16.578v4.198h-22.857v-2.223c.014-.312.073-.621.176-.917.139-.366.329-.71.565-1.023l16.508-22.01h-16.332V26.8h22.54v2.257Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M309.528 27.223a13.614 13.614 0 0 0-5.009-.917 14.6 14.6 0 0 0-5.961 1.164 13.127 13.127 0 0 0-4.445 3.174 13.974 13.974 0 0 0-2.822 4.762 18.41 18.41 0 0 0-.952 5.962c-.04 2.359.317 4.708 1.058 6.949a14.527 14.527 0 0 0 3.034 5.079 12.449 12.449 0 0 0 4.585 3.104 15.488 15.488 0 0 0 5.785 1.094 18.234 18.234 0 0 0 3.351-.318 17.583 17.583 0 0 0 3.245-.846 14.146 14.146 0 0 0 2.928-1.447 9.793 9.793 0 0 0 2.399-2.08l-1.517-1.94a1.166 1.166 0 0 0-1.023-.53c-.432.05-.845.207-1.199.459-.569.373-1.157.715-1.764 1.022-.802.408-1.64.739-2.504.988a11.01 11.01 0 0 1-3.457.494 10.62 10.62 0 0 1-3.916-.705 8.544 8.544 0 0 1-2.998-2.152 10.754 10.754 0 0 1-1.975-3.563 17.09 17.09 0 0 1-.776-4.973h20.212a1.132 1.132 0 0 0 1.023-.424c.176-.282.282-.846.282-1.693.032-1.97-.291-3.93-.953-5.785a12.44 12.44 0 0 0-2.61-4.233 11.106 11.106 0 0 0-4.021-2.645Zm-10.97 5.256c1.446-1.517 3.492-2.258 6.067-2.258a7.828 7.828 0 0 1 3.245.635 6.66 6.66 0 0 1 2.434 1.728 7.635 7.635 0 0 1 1.482 2.681 10.36 10.36 0 0 1 .529 3.387h-16.544c.388-2.646 1.341-4.657 2.787-6.173ZM70.114 1h-70v71h70V1Zm-54 54.801h37.39v-7.055H23.17V17h-7.055v38.801ZM38.337 17h-7.055v24.339h7.055V17Zm15.167 24.339H46.45V17h7.054v24.339Z",
  fill: "currentColor"
}));

const MultiSelectDownshift = ({
  selectedItems = [],
  initialSelectedItems,
  onChange,
  itemCount,
  itemToString,
  closeOnSelect = false,
  initialIsOpen,
  onOuterClick,
  children,
  inputValue = "",
  ...props
}) => {
  const [selectedItemsInternal, setSelectedItemsInternal] = useState(selectedItems);
  useEffect(() => {
    if (onChange) {
      onChange(selectedItemsInternal);
    }
  }, [selectedItemsInternal]);
  useEffect(() => {
    setSelectedItemsInternal(selectedItems);
  }, [selectedItems]);
  const stateReducer = (state, changes) => {
    switch (changes.type) {
      case Downshift.stateChangeTypes.keyDownEnter:
      case Downshift.stateChangeTypes.clickItem:
        return {
          ...changes,
          highlightedIndex: state.highlightedIndex,
          isOpen: !closeOnSelect,
          inputValue: inputValue
        };
      default:
        return changes;
    }
  };
  const handleSelection = (selectedItem, _stateAndHelpers) => {
    if (selectedItem === null) {
      return;
    }
    const itemExists = selectedItemsInternal.findIndex(item => item.value === selectedItem.value) > -1;
    if (itemExists) {
      removeItem(selectedItem);
    } else {
      addSelectedItem(selectedItem);
    }
  };
  const removeItem = item => {
    const propsSelectedItems = selectedItems;
    setSelectedItemsInternal((propsSelectedItems || selectedItemsInternal).filter(i => i.value !== item.value));
  };
  const clearSelection = () => {
    setSelectedItemsInternal([]);
    onChange(selectedItems);
  };
  const addSelectedItem = item => {
    setSelectedItemsInternal([...selectedItemsInternal, item]);
  };
  const getStateAndHelpers = downshift => {
    const propsSelectedItems = selectedItems;
    return {
      ...downshift,
      selectedItems: propsSelectedItems || selectedItemsInternal,
      clearSelection,
      handleSelection
    };
  };
  return /*#__PURE__*/React.createElement(Downshift, Object.assign({}, props, {
    stateReducer: stateReducer,
    // @ts-ignore
    onChange: handleSelection,
    selectedItem: null,
    onOuterClick: onOuterClick,
    itemToString: itemToString
  }), /* @ts-ignore */ // This needs to be one block as the component is expecting a single child element.
  /* @ts-ignore */ // This needs to be one block as the component is expecting a single child element.
  downshift => children(getStateAndHelpers(downshift)));
};

const SelectInput = styled.input`
  outline: none;
  border: none;
  background: transparent;
  &:focus {
    border: none;
    outline: none;
    box-shadow: none;
    background: transparent;
  }
`;

const SelectItem = ({
  item,
  isSelected,
  noData,
  isFocused,
  ...props
}) => /*#__PURE__*/React.createElement(Box, Object.assign({
  p: "sp8",
  _hover: {
    bg: !noData && "neutrals.30",
    cursor: !noData && "pointer"
  }
}, props, {
  bg: isSelected ? "brand.200" : isFocused ? "neutrals.30" : "neutrals.0"
}), !noData && /*#__PURE__*/React.createElement(Text, {
  fontWeight: "regular",
  "data-testid": item && `item-${item.value}`
}, item.text ? item.text : item.value), noData && /*#__PURE__*/React.createElement(Flex, {
  flexDir: "column",
  alignItems: "center",
  "data-testid": "item-not-found"
}, /*#__PURE__*/React.createElement(Text, {
  fontWeight: "regular",
  color: "neutrals.200",
  fontSize: "sm"
}, "No match found"), /*#__PURE__*/React.createElement(Text, {
  fontWeight: "regular",
  color: "neutrals.200",
  fontSize: "sm"
}, "Try modifying your search")));

const MultiSelectItem = ({
  item,
  isSelected,
  isFocused,
  ...props
}) => /*#__PURE__*/React.createElement(Flex, Object.assign({
  p: "sp8",
  _hover: {
    bg: "neutrals.30",
    cursor: "pointer"
  }
}, props, {
  bg: isSelected ? "brand.200" : isFocused ? "neutrals.30" : "neutrals.0",
  alignItems: "center"
}), /*#__PURE__*/React.createElement(Flex, {
  justifyContent: "center",
  alignItems: "center",
  bg: isSelected ? "brand.400" : "neutrals.0",
  border: "1px solid",
  borderColor: isSelected ? "brand.400" : "neutrals.100",
  boxSize: "16px",
  borderRadius: "xxs",
  mr: "sp8"
}, isSelected && /*#__PURE__*/React.createElement(Icon, {
  icon: "fa-check",
  variant: "solid",
  color: "neutrals.0",
  boxSize: "16px"
})), item.text || item.value);

const FilteredItems = ({
  items,
  inputValue,
  highlightedIndex,
  selectedItems,
  getItemProps,
  isMulti,
  isFiltered = false
}) => {
  let filtered = items;
  if (isFiltered) {
    filtered = items.filter(item => !inputValue || item.text && item.text.toLowerCase().includes(inputValue.toLowerCase()));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, filtered.length > 0 ? filtered.map((item, index) => isMulti ? /*#__PURE__*/React.createElement(MultiSelectItem, Object.assign({}, getItemProps({
    key: item.value,
    isSelected: selectedItems.find(selectedItem => selectedItem.value === item.value) !== undefined,
    index,
    item
  }), {
    isFocused: highlightedIndex === index,
    item: item,
    key: item.value
  })) : /*#__PURE__*/React.createElement(SelectItem, Object.assign({}, getItemProps({
    key: item.value,
    index,
    item
  }), {
    isFocused: highlightedIndex === index,
    isSelected: selectedItems && selectedItems.length > 0 && selectedItems[0].value === item.value,
    item: item
  }))) : /*#__PURE__*/React.createElement(SelectItem, {
    noData: true
  }));
};

const SelectButton = props => {
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    variant: "ghost"
  }, props));
};
const MultiSelect = ({
  placeholder,
  clearAllButtonText,
  onChange,
  items = [],
  selectedItems: selectedItemProps,
  initialSelectedItems,
  itemToString = item => item ? item.value : "",
  disabled,
  label,
  showPills,
  isLabelExternal,
  canClearAll,
  isClearExternal,
  inputValue = "",
  isFiltered,
  handleClearAll = () => onChange([])
}) => {
  const {
    t
  } = useTranslation();
  const [searchValue, setSearchValue] = useState(inputValue);
  const handleChange = selection => {
    if (!selection) {
      return;
    }
    onChange(selection);
  };
  return /*#__PURE__*/React.createElement(Box, {
    height: "40px"
  }, /*#__PURE__*/React.createElement(MultiSelectDownshift, {
    onChange: handleChange,
    itemToString: itemToString,
    initialSelectedItems: initialSelectedItems,
    selectedItems: selectedItemProps,
    closeOnSelect: false,
    inputValue: searchValue
  }, ({
    getItemProps,
    getLabelProps,
    getMenuProps,
    getToggleButtonProps,
    getInputProps,
    isOpen,
    getRootProps,
    highlightedIndex,
    selectedItems
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, isLabelExternal && /*#__PURE__*/React.createElement(Text, Object.assign({}, getLabelProps()), label), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box
  // @ts-ignore
  , Object.assign({}, getRootProps({}, {
    suppressRefError: true
  })), /*#__PURE__*/React.createElement(SelectButton, Object.assign({}, getToggleButtonProps(), {
    isDisabled: disabled,
    "aria-label": "toggle menu",
    rightIcon: /*#__PURE__*/React.createElement(Icon, {
      icon: "fa-chevron-down"
    }),
    mr: "sp4",
    color: "neutrals.900",
    fontWeight: "regular",
    border: "1px",
    borderColor: "neutrals.50",
    height: "40px",
    bgColor: "neutrals.0",
    _hover: {
      bgColor: "neutrals.20"
    },
    _focus: {
      border: "1px solid brand.500"
    },
    justifyContent: "space-between"
  }), isOpen && /*#__PURE__*/React.createElement(SelectInput, Object.assign({
    "data-testid": "multiselectInput",
    placeholder: placeholder || "Select",
    autoFocus: true
  }, getInputProps(), {
    value: searchValue,
    onChange: e => {
      setSearchValue(e.target.value);
    }
  })), !isOpen && isLabelExternal && (!showPills ? /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    mr: "sp4"
  }, /*#__PURE__*/React.createElement(Text, null, selectedItems.length > 0 ? selectedItems[0].text || selectedItems[0].value : placeholder || "Select")), selectedItems.length > 1 && !showPills && /*#__PURE__*/React.createElement(Tag, {
    tagLabel: `+${selectedItems.length - 1}`,
    variant: "dark"
  })) : placeholder || "Select"), !isOpen && !isLabelExternal && (selectedItems.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mr: "sp4"
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "medium"
  }, `${label} ${selectedItems[0].text || selectedItems[0].value}`)), selectedItems.length > 1 && /*#__PURE__*/React.createElement(Tag, {
    tagLabel: `+${selectedItems.length - 1}`,
    variant: "dark"
  })) : placeholder || "Select"))), isOpen && /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    zIndex: "1"
  }, /*#__PURE__*/React.createElement(Box, Object.assign({}, getMenuProps(), {
    shadow: "dropdown",
    position: "absolute",
    width: "100%",
    bg: "neutrals.0",
    maxHeight: "300px",
    overflowY: items.length > 8 ? "scroll" : "hidden"
  }), /*#__PURE__*/React.createElement(FilteredItems, {
    items: items,
    inputValue: searchValue,
    highlightedIndex: highlightedIndex,
    selectedItems: selectedItems,
    getItemProps: getItemProps,
    isMulti: true,
    isFiltered: isFiltered
  }), canClearAll && !isClearExternal && /*#__PURE__*/React.createElement(Box, {
    borderTop: "1px solid",
    borderTopColor: "neutrals.30",
    position: "sticky",
    bottom: "0px",
    bg: "neutrals.0",
    justifyContent: "start"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    onClick: handleClearAll
  }, clearAllButtonText || t("Clear All")))))), /*#__PURE__*/React.createElement(Box, null, showPills && selectedItems && /*#__PURE__*/React.createElement(Flex, {
    mr: "sp8"
  }, selectedItems.map(item => /*#__PURE__*/React.createElement(Box, {
    mr: "sp8"
  }, /*#__PURE__*/React.createElement(Tag, {
    isRemovable: true,
    onRemoveClick: () => handleChange(selectedItems.filter(i => i.value !== item.value)),
    tagLabel: item.text || item.value,
    variant: "dark",
    key: item.value
  }))))), canClearAll && isClearExternal && /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    onClick: handleClearAll
  }, clearAllButtonText || t("Clear All"))))));
};

const ButtonContainer = styled.button`
  position: absolute;
  right: 8px;
  font-family: ${fonts.paragraphs};
  font-size: ${fontSizes.md};
  font-weight: 500;
  cursor: pointer;
  z-index: 1;
  color: ${props => props.disabled ? `${colors.neutrals[100]}` : `${colors.brand[500]}`};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
const PasswordContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
const PasswordInput = /*#__PURE__*/React.forwardRef(({
  isRequired,
  errorMessage,
  name,
  label,
  helperLinkText,
  helperLinkURL,
  helperText,
  isHelperLinkExternal,
  isDisabled,
  ...props
}, ref) => {
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);
  return /*#__PURE__*/React.createElement(FormWrapper, {
    isRequired: isRequired,
    errorMessage: errorMessage,
    name: name,
    label: label,
    helperText: helperText,
    helperLinkText: helperLinkText,
    helperLinkURL: helperLinkURL,
    isHelperLinkExternal: isHelperLinkExternal
  }, /*#__PURE__*/React.createElement(PasswordContainer, null, /*#__PURE__*/React.createElement(Input, Object.assign({
    ref: ref,
    placeholder: "Enter Password",
    "data-testid": "password-input",
    type: show ? "text" : "password"
  }, props)), /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: handleClick,
    disabled: isDisabled
  }, show ? "Hide" : "Show")));
});

const PinInput = ({
  onChange,
  onComplete,
  errorMessage,
  ...props
}) => /*#__PURE__*/React.createElement(FormWrapper, Object.assign({
  errorMessage: errorMessage
}, props), /*#__PURE__*/React.createElement(PinInput$1, Object.assign({}, props, {
  onChange: onChange,
  onComplete: onComplete,
  placeholder: "",
  mask: true
}), /*#__PURE__*/React.createElement(PinInputField, null), /*#__PURE__*/React.createElement(PinInputField, null), /*#__PURE__*/React.createElement(PinInputField, null), /*#__PURE__*/React.createElement(PinInputField, null), /*#__PURE__*/React.createElement(PinInputField, null), /*#__PURE__*/React.createElement(PinInputField, null)));

const errorMessageStylingProps$1 = {
  color: "accent.red.500",
  fontSize: "sm",
  fontFamily: "paragraphs",
  fontWeight: "regular"
};
const Radio = ({
  children,
  isRequired,
  name,
  errorMessage,
  ...props
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Radio$1, Object.assign({}, props, {
  isInvalid: !!errorMessage
}), /*#__PURE__*/React.createElement(FormControl, {
  isRequired: isRequired
}, /*#__PURE__*/React.createElement(FormLabel, {
  htmlFor: name
}, children))), !!errorMessage && /*#__PURE__*/React.createElement(Box, Object.assign({}, errorMessageStylingProps$1), errorMessage));

const RadioGroup = ({
  children,
  direction = "row",
  ...props
}) => /*#__PURE__*/React.createElement(RadioGroup$1, Object.assign({}, props), /*#__PURE__*/React.createElement(Stack, {
  direction: direction,
  spacing: direction == "column" ? "12px" : "20px"
}, children));

const Container$1 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid var(--chakra-colors-neutrals-50);
  padding: 0 4px 0 12px;
  border-radius: var(--chakra-radii-md);

  :focus-within {
    outline: "none";
    z-index: 1;
    background-color: var(--chakra-colors-neutrals-0);
    border: 1px solid var(--chakra-colors-brand-400);
    box-shadow: 0px 0px 3px 0px var(--chakra-colors-brand-400);
  }
`;
const StyledSearchIcon = /*#__PURE__*/styled(SearchIcon$1)`
  color: var(--chakra-colors-neutrals-0);
`;
const StyledIconButton = /*#__PURE__*/styled(IconButton)`
  padding: 9px;
  :focus {
    box-shadow: none;
  }
`;
const Input$1 = /*#__PURE__*/styled(Input)`
  border: none;
  padding-right: 0;
  padding-left: 0;

  :focus {
    outline: "none";
    z-index: 1;
    background-color: transparent;
    box-shadow: none;
    border: none;
  }
`;
const SearchIcon = /*#__PURE__*/styled(SearchIcon$1)`
  margin-right: 12px;
  color: var(--chakra-colors-neutrals-200);
`;
const CloseButton = /*#__PURE__*/styled(Button)`
  padding: var(--chakra-space-2);
  background-color: var(--chakra-colors-neutrals-0);
  border-radius: var(--chakra-radii-round);
  height: 25px;
  width: 25px;
  margin-right: 8px;
  min-width: unset;
  :focus {
    box-shadow: none;
  }
`;
const SearchBox = ({
  onClear,
  value,
  onSearchClick = () => {},
  variant = "default",
  placeholder = "",
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Container$1, {
    "aria-disabled": props.isDisabled
  }, variant === "default" && /*#__PURE__*/React.createElement(SearchIcon, null), /*#__PURE__*/React.createElement(Input$1, Object.assign({
    placeholder: placeholder,
    "data-testid": props.name && `${props.name}-input`,
    value: value
  }, props)), /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onClear,
    "aria-label": t("clear search"),
    "data-testid": props.name && `${props.name}-clearSearchButton`,
    visibility: value ? "visible" : "hidden"
  }, /*#__PURE__*/React.createElement(CloseIcon$1, {
    h: "10px",
    w: "10px"
  })), variant !== "default" && /*#__PURE__*/React.createElement(StyledIconButton, {
    size: "default",
    icon: /*#__PURE__*/React.createElement(StyledSearchIcon, null),
    onClick: onSearchClick,
    "aria-label": t("clear search"),
    variant: props.searchIconColour || "primary",
    "data-testid": props.name && `${props.name}-searchButton`,
    disabled: props.searchButtonDisabled || props.isDisabled
  }));
};

const Table = /*#__PURE__*/React.forwardRef(({
  variant = "simple",
  style,
  children,
  ...props
}, ref) => /*#__PURE__*/React.createElement(Table$1, Object.assign({
  variant: variant,
  style: style
}, props, {
  ref: ref
}), children));

const SelectorContainer = /*#__PURE__*/styled("div", {
  shouldForwardProp: prop => prop !== "open" && prop !== "disabled"
})`
  position: relative;
  border: ${props => props.disabled ? `1px solid ${theme.colors.neutrals[50]}` : props.open ? `1px solid ${theme.colors.brand[400]}` : `1px solid ${theme.colors.neutrals[60]}`};
  box-sizing: border-box;
  border-radius: 6px;
  padding: ${theme.space.sp4};
  display: flex;
  cursor: ${props => props.disabled ? "default" : "text"};
  user-select: none;
  transition: 0.2s all;
  flex-wrap: wrap;
  align-items: start;
  box-shadow: ${props => props.open ? `0px 0px 0px 3px ${theme.colors.brand[300]}` : "none"};
  background-color: ${theme.colors.neutrals[0]};
`;

const OptionContainer = /*#__PURE__*/styled("a", {
  shouldForwardProp: prop => prop !== "selected" && prop !== "indent" && prop !== "pointer"
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: ${theme.space.sp4};
  margin-bottom: ${theme.space.sp4};
  background: ${props => props.selected ? theme.colors.brand[200] : "none"};
  padding-top: ${theme.space.sp2};
  padding-left: ${props => props.indent ? `${props.indent * 16}px` : "0px"};
  cursor: ${props => props.pointer ? "pointer" : "default"};
  text-decoration: none;
  :hover {
    text-decoration: none;
    ${props => !props.selected && !props.disabled && `background: ${theme.colors.brand[100]}`};
  }
`;

const OptionImgContainer = /*#__PURE__*/styled("div")`
  height: 100%;
  width: ${theme.space.sp16};
  display: flex;
  align-items: center;
  margin-right: ${theme.space.sp4};
  cursor: pointer;
`;
const OptionItemImage = /*#__PURE__*/styled("img")`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;
const OptionImage = /*#__PURE__*/forwardRef$1(({
  src = "",
  alt = "",
  loading,
  ...props
}, ref) => {
  if (typeof src === "string") {
    const [imageSrc, setImageSrc] = useState(undefined);
    useEffect(() => {
      const image = new Image();
      image.src = src;
      image.onload = () => {
        setImageSrc(src);
      };
      return () => {
        image.onload = () => {};
      };
    }, []);
    return /*#__PURE__*/React.createElement(OptionImgContainer, Object.assign({}, props, {
      ref: ref
    }), /*#__PURE__*/React.createElement(OptionItemImage, {
      draggable: false,
      src: imageSrc,
      loading: loading,
      "aria-label": `${alt} icon`
    }));
  }
  return /*#__PURE__*/React.createElement(OptionImgContainer, Object.assign({}, props, {
    ref: ref
  }), src);
});

const OptionName = /*#__PURE__*/styled("button", {
  shouldForwardProp: prop => prop !== "selected" && prop !== "disabled" && prop !== "noUnderline"
})`
  cursor: ${props => props.selected || props.disabled ? "default" : "pointer"};
  opacity: ${props => props.disabled ? 0.3 : 1};
  :hover {
    text-decoration: ${props => props.selected || props.disabled || props.noUnderline ? "none" : "underline"};
  }
  padding: ${theme.space.sp2};
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
`;

const ArrowRightIcon = ({
  color,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.76562 4.48438L10.7656 7.46094C10.9062 7.625 11 7.8125 11 8C11 8.16406 10.9062 8.375 10.7656 8.51562L7.76562 11.4922C7.55469 11.7031 7.22656 11.7734 6.94531 11.6562C6.66406 11.5391 6.5 11.3047 6.5 11V5C6.5 4.71875 6.66406 4.4375 6.94531 4.32031C7.22656 4.20312 7.55469 4.27344 7.76562 4.48438Z",
    fill: color
  }));
};

const OptionArrowPlaceholder = /*#__PURE__*/styled("div")`
  display: flex;
  align-items: center;
  width: 32px;
  height: 32px;
`;
const OptionItemArrow = /*#__PURE__*/styled("div", {
  shouldForwardProp: prop => prop !== "open"
})`
  padding: ${theme.space.sp8};
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: 0.2s all;
  transform: ${props => props.open ? "rotate(90deg)" : "rotate(0deg)"};
`;
const OptionNameCharacter = /*#__PURE__*/styled("span", {
  shouldForwardProp: prop => prop !== "highlighted"
})`
  color: ${theme.colors.text.title};
  font-weight: ${props => !props.highlighted ? theme.fontWeights.medium : theme.fontWeights.bold};
`;
function SelectorOption({
  option,
  indent = 0,
  arrowOpen = false,
  showArrow = false,
  isHierarchy = false,
  selected = false,
  disabled = false,
  search = "",
  imgLoading,
  showCheckboxes = false,
  onClick = () => {},
  onClickContainer = () => {},
  ...props
}) {
  const optionName = `${(option.label || option.text) ?? option.value}`;
  const optionNameElements = useMemo(() => {
    if (!search) {
      return /*#__PURE__*/React.createElement(OptionNameCharacter, null, optionName);
    }
    const searchIndex = optionName.toLowerCase().indexOf(search.toLowerCase());
    if (searchIndex === -1) {
      return /*#__PURE__*/React.createElement(OptionNameCharacter, null, optionName);
    }
    const maxIndex = searchIndex + search.length;
    return Array.from(optionName).map((letter, index) => {
      return /*#__PURE__*/React.createElement(OptionNameCharacter, {
        key: `${option.value}-letter-${index}`,
        highlighted: index >= searchIndex && index < maxIndex
      }, letter);
    });
  }, [search, option, optionName]);
  const handleClick = e => {
    e.preventDefault();
    onClick(e);
  };
  const handleClickContainer = e => {
    e.preventDefault();
    onClickContainer(e);
  };
  return /*#__PURE__*/React.createElement(OptionContainer, Object.assign({}, props, {
    selected: selected,
    indent: indent,
    onClick: handleClickContainer,
    href: "#",
    pointer: !isHierarchy && !disabled,
    disabled: disabled
  }), showArrow && /*#__PURE__*/React.createElement(OptionItemArrow, {
    open: arrowOpen
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, {
    color: theme.colors.neutrals[500]
  })), isHierarchy && !showArrow && /*#__PURE__*/React.createElement(OptionArrowPlaceholder, null), option.icon && /*#__PURE__*/React.createElement(OptionImage, {
    loading: imgLoading,
    src: option.icon,
    alt: `${option.label || option.value}`,
    onClick: handleClickContainer
  }), !showArrow && showCheckboxes ? /*#__PURE__*/React.createElement(MultiSelectItem, {
    isSelected: selected,
    isFocused: false,
    item: {
      value: "" + option.value,
      text: option.label
    }
  }) : /*#__PURE__*/React.createElement(OptionName, {
    selected: selected,
    disabled: disabled,
    onClick: handleClick,
    noUnderline: !isHierarchy
  }, optionNameElements));
}

const OptionPopupContainer = /*#__PURE__*/styled("div")`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${theme.space.sp8};
  background: ${theme.colors.neutrals[0]};
  box-shadow: 0px 0px 1px rgba(9, 30, 67, 0.2),
    0px 18px 28px rgba(9, 30, 67, 0.1);
  border-radius: 6px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 2147483647;
  cursor: default;
  width: 100%;
  top: calc(100% + 2px);
  left: 0;
`;

const OptionPopupList = /*#__PURE__*/styled("ul")`
  list-style-type: none;
  margin: 0px;
  padding: 0px;
  width: 100%;
`;

const OptionPopupListItem = /*#__PURE__*/styled("li")`
  margin: 0px;
  padding: 0px;
  width: 100%;
`;

function SelectorDropdown({
  options = [],
  search = "",
  selected = [],
  onClickOption = () => {},
  id,
  pageIncrement = 20,
  startingPageCount = 60,
  showDropdown = true,
  startContent,
  endContent,
  imgLoading,
  disableNoContentText,
  ...props
}) {
  const [page, setPage] = useState(0);
  const dropdownEl = useRef(null);
  const handleScroll = () => {
    if (!dropdownEl.current) return;
    if (options.length <= page * pageIncrement + startingPageCount) return;
    const {
      scrollTop,
      scrollHeight,
      clientHeight
    } = dropdownEl.current;
    if (scrollTop + clientHeight + 100 > scrollHeight) {
      setPage(page + 1);
    }
  };
  const handleClickOption = (option, e) => {
    e.stopPropagation();
    e.preventDefault();
    if (option.disabled) return;
    onClickOption(option, e);
  };
  // Only show top-level options that dont have a cateogry
  // ( children will be rendered by the items themselves )
  const shownOptions = useMemo(() => {
    return options.filter(o => !o.category).slice(0, startingPageCount + pageIncrement * page);
  }, [options, page, pageIncrement, startingPageCount]);
  return showDropdown === false ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(OptionPopupContainer, Object.assign({}, props, {
    "aria-describedby": "option list popup",
    ref: dropdownEl,
    onScroll: handleScroll
  }), startContent, /*#__PURE__*/React.createElement(OptionPopupList, {
    role: "listbox"
  }, shownOptions.length !== 0 ? shownOptions.map((option, index) => /*#__PURE__*/React.createElement(OptionPopupListItem, {
    role: "option",
    "aria-selected": selected.includes(option.value),
    key: `selector-option-${index}-${option.value}`,
    "data-testid": `option-${index}-${option.value}`
  }, /*#__PURE__*/React.createElement(SelectorOption, {
    imgLoading: imgLoading,
    option: option,
    selected: selected.includes(option.value),
    disabled: option.disabled,
    search: search,
    onClickContainer: e => handleClickOption(option, e),
    onClick: e => handleClickOption(option, e)
  }))) : disableNoContentText ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(Flex, {
    flexDir: "column",
    alignItems: "center",
    "data-testid": "item-not-found"
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "regular",
    color: "neutrals.200",
    fontSize: "sm"
  }, "No match found"), /*#__PURE__*/React.createElement(Text, {
    fontWeight: "regular",
    color: "neutrals.200",
    fontSize: "sm"
  }, "Try modifying your search"))), endContent);
}

const ChevronDownIcon = ({
  color,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.60156 11.4531C7.8125 11.6641 8.16406 11.6641 8.375 11.4531L12.9453 6.90625C13.1562 6.67188 13.1562 6.32031 12.9453 6.10938L12.4062 5.57031C12.1953 5.35938 11.8438 5.35938 11.6094 5.57031L8 9.17969L4.36719 5.57031C4.13281 5.35938 3.78125 5.35938 3.57031 5.57031L3.03125 6.10938C2.82031 6.32031 2.82031 6.67188 3.03125 6.90625L7.60156 11.4531Z",
    fill: color
  }));
};

const CloseIcon = ({
  color,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.51562 9.48438C7.82031 9.76562 7.82031 10.2578 7.51562 10.5391C7.375 10.6797 7.1875 10.75 7 10.75C6.78906 10.75 6.60156 10.6797 6.46094 10.5391L4 8.07812L1.51562 10.5391C1.375 10.6797 1.1875 10.75 1 10.75C0.789062 10.75 0.601562 10.6797 0.460938 10.5391C0.15625 10.2578 0.15625 9.76562 0.460938 9.48438L2.92188 7L0.460938 4.53906C0.15625 4.25781 0.15625 3.76562 0.460938 3.48438C0.742188 3.17969 1.23438 3.17969 1.51562 3.48438L4 5.94531L6.46094 3.48438C6.74219 3.17969 7.23438 3.17969 7.51562 3.48438C7.82031 3.76562 7.82031 4.25781 7.51562 4.53906L5.05469 7.02344L7.51562 9.48438Z",
    fill: color
  }));
};

const SelectorRawInput = /*#__PURE__*/styled("input")`
  font-style: normal;
  font-weight: ${theme.fontWeights.medium};
  font-size: ${theme.fontSizes.md};
  outline: none;
  border: none;
  flex-grow: 1;
  background-color: rgba(0, 0, 0, 0);
  ::placeholder {
    color: ${props => props.disabled ? theme.colors.neutrals[50] : theme.colors.neutrals[200]};
  }
  ${props => props.disabled && `color: ${theme.colors.neutrals[60]}`};
`;
const SelectorInputContainer = /*#__PURE__*/styled("div")`
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding: ${theme.space.sp4};
  margin: ${theme.space.sp2};
`;
const CloseButton$1 = /*#__PURE__*/styled("button")`
  border: none;
  padding: none;
  cursor: ${props => props.disabled ? "default" : "pointer"};
`;
const DropdownButton = /*#__PURE__*/styled("button")`
  border: none;
  padding: none;
  cursor: ${props => props.disabled || !props.onClick ? "default" : "pointer"};  
`;
const DropdownIcon = /*#__PURE__*/styled(ChevronDownIcon, {
  shouldForwardProp: prop => prop !== "open"
})`
  transition: 0.2s all;
  transform: ${props => props.open ? "rotate(180deg)" : "rotate(0deg)"};
  padding: 0;
  margin: 0;
`;
const SelectorInput = /*#__PURE__*/forwardRef$1(({
  open = false,
  showClearIcon = false,
  onClear = () => {},
  disabled = false,
  name,
  showDropdownIcon = true,
  onDropdownButtonClick,
  ...props
}, ref) => {
  return /*#__PURE__*/React.createElement(SelectorInputContainer, null, /*#__PURE__*/React.createElement(SelectorRawInput, Object.assign({}, props, {
    name: name,
    ref: ref,
    type: "text",
    autoComplete: "off",
    "aria-haspopup": "listbox",
    "aria-expanded": open,
    disabled: disabled,
    role: "textbox"
  })), showClearIcon && /*#__PURE__*/React.createElement(CloseButton$1, {
    onClick: onClear,
    disabled: disabled,
    "data-testid": "closeButton"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    color: disabled ? theme.colors.neutrals[50] : theme.colors.neutrals[300]
  })), showDropdownIcon && /*#__PURE__*/React.createElement(DropdownButton, {
    onClick: onDropdownButtonClick,
    "data-testid": "dropdownButton",
    type: "button"
  }, /*#__PURE__*/React.createElement(DropdownIcon, {
    open: open,
    color: disabled ? theme.colors.neutrals[50] : theme.colors.neutrals[80]
  })));
});

/** Check if option matches search keyword */
const matchesSearch = (option, search) => {
  const optionName = option.label || option.value;
  return optionName.toString().toLowerCase().includes(search);
};
/** Check if child option matches search in hierarchy */
const childMatchesSearch = (option, search, options) => {
  const children = options.filter(o => o.category === option.value);
  return children.some(child => {
    if (matchesSearch(child, search)) return true;
    return childMatchesSearch(child, search, options);
  });
};
/** Check if parent option matches search in hierarchy */
const parentMatchesSearch = (option, search, options) => {
  if (!option.category) return false;
  const parent = options.find(o => o.value === option.category);
  if (!parent) return false;
  if (matchesSearch(parent, search)) return true;
  return parentMatchesSearch(parent, search, options);
};
/** Check if sibling option matches search in a hierarchy */
const siblingMatchesSearch = (option, search, options) => {
  if (!option.category) return false;
  const siblings = options.filter(o => o.category === option.category);
  return siblings.some(s => matchesSearch(s, search));
};
/** Check if parent's sibling matches the search */
const parentSiblingMatchesSearch = (option, search, options) => {
  if (!option.category) return false;
  const parent = options.find(o => o.value === option.category);
  if (!parent) return false;
  const siblings = options.filter(o => o.category === parent.category);
  return siblings.some(s => matchesSearch(s, search));
};

function SingleSearchSelector({
  options = [],
  selected = null,
  onChange = () => {},
  searchDelay = 200,
  placeholder = "Select Single",
  name = "Single Selector",
  id,
  onClick = () => {},
  keepOpen = false,
  pageIncrement,
  startingPageCount,
  type,
  autoComplete,
  disabled,
  showDropdownIcon = true,
  showDropdown = true,
  showClearIcon = true,
  onInputChange = () => {},
  startContent,
  endContent,
  imgLoading = "lazy",
  onSearch = () => {},
  filterOptions = true,
  disableNoContentText = false,
  clearInputOnSelect = false,
  clearInput = false,
  ...props
}) {
  const inputEl = useRef(null);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [search, setSearch] = useState("");
  const [shownOptions, setShownOptions] = useState([]);
  const containerEl = useRef(null);
  const isHierarchy = useMemo(() => options.some(o => o.category !== undefined), [options]);
  const handleFocus = () => {
    setOpen(true);
  };
  // Focus the input whenever the container element is clicked
  const handleClickContainer = e => {
    onClick(e);
    if (inputEl.current) {
      inputEl.current.focus();
    }
  };
  const handleClickInput = e => {
    onClick(e);
    setOpen(true);
  };
  // Handle changing input value
  const handleChangeInputValue = e => {
    setInputValue(e.target.value);
    onInputChange(e);
    const matchingOption = options.find(o => {
      const name = `${o.label ?? o.value}`;
      return name === e.target.value;
    });
    if (matchingOption) {
      onChange(matchingOption, e);
      return;
    }
    setOpen(true);
    onChange(null, e);
  };
  // Handle the addition of a selected option
  const handleSelectOption = (option, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (inputEl.current) {
      if (keepOpen) {
        inputEl.current.focus();
      } else {
        inputEl.current.blur();
        setOpen(false);
      }
    }
    if (option.disabled) return;
    onChange(option, e);
    if (clearInputOnSelect) {
      setInputValue("");
    }
  };
  // Handle the removal of a selected option
  const handleClearOption = e => {
    e.preventDefault();
    e.stopPropagation();
    onChange(null, e);
    setInputValue("");
    if (inputEl.current) {
      inputEl.current.focus();
    }
  };
  // Toggles menu open state on click of dropdown arrow
  const handleDropdownButtonClick = e => {
    e.stopPropagation();
    setOpen(!open);
  };
  useEffect(() => {
    const lcaseSearch = search.toLowerCase();
    if (!lcaseSearch || !filterOptions) {
      // If no search keyword, or the filtering option is turned off, show all options
      setShownOptions(options);
    } else {
      // If options are not hierarchical then do faster search
      setShownOptions(options.filter(o => matchesSearch(o, lcaseSearch)).sort((a, b) => {
        const aName = `${a.label || a.value}`;
        const bName = `${b.label || b.value}`;
        if (aName.toLowerCase() === lcaseSearch) {
          return -1;
        }
        if (bName.toLowerCase() === lcaseSearch) {
          return 1;
        }
        return 0;
      }));
    }
  }, [options, search, isHierarchy]);
  // Only affect search if the input value has not changed
  // within the last x ms for performance
  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearch(inputValue);
      onSearch(inputValue);
    }, searchDelay);
    return () => {
      clearTimeout(timeout);
    };
  }, [inputValue, searchDelay]);
  // Detect clicking outside of selector container and set open to false
  useEffect(() => {
    const handleClick = e => {
      if (!containerEl.current) return;
      if (!e.target) return;
      if (containerEl.current.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [containerEl]);
  useEffect(() => {
    if (selected) {
      const newInput = `${selected.label ?? selected.value}`;
      setInputValue(newInput);
    }
  }, [selected]);
  useEffect(() => {
    if (open) return;
    // If dialog is closed, clear the input if its not selected
    if (!selected) {
      setInputValue("");
    }
  }, [open, selected]);
  useEffect(() => {
    if (!clearInput) return;
    setInputValue("");
  }, [clearInput]);
  return /*#__PURE__*/React.createElement(SelectorContainer, Object.assign({}, props, {
    onClick: handleClickContainer,
    open: open,
    ref: containerEl,
    id: id ? `${id}-container` : undefined,
    "data-testid": id ? `${id}-container` : undefined,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(SelectorInput, {
    open: open,
    ref: inputEl,
    placeholder: placeholder,
    onFocus: handleFocus,
    value: selected && selected.text || inputValue,
    onChange: handleChangeInputValue,
    name: name,
    id: id ? `${id}-input` : undefined,
    "data-testid": id ? `${id}-input` : undefined,
    onClick: handleClickInput,
    showClearIcon: showClearIcon && !!inputValue,
    onClear: handleClearOption,
    type: type,
    autoComplete: autoComplete,
    disabled: disabled,
    showDropdownIcon: showDropdownIcon,
    onDropdownButtonClick: handleDropdownButtonClick
  }), open && /*#__PURE__*/React.createElement(SelectorDropdown, {
    startContent: startContent,
    endContent: endContent,
    options: shownOptions,
    search: search,
    selected: selected ? [selected.value] : [],
    onClickOption: handleSelectOption,
    id: id ? `${id}-dropdown` : undefined,
    "data-testid": id ? `${id}-dropdown` : undefined,
    pageIncrement: pageIncrement,
    startingPageCount: startingPageCount,
    showDropdown: showDropdown,
    imgLoading: imgLoading,
    disableNoContentText: disableNoContentText
  }));
}

const SelectedName = /*#__PURE__*/styled("div")`
  font-style: normal;
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes.md};
  display: flex;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  padding-right: ${theme.space.sp4};
`;
const SelectedIcon = /*#__PURE__*/styled("div")`
  padding-left: ${theme.space.sp2};
  padding-right: ${theme.space.sp2};
  display: flex;
  align-items: center;
  justify-content: center;
`;
const SelectorChip = ({
  name,
  id,
  disabled,
  color,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Link, Object.assign({}, props, {
    href: "#",
    id: id ? `${id}-chip` : undefined,
    "data-testid": `${id ?? ""}-chip`,
    backgroundColor: color && !disabled ? color : disabled ? "neutrals.50" : "neutrals.300",
    borderRadius: "4px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "sp4",
    paddingLeft: "sp8",
    paddingRight: "sp4",
    color: "neutrals.0",
    margin: "sp2",
    width: "auto",
    cursor: disabled ? "default" : "pointer",
    textDecoration: "none",
    _hover: {
      textDecoration: "none",
      color: "neutrals.0"
    }
  }), /*#__PURE__*/React.createElement(SelectedName, null, name), /*#__PURE__*/React.createElement(SelectedIcon, null, /*#__PURE__*/React.createElement(CloseIcon, {
    color: theme.colors.neutrals[0]
  })));
};

function MultiSearchSelector({
  options = [],
  selected = [],
  onChange = () => {},
  searchDelay = 200,
  placeholder = "Select Multiple",
  name = "Multiple Selector",
  id,
  onClick = () => {},
  pageIncrement,
  startingPageCount,
  type,
  autoComplete,
  disabled,
  onInputChange = () => {},
  startContent,
  endContent,
  imgLoading = "lazy",
  onSearch = () => {},
  disableNoContentText,
  filterOptions = true,
  clearInputOnSelect = false,
  clearInput = false,
  ...props
}) {
  const inputEl = useRef(null);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [search, setSearch] = useState("");
  const [shownOptions, setShownOptions] = useState([]);
  const containerEl = useRef(null);
  const handleOpenDialog = () => {
    setOpen(true);
  };
  // Focus the input whenever the container element is clicked
  const handleClickContainer = e => {
    onClick(e);
    if (inputEl.current) {
      inputEl.current.focus();
    }
  };
  const handleClickInput = e => {
    onClick(e);
    setOpen(true);
  };
  // Handle changing input value
  const handleChangeInputValue = e => {
    setInputValue(e.target.value);
    onInputChange(e);
    setOpen(true);
  };
  // Handle the addition of a selected option
  const handleAddOption = (option, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (inputEl.current) {
      inputEl.current.focus();
    }
    if (selected.some(s => s.value === option.value)) return;
    if (option.disabled) return;
    onChange([...selected, option], e);
    if (clearInputOnSelect) {
      setInputValue("");
    }
  };
  // Handle the removal of a selected option
  const handleRemoveOption = (e, option) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    onChange(selected.filter(o => o.value !== option.value), e);
    if (inputEl.current) {
      inputEl.current.focus();
    }
  };
  // Toggles menu open state on click of dropdown arrow
  const handleDropdownButtonClick = e => {
    e.stopPropagation();
    setOpen(!open);
  };
  useEffect(() => {
    const lcaseSearch = search.toLowerCase();
    if (!lcaseSearch || !filterOptions) {
      // If no search keyword, or the filtering option is turned off show all options
      setShownOptions(options);
    } else {
      // If options are not hierarchical then do faster search
      setShownOptions(options.filter(o => matchesSearch(o, lcaseSearch)).sort((a, b) => {
        const aName = `${a.label || a.value}`;
        const bName = `${b.label || b.value}`;
        if (aName.toLowerCase() === lcaseSearch) {
          return -1;
        }
        if (bName.toLowerCase() === lcaseSearch) {
          return 1;
        }
        return 0;
      }));
    }
  }, [options, search]);
  // Only affect search if the input value has not changed
  // within the last x ms for performance
  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearch(inputValue);
      onSearch(inputValue);
    }, searchDelay);
    return () => {
      clearTimeout(timeout);
    };
  }, [inputValue, searchDelay]);
  // Detect clicking outside of selector container and set open to false
  useEffect(() => {
    const handleClick = e => {
      if (!containerEl.current) return;
      if (!e.target) return;
      if (containerEl.current.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [containerEl]);
  useEffect(() => {
    if (open) return;
    setInputValue("");
  }, [open]);
  useEffect(() => {
    if (!clearInput) return;
    setInputValue("");
  }, [clearInput]);
  return /*#__PURE__*/React.createElement(SelectorContainer, Object.assign({}, props, {
    onClick: handleClickContainer,
    open: open,
    ref: containerEl,
    id: id ? `${id}-container` : undefined,
    "data-testid": id ? `${id}-container` : undefined,
    disabled: disabled
  }), selected.map((option, index) => /*#__PURE__*/React.createElement(SelectorChip, {
    name: `${option && (option.label ?? option.value)}`,
    key: `option-selected-${option.value}-${index}`,
    onClick: e => handleRemoveOption(e, option),
    disabled: disabled,
    color: option.color
  })), /*#__PURE__*/React.createElement(SelectorInput, {
    open: open,
    ref: inputEl,
    placeholder: placeholder,
    onFocus: handleOpenDialog,
    value: inputValue,
    onChange: handleChangeInputValue,
    name: name,
    id: id ? `${id}-input` : undefined,
    "data-testid": id ? `${id}-input` : undefined,
    onClick: handleClickInput,
    type: type,
    autoComplete: autoComplete,
    disabled: disabled,
    onDropdownButtonClick: handleDropdownButtonClick
  }), open && /*#__PURE__*/React.createElement(SelectorDropdown, {
    imgLoading: imgLoading,
    startContent: startContent,
    endContent: endContent,
    options: shownOptions,
    search: search,
    selected: selected.map(s => s.value),
    onClickOption: handleAddOption,
    id: id ? `${id}-dropdown` : undefined,
    "data-testid": id ? `${id}-dropdown` : undefined,
    pageIncrement: pageIncrement,
    startingPageCount: startingPageCount,
    disableNoContentText: disableNoContentText
  }));
}

const OptionPopupListItemContainer = /*#__PURE__*/styled("div", {
  shouldForwardProp: prop => prop !== "hidden"
})`
  width: 100%;
  padding: 0px;
  display: ${props => props.hidden ? "none" : "flex"};
  user-select: none;
  transition: 0.2 all;
  flex-wrap: wrap;
  cursor: default;
`;

const ClearContainer = /*#__PURE__*/styled(Flex)`
  width: 100%;
  border-top: 1px solid ${colors.neutrals[50]};
  a {
    font-weight: 600;
    text-decoration: underline;
    padding-top: 5px;
    &:hover {
      cursor: pointer;
    }
  }
`;
function SelectorDropdown$1({
  expandedOptions = [],
  options = [],
  search = "",
  selected = [],
  onClickOption = () => {},
  onToggleOption = () => {},
  onClearAll = () => {},
  id,
  disableCategoryOptions = false,
  pageIncrement = 20,
  startingPageCount = 60,
  startContent,
  endContent,
  imgLoading,
  disableNoContentText,
  showCheckboxes = false,
  showClearSelection = false,
  ...props
}) {
  const [page, setPage] = useState(0);
  const dropdownEl = useRef(null);
  const handleScroll = () => {
    if (!dropdownEl.current) return;
    if (options.length <= page * pageIncrement + startingPageCount) return;
    const {
      scrollTop,
      scrollHeight,
      clientHeight
    } = dropdownEl.current;
    if (scrollTop + clientHeight + 100 > scrollHeight) {
      setPage(page + 1);
    }
  };
  const handleToggleOpenOption = (option, e, hasChildren) => {
    if (hasChildren) {
      onToggleOption(option, e);
      return;
    }
    onClickOption(option, e);
  };
  const handleClickOption = (e, option) => {
    e.stopPropagation();
    e.preventDefault();
    if (isOptionDisabled(option)) return;
    const children = getOptionChildren(option);
    if (children.length !== 0) onToggleOption(option, e);
    onClickOption(option, e);
  };
  const getOptionChildren = option => {
    return options.filter(o => o.category === option.value);
  };
  const isChildSelected = option => {
    const children = options.filter(o => o.category === option.value);
    return children.some(c => {
      if (selected.includes(c.value)) return true;
      return isChildSelected(c);
    });
  };
  const isParentSelected = option => {
    if (!option.category) return false;
    const parent = options.find(o => o.value === option.category);
    if (!parent) return false;
    if (selected.includes(parent.value)) return true;
    return isParentSelected(parent);
  };
  const isOptionDisabled = option => {
    if (option.disabled) return true;
    if (!disableCategoryOptions) return false;
    if (isChildSelected(option)) return true;
    if (isParentSelected(option)) return true;
    return false;
  };
  // Render an option along with it's children ( if it has children )
  const renderOption = (option, level) => {
    const children = getOptionChildren(option);
    return /*#__PURE__*/React.createElement(OptionPopupListItem, {
      role: "option",
      "aria-selected": selected.includes(option.value),
      key: `selector-option-${option.value}`,
      "data-testid": `option-${option.value}`
    }, /*#__PURE__*/React.createElement(SelectorOption, {
      imgLoading: imgLoading,
      indent: level,
      option: option,
      selected: selected.includes(option.value),
      disabled: isOptionDisabled(option),
      showArrow: children.length !== 0,
      isHierarchy: true,
      arrowOpen: expandedOptions.includes(option.value),
      search: search,
      onClickContainer: e => handleToggleOpenOption(option, e, children.length !== 0),
      onClick: e => handleClickOption(e, option),
      showCheckboxes: showCheckboxes
    }), children.length !== 0 && /*#__PURE__*/React.createElement(OptionPopupListItemContainer, {
      hidden: !expandedOptions.includes(option.value)
    }, /*#__PURE__*/React.createElement(OptionPopupList, null, children.map(o => renderOption(o, level + 1)))));
  };
  // Only show top-level options that dont have a cateogry
  // ( children will be rendered by the items themselves )
  const shownOptions = useMemo(() => {
    return options.filter(o => !o.category).slice(0, startingPageCount + pageIncrement * page);
  }, [options, page, pageIncrement, startingPageCount]);
  return /*#__PURE__*/React.createElement(OptionPopupContainer, Object.assign({}, props, {
    "aria-describedby": "option list popup",
    ref: dropdownEl,
    onScroll: handleScroll
  }), startContent, /*#__PURE__*/React.createElement(OptionPopupList, {
    role: "listbox"
  }, shownOptions.length !== 0 ? shownOptions.map(o => renderOption(o, 0)) : disableNoContentText ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(Flex, {
    flexDir: "column",
    alignItems: "center",
    "data-testid": "item-not-found"
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "regular",
    color: "neutrals.200",
    fontSize: "sm"
  }, "No match found"), /*#__PURE__*/React.createElement(Text, {
    fontWeight: "regular",
    color: "neutrals.200",
    fontSize: "sm"
  }, "Try modifying your search"))), endContent, showClearSelection && /*#__PURE__*/React.createElement(ClearContainer, null, /*#__PURE__*/React.createElement(Link, {
    onClick: onClearAll
  }, "Clear selected")));
}

const Tag = ({
  tagLabel,
  tagLeftIcon,
  tagLeftIconVariant,
  isRemovable,
  onRemoveClick,
  size,
  ...props
}) => /*#__PURE__*/React.createElement(Tag$1, Object.assign({}, props, {
  size: size
}), tagLeftIcon && /*#__PURE__*/React.createElement(Icon, {
  mr: size === "compact" ? "sp4" : "sp8",
  boxSize: "12px",
  icon: tagLeftIcon,
  variant: tagLeftIconVariant
}), /*#__PURE__*/React.createElement(TagLabel, {
  mr: isRemovable && size === "compact" ? "sp4" : isRemovable ? "sp8" : 0,
  lineHeight: "20px"
}, tagLabel), isRemovable && /*#__PURE__*/React.createElement(TagCloseButton, {
  onClick: onRemoveClick
}));

function MultiSearchSelector$1({
  options = [],
  selected = [],
  onChange = () => {},
  searchDelay = 200,
  placeholder = "Select Multiple",
  selectedplaceholder = "",
  name = "Multiple Selector",
  id,
  disableCategoryOptions = false,
  onClick = () => {},
  pageIncrement,
  startingPageCount,
  type,
  autoComplete,
  disabled,
  onInputChange = () => {},
  startContent,
  endContent,
  imgLoading = "lazy",
  onSearch = () => {},
  disableNoContentText = false,
  onlyExactSiblingsInSearch = false,
  clearInputOnSelect = false,
  clearInput = false,
  showSelectedNames = true,
  showCheckboxes = false,
  showClearSelection = false,
  ...props
}) {
  const inputEl = useRef(null);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [search, setSearch] = useState("");
  const [shownOptions, setShownOptions] = useState([]);
  const [expandedOptions, setExpandedOptions] = useState([]);
  const containerEl = useRef(null);
  const handleOpenDialog = () => {
    setOpen(true);
  };
  // Focus the input whenever the container element is clicked
  const handleClickContainer = e => {
    onClick(e);
    if (inputEl.current) {
      inputEl.current.focus();
    }
  };
  const handleClickInput = e => {
    onClick(e);
    setOpen(true);
  };
  // Handle changing input value
  const handleChangeInputValue = e => {
    setInputValue(e.target.value);
    onInputChange(e);
    setOpen(true);
  };
  // Handle the addition of a selected option
  const handleAddOption = (option, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (inputEl.current) {
      inputEl.current.focus();
    }
    if (selected.some(s => s.value === option.value)) {
      if (showCheckboxes) {
        const updated = selected.filter(s => s.value !== option.value);
        onChange(updated, e);
        if (clearInputOnSelect) {
          setInputValue("");
        }
      }
      return;
    }
    if (option.disabled) return;
    onChange([...selected, option], e);
    if (clearInputOnSelect) {
      setInputValue("");
    }
  };
  const onClearAll = e => {
    e.preventDefault();
    e.stopPropagation();
    onChange([], e);
    if (clearInputOnSelect) {
      setInputValue("");
    }
  };
  // Handle the removal of a selected option
  const handleRemoveOption = (option, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    onChange(selected.filter(o => o.value !== option.value), e);
    if (inputEl.current) {
      inputEl.current.focus();
    }
  };
  // Handle toggling the search option dropdown
  const handleToggleOption = (option, e) => {
    e.preventDefault();
    if (expandedOptions.some(o => o === option.value)) {
      setExpandedOptions(expandedOptions.filter(o => o !== option.value));
      return;
    }
    setExpandedOptions([...expandedOptions, option.value]);
  };
  useEffect(() => {
    const newExpanded = [];
    const lcaseSearch = search.toLowerCase();
    if (!lcaseSearch) {
      // If no search keyword, show all options
      setShownOptions(options);
    } else {
      // 1. Map the options so we can give them a ranking
      // 2. Filter the options that dont match the search
      // 3. Sort the options so the options that best match the search show up on top
      // 4. Re-map the options to their original state
      setShownOptions(options.map(option => {
        if (childMatchesSearch(option, lcaseSearch, options)) {
          newExpanded.push(option.value);
          return [option, 1];
        }
        if (parentMatchesSearch(option, lcaseSearch, options)) {
          return [option, 2];
        }
        if (matchesSearch(option, lcaseSearch)) {
          return [option, 3];
        }
        if (siblingMatchesSearch(option, lcaseSearch, options) && !onlyExactSiblingsInSearch) {
          return [option, 1];
        }
        if (parentSiblingMatchesSearch(option, lcaseSearch, options)) {
          return [option, 1];
        }
        return [option, 0];
      }).filter(o => o[1] !== 0).sort((a, b) => {
        if (a[1] > b[1]) return -1;
        if (a[1] < b[1]) return 1;
        return 0;
      }).map(o => o[0]));
    }
    setExpandedOptions(newExpanded);
  }, [options, search]);
  // Only affect search if the input value has not changed
  // within the last x ms for performance
  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearch(inputValue);
      onSearch(inputValue);
    }, searchDelay);
    return () => {
      clearTimeout(timeout);
    };
  }, [inputValue, searchDelay]);
  // Detect clicking outside of selector container and set open to false
  useEffect(() => {
    const handleClick = e => {
      if (!containerEl.current) return;
      if (!e.target) return;
      if (containerEl.current.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [containerEl]);
  useEffect(() => {
    if (open) return;
    setInputValue("");
  }, [open]);
  useEffect(() => {
    if (!clearInput) return;
    setInputValue("");
  }, [clearInput]);
  return /*#__PURE__*/React.createElement(SelectorContainer, Object.assign({}, props, {
    onClick: handleClickContainer,
    open: open,
    ref: containerEl,
    id: id ? `${id}-container` : undefined,
    "data-testid": id ? `${id}-container` : undefined,
    disabled: disabled
  }), showSelectedNames && selected.map((option, index) => /*#__PURE__*/React.createElement(SelectorChip, {
    name: `${option.label ?? option.value}`,
    key: `option-selected-${option.value}-${index}`,
    onClick: e => handleRemoveOption(option, e),
    disabled: disabled,
    color: option.color
  })), /*#__PURE__*/React.createElement(SelectorInput, {
    open: open,
    ref: inputEl,
    placeholder: selected.length && selectedplaceholder ? selectedplaceholder : placeholder,
    onFocus: handleOpenDialog,
    value: inputValue,
    onChange: handleChangeInputValue,
    name: name,
    id: id ? `${id}-input` : undefined,
    "data-testid": id ? `${id}-input` : undefined,
    onClick: handleClickInput,
    type: type,
    autoComplete: autoComplete,
    disabled: disabled
  }), !showSelectedNames && selected.length > 0 && /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    right: "30px"
  }, /*#__PURE__*/React.createElement(Tag, {
    tagLabel: `+${selected.length}`,
    variant: "dark"
  })), open && /*#__PURE__*/React.createElement(SelectorDropdown$1, {
    imgLoading: imgLoading,
    startContent: startContent,
    endContent: endContent,
    expandedOptions: expandedOptions,
    onToggleOption: handleToggleOption,
    options: shownOptions,
    search: search,
    selected: selected.map(s => s.value),
    onClickOption: handleAddOption,
    onClearAll: onClearAll,
    disableCategoryOptions: disableCategoryOptions,
    id: id ? `${id}-dropdown` : undefined,
    "data-testid": id ? `${id}-dropdown` : undefined,
    pageIncrement: pageIncrement,
    startingPageCount: startingPageCount,
    disableNoContentText: disableNoContentText,
    showCheckboxes: showCheckboxes,
    showClearSelection: showClearSelection
  }));
}

function SingleSearchSelector$1({
  options = [],
  selected = null,
  onChange = () => {},
  searchDelay = 200,
  placeholder = "Select Single",
  name = "Single Selector",
  id,
  onClick = () => {},
  keepOpen = false,
  pageIncrement,
  startingPageCount,
  type,
  autoComplete,
  disabled,
  onInputChange = () => {},
  startContent,
  endContent,
  imgLoading = "lazy",
  onSearch = () => {},
  disableNoContentText = false,
  onlyExactSiblingsInSearch = false,
  clearInputOnSelect = false,
  clearInput = false,
  ...props
}) {
  const inputEl = useRef(null);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [search, setSearch] = useState("");
  const [shownOptions, setShownOptions] = useState([]);
  const [expandedOptions, setExpandedOptions] = useState([]);
  const containerEl = useRef(null);
  const handleFocus = () => {
    setOpen(true);
  };
  // Focus the input whenever the container element is clicked
  const handleClickContainer = e => {
    onClick(e);
    if (inputEl.current) {
      inputEl.current.focus();
    }
  };
  const handleClickInput = e => {
    onClick(e);
    setOpen(true);
  };
  // Handle changing input value
  const handleChangeInputValue = e => {
    setInputValue(e.target.value);
    onInputChange(e);
    const matchingOption = options.find(o => {
      const name = `${o.label ?? o.value}`;
      return name === e.target.value;
    });
    if (matchingOption) {
      onChange(matchingOption, e);
      return;
    }
    setOpen(true);
    onChange(null, e);
  };
  // Handle the addition of a selected option
  const handleSelectOption = (option, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (inputEl.current) {
      if (keepOpen) {
        inputEl.current.focus();
      } else {
        inputEl.current.blur();
        setOpen(false);
      }
    }
    if (option.disabled) return;
    onChange(option, e);
    if (clearInputOnSelect) {
      setInputValue("");
    }
  };
  // Handle the removal of a selected option
  const handleClearOption = e => {
    e.preventDefault();
    e.stopPropagation();
    onChange(null, e);
    setInputValue("");
    if (inputEl.current) {
      inputEl.current.focus();
    }
  };
  // Handle toggling the search option dropdown
  const handleToggleOption = (option, e) => {
    e.preventDefault();
    if (expandedOptions.some(o => o === option.value)) {
      setExpandedOptions(expandedOptions.filter(o => o !== option.value));
      return;
    }
    setExpandedOptions([...expandedOptions, option.value]);
  };
  useEffect(() => {
    const newExpanded = [];
    const lcaseSearch = search.toLowerCase();
    if (!lcaseSearch) {
      // If no search keyword, show all options
      setShownOptions(options);
    } else {
      // 1. Map the options so we can give them a ranking
      // 2. Filter the options that dont match the search
      // 3. Sort the options so the options that best match the search show up on top
      // 4. Re-map the options to their original state
      setShownOptions(options.map(option => {
        if (childMatchesSearch(option, lcaseSearch, options)) {
          newExpanded.push(option.value);
          return [option, 1];
        }
        if (parentMatchesSearch(option, lcaseSearch, options)) {
          return [option, 2];
        }
        if (matchesSearch(option, lcaseSearch)) {
          return [option, 3];
        }
        if (siblingMatchesSearch(option, lcaseSearch, options) && !onlyExactSiblingsInSearch) {
          return [option, 1];
        }
        if (parentSiblingMatchesSearch(option, lcaseSearch, options)) {
          return [option, 1];
        }
        return [option, 0];
      }).filter(o => o[1] !== 0).sort((a, b) => {
        if (a[1] > b[1]) return -1;
        if (a[1] < b[1]) return 1;
        return 0;
      }).map(o => o[0]));
    }
    setExpandedOptions(newExpanded);
  }, [options, search]);
  // Only affect search if the input value has not changed
  // within the last x ms for performance
  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearch(inputValue);
      onSearch(inputValue);
    }, searchDelay);
    return () => {
      clearTimeout(timeout);
    };
  }, [inputValue, searchDelay]);
  // Detect clicking outside of selector container and set open to false
  useEffect(() => {
    const handleClick = e => {
      if (!containerEl.current) return;
      if (!e.target) return;
      if (containerEl.current.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [containerEl]);
  useEffect(() => {
    if (selected) {
      const newInput = `${selected.label ?? selected.value}`;
      setInputValue(newInput);
    }
  }, [selected]);
  useEffect(() => {
    if (open) return;
    // If dialog is closed, clear the input if its not selected
    if (!selected) {
      setInputValue("");
    }
  }, [open, selected]);
  useEffect(() => {
    if (!clearInput) return;
    setInputValue("");
  }, [clearInput]);
  return /*#__PURE__*/React.createElement(SelectorContainer, Object.assign({}, props, {
    onClick: handleClickContainer,
    open: open,
    ref: containerEl,
    id: id ? `${id}-container` : undefined,
    "data-testid": id ? `${id}-container` : undefined,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(SelectorInput, {
    open: open,
    ref: inputEl,
    placeholder: placeholder,
    onFocus: handleFocus,
    value: inputValue,
    onChange: handleChangeInputValue,
    name: name,
    id: id ? `${id}-input` : undefined,
    "data-testid": id ? `${id}-input` : undefined,
    onClick: handleClickInput,
    showClearIcon: !!inputValue,
    onClear: handleClearOption,
    type: type,
    autoComplete: autoComplete,
    disabled: disabled
  }), open && /*#__PURE__*/React.createElement(SelectorDropdown$1, {
    startContent: startContent,
    endContent: endContent,
    expandedOptions: expandedOptions,
    onToggleOption: handleToggleOption,
    options: shownOptions,
    search: search,
    selected: selected ? [selected.value] : [],
    onClickOption: handleSelectOption,
    id: id ? `${id}-dropdown` : undefined,
    "data-testid": id ? `${id}-dropdown` : undefined,
    pageIncrement: pageIncrement,
    startingPageCount: startingPageCount,
    imgLoading: imgLoading,
    disableNoContentText: disableNoContentText
  }));
}

const Thead = /*#__PURE__*/React.forwardRef(({
  children,
  ...props
}, ref) => /*#__PURE__*/React.createElement(Thead$1, Object.assign({}, props, {
  ref: ref
}), children));

const Th = /*#__PURE__*/React.forwardRef(({
  headerText,
  secondaryText,
  icon,
  handleSort,
  sortDirection,
  columnName,
  alignment,
  ...props
}, ref) => {
  const handleSortInner = () => {
    if (!columnName || !handleSort) {
      return;
    }
    switch (sortDirection) {
      case "asc":
        handleSort(columnName, "desc");
        break;
      case "desc":
        handleSort(columnName, "");
        break;
      default:
        handleSort(columnName, "asc");
        break;
    }
  };
  const tableSortDirection = sortDirection === "" || !sortDirection ? "" : sortDirection;
  return /*#__PURE__*/React.createElement(Th$1, Object.assign({
    cursor: handleSort && "pointer",
    onClick: handleSortInner
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: alignment
  }, icon && /*#__PURE__*/React.createElement(Box, {
    mr: "sp8"
  }, icon), /*#__PURE__*/React.createElement(Box, Object.assign({}, handleSort && {
    mr: "sp8"
  }), /*#__PURE__*/React.createElement(Text, {
    lineHeight: "16px",
    fontWeight: "medium",
    pb: secondaryText ? "sp2" : "0"
  }, headerText), secondaryText && /*#__PURE__*/React.createElement(Text, {
    color: "text.paragraph.light",
    fontWeight: "medium",
    fontSize: "sm",
    pb: "sp4",
    lineHeight: "14px"
  }, secondaryText)), handleSort && /*#__PURE__*/React.createElement(Box, null, tableSortDirection === "asc" && /*#__PURE__*/React.createElement(Icon, {
    color: "text.paragraph.light",
    variant: "duotone",
    icon: "fa-sort-up"
  }), tableSortDirection === "desc" && /*#__PURE__*/React.createElement(Icon, {
    color: "text.paragraph.light",
    variant: "duotone",
    icon: "fa-sort-down"
  }), tableSortDirection === "" && /*#__PURE__*/React.createElement(Icon, {
    color: "neutrals.50",
    variant: "solid",
    icon: "fa-sort"
  }))));
});

const Tr = /*#__PURE__*/React.forwardRef(({
  children,
  ...props
}, ref) => /*#__PURE__*/React.createElement(Tr$1, Object.assign({}, props, {
  ref: ref
}), children));

const NoDataSearchIcon = () => /*#__PURE__*/React.createElement(Icon$1, {
  width: "68px",
  height: "56px",
  viewBox: "0 0 68 56"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.691132 0H40.7165V52.8623H0.691132V0Z",
  fill: "#EBECF0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.40064 12.4381C5.40064 11.7941 5.92272 11.272 6.56672 11.272H29.7409C30.3849 11.272 30.907 11.7941 30.907 12.4381C30.907 13.0821 30.3849 13.6042 29.7409 13.6042H6.56672C5.92272 13.6042 5.40064 13.0821 5.40064 12.4381Z",
  fill: "#FAFBFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.40064 19.0458C5.40064 18.4018 5.92272 17.8797 6.56672 17.8797H33.6649C34.309 17.8797 34.831 18.4018 34.831 19.0458C34.831 19.6898 34.309 20.2119 33.6649 20.2119H6.56672C5.92272 20.2119 5.40064 19.6898 5.40064 19.0458Z",
  fill: "#FAFBFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.40064 40.8129C5.40064 40.1689 5.92272 39.6468 6.56672 39.6468H29.7409C30.3849 39.6468 30.907 40.1689 30.907 40.8129C30.907 41.4569 30.3849 41.979 29.7409 41.979H6.56672C5.92272 41.979 5.40064 41.4569 5.40064 40.8129Z",
  fill: "#FAFBFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.40064 34.9826C5.40064 34.3386 5.92272 33.8165 6.56672 33.8165H23.4624C24.1064 33.8165 24.6285 34.3386 24.6285 34.9826C24.6285 35.6266 24.1064 36.1487 23.4624 36.1487H6.56673C5.92272 36.1487 5.40064 35.6266 5.40064 34.9826Z",
  fill: "#FAFBFC"
}), /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1_1435_11209",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.9597 41.0932L55.9273 39.7017L60.0164 45.2013L58.0488 46.5928L53.9597 41.0932Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.9273 46.6871C55.3669 45.9096 55.547 44.8307 56.3295 44.2774L58.3624 42.8397C59.1449 42.2863 60.2335 42.468 60.7939 43.2455L66.983 51.8322C67.5434 52.6097 67.3633 53.6886 66.5808 54.242L64.5479 55.6797C63.7654 56.233 62.6768 56.0514 62.1164 55.2739L55.9273 46.6871Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.0669 15.8595C64.8081 23.8249 62.9434 34.8923 54.902 40.5792C46.8605 46.2661 35.6875 44.4191 29.9463 36.4537C24.205 28.4883 26.0698 17.4209 34.1112 11.734C42.1526 6.04709 53.3257 7.89416 59.0669 15.8595Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M53.9597 41.0932L55.9273 39.7017L60.0164 45.2013L58.0488 46.5928L53.9597 41.0932Z",
  fill: "#B3BAC5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.9273 46.6871C55.3669 45.9096 55.547 44.8307 56.3295 44.2774L58.3624 42.8397C59.1449 42.2863 60.2335 42.468 60.7939 43.2455L66.983 51.8322C67.5434 52.6097 67.3633 53.6886 66.5808 54.242L64.5479 55.6797C63.7654 56.233 62.6768 56.0514 62.1164 55.2739L55.9273 46.6871Z",
  fill: "#C1C7D0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.0669 15.8595C64.8081 23.8249 62.9434 34.8923 54.902 40.5792C46.8605 46.2661 35.6875 44.4191 29.9463 36.4537C24.205 28.4883 26.0698 17.4209 34.1112 11.734C42.1526 6.04709 53.3257 7.89416 59.0669 15.8595Z",
  fill: "white",
  fillOpacity: "0.7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.9597 41.0932L51.0727 37.0109L46.8921 39.9674L49.9473 44.0765L53.9597 41.0932ZM55.9273 39.7017L59.9398 36.7184L57.0266 32.8003L53.0403 35.6194L55.9273 39.7017ZM60.0164 45.2013L62.9034 49.2836L67.084 46.327L64.0288 42.2179L60.0164 45.2013ZM58.0488 46.5928L54.0363 49.5761L56.9495 53.4942L60.9358 50.6751L58.0488 46.5928ZM64.5479 55.6797L67.4349 59.762L64.5479 55.6797ZM62.1164 55.2739L66.1726 52.3503V52.3503L62.1164 55.2739ZM66.983 51.8322L62.9268 54.7558L66.983 51.8322ZM66.5808 54.242L63.6938 50.1597L66.5808 54.242ZM58.3624 42.8397L61.2494 46.922L61.2494 46.922L58.3624 42.8397ZM60.7939 43.2455L64.8501 40.3219L60.7939 43.2455ZM56.3295 44.2774L53.4425 40.1951L53.4425 40.1951L56.3295 44.2774ZM55.9273 46.6871L51.8711 49.6107H51.8711L55.9273 46.6871ZM56.8467 45.1755L58.8143 43.784L53.0403 35.6194L51.0727 37.0109L56.8467 45.1755ZM51.9149 42.685L56.0039 48.1846L64.0288 42.2179L59.9398 36.7184L51.9149 42.685ZM57.1294 41.119L55.1618 42.5105L60.9358 50.6751L62.9034 49.2836L57.1294 41.119ZM62.0612 43.6094L57.9722 38.1098L49.9473 44.0765L54.0363 49.5761L62.0612 43.6094ZM59.2165 48.3597L61.2494 46.922L55.4754 38.7574L53.4425 40.1951L59.2165 48.3597ZM56.7377 46.1691L62.9268 54.7558L71.0392 48.9087L64.8501 40.3219L56.7377 46.1691ZM63.6938 50.1597L61.6609 51.5974L67.4349 59.762L69.4678 58.3243L63.6938 50.1597ZM66.1726 52.3503L59.9835 43.7635L51.8711 49.6107L58.0602 58.1975L66.1726 52.3503ZM61.6609 51.5974C63.1187 50.5664 65.1286 50.9018 66.1726 52.3503L58.0602 58.1975C60.225 61.2009 64.4122 61.8997 67.4349 59.762L61.6609 51.5974ZM62.9268 54.7558C61.8623 53.2789 62.2074 51.2109 63.6938 50.1597L69.4678 58.3243C72.5193 56.1663 73.2245 51.9406 71.0392 48.9087L62.9268 54.7558ZM61.2494 46.922C59.7916 47.9529 57.7817 47.6175 56.7377 46.1691L64.8501 40.3219C62.6853 37.3185 58.4982 36.6197 55.4754 38.7574L61.2494 46.922ZM53.4425 40.1951C50.391 42.353 49.6858 46.5788 51.8711 49.6107L59.9835 43.7635C61.048 45.2405 60.7029 47.3085 59.2165 48.3597L53.4425 40.1951ZM55.0107 18.7831C59.1184 24.4821 57.7995 32.4061 52.015 36.4969L57.789 44.6615C68.0873 37.3785 70.4979 23.1677 63.1231 12.936L55.0107 18.7831ZM52.015 36.4969C46.2021 40.6078 38.1309 39.2579 34.0024 33.5301L25.8901 39.3773C33.2441 49.5802 47.519 51.9245 57.789 44.6615L52.015 36.4969ZM34.0024 33.5301C29.8948 27.8311 31.2136 19.9071 36.9982 15.8163L31.2242 7.6517C20.9259 14.9347 18.5153 29.1455 25.8901 39.3773L34.0024 33.5301ZM36.9982 15.8163C42.8111 11.7054 50.8823 13.0553 55.0107 18.7831L63.1231 12.936C55.7691 2.73299 41.4942 0.388753 31.2242 7.6517L36.9982 15.8163Z",
  fill: "#C1C7D0",
  mask: "url(#path-2-inside-1_1435_11209)"
}));

const TrLoading = () => /*#__PURE__*/React.createElement(Tr, null, /*#__PURE__*/React.createElement(Td, {
  colSpan: 100
}, /*#__PURE__*/React.createElement(Flex, {
  justifyContent: "center",
  py: "sp24"
}, /*#__PURE__*/React.createElement(Spinner, {
  size: "md"
}))));
const TrNoData = ({
  title,
  subtitle
}) => /*#__PURE__*/React.createElement(Tr, null, /*#__PURE__*/React.createElement(Td, {
  colSpan: 100
}, /*#__PURE__*/React.createElement(Flex, {
  justifyContent: "center",
  py: "sp24"
}, /*#__PURE__*/React.createElement(NoDataSearchIcon, null)), /*#__PURE__*/React.createElement(Flex, {
  justifyContent: "center",
  pb: "sp2"
}, /*#__PURE__*/React.createElement(Text, {
  color: "neutrals.900",
  fontSize: "sm"
}, title)), /*#__PURE__*/React.createElement(Flex, {
  justifyContent: "center",
  pb: "sp24"
}, /*#__PURE__*/React.createElement(Text, {
  color: "neutrals.500",
  fontSize: "sm"
}, subtitle))));
const Tbody = /*#__PURE__*/React.forwardRef(({
  loaded = true,
  searched = false,
  children,
  ...props
}, ref) => {
  if (!loaded) return /*#__PURE__*/React.createElement(Tbody$1, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(TrLoading, null));
  if (!Array.isArray(children) || children.length === 0) {
    if (searched) return /*#__PURE__*/React.createElement(Tbody$1, Object.assign({}, props), /*#__PURE__*/React.createElement(TrNoData, {
      title: "No data found to match your search",
      subtitle: "Try modifying your search criteria"
    }));else return /*#__PURE__*/React.createElement(Tbody$1, Object.assign({}, props), /*#__PURE__*/React.createElement(TrNoData, {
      title: "No data available"
    }));
  }
  return /*#__PURE__*/React.createElement(Tbody$1, Object.assign({}, props), children);
});

const Td = /*#__PURE__*/React.forwardRef(({
  primaryText,
  secondaryText,
  icon,
  alignment,
  children,
  ...props
}, ref) => /*#__PURE__*/React.createElement(Td$1, Object.assign({}, props, {
  ref: ref
}), children ? children : /*#__PURE__*/React.createElement(Box, {
  display: "flex",
  flexDirection: "row",
  justifyContent: alignment
}, icon && /*#__PURE__*/React.createElement(Box, {
  mr: "sp8"
}, icon), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
  lineHeight: "16px",
  pb: secondaryText ? "sp2" : ""
}, primaryText), secondaryText && /*#__PURE__*/React.createElement(Text, {
  color: "text.paragraph.light",
  fontWeight: "medium",
  fontSize: "sm",
  lineHeight: "14px"
}, secondaryText)))));

const style = `
  padding: 7px 8px;
  font-size: ${fontSizes.sm};
  color: ${colors.text.paragraph.regular};
  background-color: ${colors.neutrals["0"]};
  box-shadow: ${shadows[20]};
  border: 1px solid transparent;

  :hover {
    background-color: ${colors.neutrals["20"]};
    color: ${colors.text.title};
  }

  :focus {
    background-color: ${colors.brand["100"]};
    color: ${colors.text.title};
    border: 1px solid ${colors.brand["400"]};
    box-shadow: none;
  }
`;
const TableButton = /*#__PURE__*/styled(Button)(style);
const TableIconButton = /*#__PURE__*/styled(IconButton)(style);

const ButtonTd = ({
  buttonText,
  buttonIconName,
  onClick
}) => {
  const icon = buttonIconName ? /*#__PURE__*/React.createElement(Icon, {
    icon: buttonIconName,
    variant: "solid",
    color: "text.paragraph.light"
  }) : undefined;
  const button = buttonText ? /*#__PURE__*/React.createElement(TableButton, {
    ml: "auto",
    onClick: onClick,
    leftIcon: icon
  }, buttonText) : /*#__PURE__*/React.createElement(TableIconButton, {
    onClick: onClick,
    icon: icon,
    "aria-label": buttonText ?? ""
  }, buttonText);
  return /*#__PURE__*/React.createElement(Td, null, /*#__PURE__*/React.createElement(Box, null, button));
};

const TextArea = /*#__PURE__*/React.forwardRef(({
  isDisabled,
  placeholder,
  onChange,
  name,
  value,
  rows,
  ...props
}, ref) => /*#__PURE__*/React.createElement(FormWrapper, Object.assign({}, props), /*#__PURE__*/React.createElement(Textarea, {
  ref: ref,
  placeholder: placeholder,
  onChange: onChange,
  name: name,
  isDisabled: isDisabled,
  value: value,
  rows: rows
})));

const ThemeProvider = ({
  children,
  applyCSSReset = true,
  cssResetScope = '',
  theme: theme$1
}) => /*#__PURE__*/React.createElement(ChakraProvider, {
  theme: theme$1 || theme,
  resetCSS: applyCSSReset,
  resetScope: cssResetScope
}, /*#__PURE__*/React.createElement(Global, {
  styles: css`
        @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@500;600&family=Roboto:wght@400;500;700&display=swap");
      `
}), children);

const Toggle = ({
  isChecked,
  labelLeft,
  labelRight,
  disabled,
  onChange,
  ...props
}) => {
  const CheckboxContainer = styled.div`
    position: relative;
    width: 41px;
    height: 18px;
  `;
  const Slider = styled(FormLabel)`
    position: absolute;
    cursor: ${disabled ? "not-allowed" : "pointer"};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${isChecked ? disabled ? `${colors.accent.green[200]}` : `${colors.accent.green[400]}` : disabled ? `${colors.neutrals[40]}` : `${colors.neutrals[100]}`};

    -webkit-transition: 0.4s;
    border-radius: 34px;
    transition: 0.4s;

    &:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 1px;
      transform: ${isChecked ? "translateX(14px)" : "translateX(0px)"};
      -ms-transform: ${isChecked ? "translateX(14px)" : "translateX(0px)"};
      -webkit-transform: ${isChecked ? "translateX(14px)" : "translateX(0px)"};
      border-radius: 50%;
      bottom: 1px;
      background-color: ${colors.neutrals[0]};
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
  `;
  const CheckboxInput = styled(Checkbox)`
    opacity: 0;
    width: 0;
    height: 0;
  `;
  const CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
  `;
  const CheckboxLabel = styled.span`
    font-size: ${fontSizes.md};
    font-family: ${fonts.paragraphs};
    font-weight: ${fontWeights.regular};
    color: ${colors.text.title};
    margin: 0 ${space.sp8};
  `;
  return /*#__PURE__*/React.createElement(CheckboxWrapper, null, labelLeft && /*#__PURE__*/React.createElement(CheckboxLabel, null, labelLeft), /*#__PURE__*/React.createElement(CheckboxContainer, null, /*#__PURE__*/React.createElement(CheckboxInput, Object.assign({}, props, {
    isChecked: isChecked,
    onChange: onChange,
    id: props.name && `${props.name}-toggle-btn`,
    isDisabled: disabled
  }), "\u00A0"), /*#__PURE__*/React.createElement(Slider, {
    htmlFor: props.name && `${props.name}-toggle-btn`,
    checked: isChecked,
    disabled: disabled,
    onClick: onChange
  })), labelRight && /*#__PURE__*/React.createElement(CheckboxLabel, null, labelRight));
};

const ToolTip = /*#__PURE__*/React.forwardRef(({
  children,
  label,
  isDisabled,
  ...props
}, ref) => /*#__PURE__*/React.createElement(Tooltip, Object.assign({
  ref: ref,
  isDisabled: isDisabled,
  label: label
}, props), children));

const HeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;
const StyledIconDanger = /*#__PURE__*/styled(Icon)`
  width: 19px;
  height: 19px;
  color: ${colors.accent.red[400]};
  margin-right: 8px;
`;
const StyledIconWarning = /*#__PURE__*/styled(Icon)`
width: 19px;
height: 19px;
color: ${colors.accent.orange[400]};
margin-right: 8px;
`;
const ChakraModalHeaderWrapper = /*#__PURE__*/styled(ModalHeader)`
  display: flex;
  align-items: center;
`;
const Header = ({
  headerText,
  variant
}) => /*#__PURE__*/React.createElement(HeaderWrapper, null, /*#__PURE__*/React.createElement(ChakraModalHeaderWrapper, {
  "data-testid": "modal-header"
}, variant === "danger" ? /*#__PURE__*/React.createElement(StyledIconDanger, {
  variant: "solid",
  icon: "fa-circle-exclamation"
}) : variant === "warning" ? /*#__PURE__*/React.createElement(StyledIconWarning, {
  variant: "solid",
  icon: "fa-triangle-exclamation"
}) : "", headerText), /*#__PURE__*/React.createElement(ModalCloseButton, {
  "data-testid": "modal-close-btn"
}));

const ModalBody = ({
  children
}) => /*#__PURE__*/React.createElement(ModalBody$1, null, children);

const PrimaryCTA = ({
  children,
  onClick = () => {},
  variant = "primary",
  loading = false,
  ...props
}) => /*#__PURE__*/React.createElement(Button, Object.assign({
  mr: 16,
  onClick: onClick,
  isLoading: loading,
  variant: variant
}, props), children);

const ModalFooter = ({
  onPrimaryCTAClick,
  onSecondaryCTAClick,
  secondaryCTALabel,
  primaryCTALabel,
  primaryCTADisabled = false,
  secondaryCTADisabled = false,
  primaryCTALoading = false,
  variant,
  ...props
}) => {
  const btnVariant = {
    primary: "secondary",
    warning: "ghost",
    danger: "ghost"
  };
  return /*#__PURE__*/React.createElement(ModalFooter$1, Object.assign({
    "data-testid": "modal-footer"
  }, props), primaryCTALabel && /*#__PURE__*/React.createElement(PrimaryCTA, {
    onClick: onPrimaryCTAClick,
    // @ts-ignore
    variant: variant,
    isDisabled: primaryCTADisabled,
    loading: primaryCTALoading
  }, primaryCTALabel), secondaryCTALabel && /*#__PURE__*/React.createElement(SecondaryCTA, {
    onClick: onSecondaryCTAClick,
    // @ts-ignore
    variant: btnVariant[variant],
    isDisabled: secondaryCTADisabled
  }, secondaryCTALabel));
};

const SecondaryCTA = ({
  children,
  onClick = () => {},
  variant = "secondary",
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    onClick: onClick,
    variant: variant
  }, props), children);
};

const Modal = /*#__PURE__*/React.forwardRef(({
  isOpen,
  onClose,
  headerText,
  children,
  onPrimaryCTAClick,
  onSecondaryCTAClick,
  secondaryCTALabel,
  primaryCTALabel,
  variant,
  enableFooter,
  primaryCTADisabled,
  secondaryCTADisabled,
  primaryCTALoading,
  contentProps,
  overlayProps,
  ...props
}, ref) => /*#__PURE__*/React.createElement(Modal$1, Object.assign({
  closeOnEsc: true,
  isCentered: true,
  closeOnOverlayClick: true,
  isOpen: isOpen,
  onClose: onClose,
  variant: variant
}, props), /*#__PURE__*/React.createElement(ModalOverlay, Object.assign({
  "data-testid": "modal-overlay",
  bg: "rgba(0, 0, 0, 0.68)"
}, overlayProps)), /*#__PURE__*/React.createElement(ModalContent, Object.assign({
  ref: ref
}, contentProps), /*#__PURE__*/React.createElement(Header, {
  headerText: headerText,
  variant: variant
}), children, /*#__PURE__*/React.createElement(ModalFooter, {
  variant: variant,
  primaryCTALabel: primaryCTALabel,
  secondaryCTALabel: secondaryCTALabel,
  onPrimaryCTAClick: onPrimaryCTAClick,
  onSecondaryCTAClick: onSecondaryCTAClick,
  primaryCTADisabled: primaryCTADisabled,
  secondaryCTADisabled: secondaryCTADisabled,
  primaryCTALoading: primaryCTALoading
}))));

function InternalDrawer(props) {
  const divRef = useRef(null);
  return /*#__PURE__*/React.createElement(Drawer, {
    closeOnEsc: true,
    isFullHeight: true,
    closeOnOverlayClick: true,
    isOpen: props.isOpen,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement(DrawerOverlay, {
    "data-testid": "modal-overlay",
    bg: "rgba(0, 0, 0, 0.68)"
  }), /*#__PURE__*/React.createElement(DrawerContent, {
    ref: divRef
  }, /*#__PURE__*/React.createElement(DrawerBody, null, props.children)));
}

const Animation = ({
  animation,
  size = "100px",
  loop = false,
  play = false,
  renderer = "svg",
  speed = 1
}) => {
  const animationContainer = useRef(null);
  useEffect(() => {
    if (!animation) return;
    if (!animationContainer.current) return;
    const anim = lottie.loadAnimation({
      container: animationContainer.current,
      animationData: animation,
      renderer,
      loop,
      autoplay: play
    });
    lottie.setSpeed(speed, anim.name);
    return () => {
      lottie.destroy(anim.name);
    };
  }, [animation, play, loop, renderer, animationContainer, speed]);
  return /*#__PURE__*/React.createElement(Box, {
    height: size,
    width: size,
    ref: animationContainer
  });
};

const StyledToast = /*#__PURE__*/styled(Box)`
  display: flex;
  align-content: start;
  position: relative;
  padding: ${space.sp12} ${space.sp32} ${space.sp12} ${space.sp12};
  width: 400px;
  color: ${colors.text.paragraph.regular};
  background-color: ${colors.accent.green["100"]};
  border: 1px solid ${colors.accent.green["300"]};
  border-radius: 5px;
`;
const SuccessToast = /*#__PURE__*/styled(StyledToast)`
  background-color: ${colors.accent.green["100"]};
  border: 1px solid ${colors.accent.green["300"]};
`;
const InfoToast = /*#__PURE__*/styled(StyledToast)`
  background-color: ${colors.accent.turquoise["100"]};
  border: 1px solid ${colors.accent.turquoise["300"]};
`;
const WarningToast = /*#__PURE__*/styled(StyledToast)`
  background-color: ${colors.accent.orange["100"]};
  border: 1px solid ${colors.accent.orange["300"]};
`;
const ErrorToast = /*#__PURE__*/styled(StyledToast)`
  background-color: ${colors.accent.red["100"]};
  border: 1px solid ${colors.accent.red["300"]};
`;
const ToastBody = ({
  title,
  description,
  isClosable,
  onClose,
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex, {
  flexDirection: "column"
}, /*#__PURE__*/React.createElement(Text, {
  fontFamily: "Roboto",
  fontWeight: "500"
}, title), description && /*#__PURE__*/React.createElement(Text, {
  fontFamily: "Roboto",
  fontWeight: "400"
}, description), children), isClosable && /*#__PURE__*/React.createElement(CloseButton$2, {
  position: "absolute",
  size: "sm",
  right: "8px",
  top: "14px",
  onClick: onClose,
  "data-testid": "close-toast"
}));
const useToast = () => {
  const chakraToast = useToast$1();
  const close = () => {
    chakraToast.closeAll();
  };
  // Wrapped in useCallback to prevent unnecessary re-renders when used as a dependency in useEffect
  const successToast = useCallback(({
    title,
    description,
    isClosable,
    duration,
    position,
    children
  }) => chakraToast({
    duration: duration || 9000,
    position: position || "top",
    render: () => /*#__PURE__*/React.createElement(SuccessToast, null, /*#__PURE__*/React.createElement(Icon, {
      variant: "solid",
      icon: "fa-circle-check",
      color: colors.accent.green[400],
      boxSize: "16px",
      mr: "12px",
      mt: "3px"
    }), /*#__PURE__*/React.createElement(ToastBody, {
      title: title,
      description: description,
      isClosable: isClosable,
      onClose: close,
      children: children
    }))
  }), []);
  const infoToast = useCallback(({
    title,
    description,
    isClosable,
    duration,
    position,
    children
  }) => chakraToast({
    duration: duration || 9000,
    position: position || "top",
    render: () => /*#__PURE__*/React.createElement(InfoToast, null, /*#__PURE__*/React.createElement(Icon, {
      variant: "solid",
      icon: "fa-circle-info",
      color: colors.accent.turquoise[400],
      boxSize: "16px",
      mr: "12px",
      mt: "3px"
    }), /*#__PURE__*/React.createElement(ToastBody, {
      title: title,
      description: description,
      isClosable: isClosable,
      onClose: close,
      children: children
    }))
  }), []);
  const warningToast = useCallback(({
    title,
    description,
    isClosable,
    duration,
    position,
    children
  }) => chakraToast({
    duration: duration || 9000,
    position: position || "top",
    render: () => /*#__PURE__*/React.createElement(WarningToast, null, /*#__PURE__*/React.createElement(Icon, {
      variant: "solid",
      icon: "fa-triangle-exclamation",
      color: colors.accent.orange[400],
      boxSize: "16px",
      mr: "12px",
      mt: "3px"
    }), /*#__PURE__*/React.createElement(ToastBody, {
      title: title,
      description: description,
      isClosable: isClosable,
      onClose: close,
      children: children
    }))
  }), []);
  const errorToast = useCallback(({
    title,
    description,
    isClosable,
    duration,
    position,
    children
  }) => chakraToast({
    duration: duration || 9000,
    position: position || "top",
    render: () => /*#__PURE__*/React.createElement(ErrorToast, null, /*#__PURE__*/React.createElement(Icon, {
      variant: "solid",
      icon: "fa-circle-exclamation",
      color: colors.accent.red[400],
      boxSize: "16px",
      mr: "12px",
      mt: "3px"
    }), /*#__PURE__*/React.createElement(ToastBody, {
      title: title,
      description: description,
      isClosable: isClosable,
      onClose: close,
      children: children
    }))
  }), []);
  return {
    successToast,
    infoToast,
    warningToast,
    errorToast
  };
};

const Select = ({
  placeholder,
  clearAllButtonText,
  onChange,
  isMulti,
  items = [],
  selectedItem,
  disabled,
  label,
  id,
  errorMessage,
  isFiltered
}) => {
  const {
    t
  } = useTranslation();
  const SelectButton = styled(props => /*#__PURE__*/React.createElement(Button, Object.assign({
    variant: "ghost"
  }, props)))`
    ${() => errorMessage ? `
  border: 1px solid #F4767F;
  background-color: #FEF6F6;
` : ``}
    min-width: 200px;
    justify-content: space-between;
    :focus-within {
      outline: "none";
      z-index: 1;
      background-color: var(--chakra-colors-neutrals-0);
      border: 1px solid var(--chakra-colors-brand-400);
      box-shadow: 0px 0px 3px 0px var(--chakra-colors-brand-400);
    }
  `;
  const handleClearAll = () => {
    onChange(null);
  };
  const handleChange = selection => {
    onChange(selection);
  };
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    id: "selectWrapper"
  }, /*#__PURE__*/React.createElement(Downshift, {
    onChange: handleChange,
    initialSelectedItem: selectedItem,
    itemToString: item => item ? item.text || item.value : ""
  }, ({
    getItemProps,
    getLabelProps,
    getMenuProps,
    getToggleButtonProps,
    getInputProps,
    isOpen,
    inputValue,
    selectedItem,
    getRootProps,
    highlightedIndex
  }) => /*#__PURE__*/React.createElement(Box, null, label && /*#__PURE__*/React.createElement(FormLabel, Object.assign({
    fontWeight: "medium"
  }, getLabelProps()), label), /*#__PURE__*/React.createElement(Box
  // @ts-ignore
  , Object.assign({}, getRootProps({}, {
    suppressRefError: true
  })), /*#__PURE__*/React.createElement(FormWrapper, {
    errorMessage: errorMessage
  }, /*#__PURE__*/React.createElement(SelectButton, Object.assign({}, getToggleButtonProps(), {
    disabled: disabled,
    "aria-label": "toggle menu",
    rightIcon: /*#__PURE__*/React.createElement(Icon, {
      icon: "fa-chevron-down"
    }),
    mr: "sp4",
    color: "neutrals.900",
    fontWeight: "regular",
    py: "0",
    border: "1px",
    borderColor: "neutrals.50",
    borderRadius: "6px",
    _hover: {
      bgColor: "neutrals.20"
    },
    _focus: {
      border: "1px solid brand.500"
    }
  }), /*#__PURE__*/React.createElement(Box, {
    py: "sp12"
  }, /*#__PURE__*/React.createElement(SelectInput, Object.assign({
    placeholder: placeholder || "Select"
  }, getInputProps(), {
    "data-testid": id && `${id}-input`
  })))))), isOpen && /*#__PURE__*/React.createElement(Box, {
    position: "relative"
  }, /*#__PURE__*/React.createElement(Box, Object.assign({}, getMenuProps(), {
    p: "sp8",
    shadow: "dropdown",
    bgColor: "neutrals.0",
    position: "absolute",
    width: "100%",
    mt: "sp4",
    borderRadius: "sm",
    maxHeight: "205px",
    overflowY: "scroll",
    overflowX: "hidden",
    zIndex: "1",
    css: {
      "&::-webkit-scrollbar": {
        width: space.sp4
      },
      "&::-webkit-scrollbar-track": {
        width: space.sp8
      },
      "&::-webkit-scrollbar-thumb": {
        background: colors.neutrals[100],
        borderRadius: radii.lg
      }
    }
  }), /*#__PURE__*/React.createElement(FilteredItems, {
    items: items,
    inputValue: inputValue,
    highlightedIndex: highlightedIndex,
    selectedItems: selectedItem ? [selectedItem] : [],
    getItemProps: getItemProps,
    isMulti: isMulti === undefined ? false : isMulti,
    isFiltered: isFiltered
  }))))), /*#__PURE__*/React.createElement(Box, null, isMulti && selectedItem && /*#__PURE__*/React.createElement(Box, {
    mr: "sp8"
  }, /*#__PURE__*/React.createElement(Tag, {
    isRemovable: true,
    onRemoveClick: () => handleClearAll(),
    tagLabel: selectedItem.text || selectedItem.value,
    variant: "dark"
  }))), isMulti && /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    onClick: handleClearAll
  }, clearAllButtonText || t("Clear All")));
};

const Tabs = /*#__PURE__*/React.forwardRef(({
  children,
  ...props
}, ref) => /*#__PURE__*/React.createElement(Tabs$1, Object.assign({
  ref: ref
}, props), children));

const StyledChakraTab = /*#__PURE__*/styled(Tab$1)`
  @media (max-width: 700px) {
    padding: 12px
  },
  @media (max-width: 500px) {
    padding: 8px
  },
`;
const Tab = /*#__PURE__*/React.forwardRef(({
  children,
  tagLabel,
  tagVariant = "brand",
  ...props
}, ref) => /*#__PURE__*/React.createElement(StyledChakraTab, Object.assign({}, props, {
  ref: ref
}), children, tagLabel && /*#__PURE__*/React.createElement(Box, {
  ml: "sp8"
}, /*#__PURE__*/React.createElement(Tag, {
  variant: tagVariant,
  tagLabel: tagLabel,
  size: "compact"
}))));

const StyledChakraTabList = /*#__PURE__*/styled(TabList$1)`
  flex-wrap: ${props => props.wrap ? "wrap" : "no-wrap"};
`;
const TabList = /*#__PURE__*/React.forwardRef(({
  children,
  ...props
}, ref) => /*#__PURE__*/React.createElement(StyledChakraTabList, Object.assign({}, props, {
  ref: ref
}), children));

const TabPanels = ({
  children
}) => /*#__PURE__*/React.createElement(TabPanels$1, null, children);

const TabPanel = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(TabPanel$1, Object.assign({}, props), children);

const Unique = () => Math.random().toString(36).substring(2) + new Date().getTime().toString(36);
const Portal = ({
  children
}) => {
  const [portalNode, setPortalNode] = useState();
  useEffect(() => {
    const rootContext = document.body;
    const portalNode = document.createElement("div");
    portalNode.setAttribute("data-portal-id", Unique());
    rootContext.appendChild(portalNode);
    setPortalNode(portalNode);
    return () => {
      const rootContext = document.body;
      if (portalNode) {
        rootContext.removeChild(portalNode);
      }
    };
  }, []);
  if (!portalNode) {
    return null;
  }
  return /*#__PURE__*/createPortal(children, portalNode);
};

const InfiniteScroll = ({
  children,
  fetchData,
  hasMore,
  dataLength,
  showLoader = true
}) => {
  return /*#__PURE__*/React.createElement(ReactInfiniteScroll, {
    dataLength: dataLength,
    next: fetchData,
    hasMore: hasMore,
    loader: showLoader && /*#__PURE__*/React.createElement(Flex, {
      justifyContent: "center",
      p: "sp24"
    }, /*#__PURE__*/React.createElement(Spinner, null))
  }, children);
};

const StyledPagination = /*#__PURE__*/styled(Flex)`
  > :hover {
    cursor: pointer;
  }
`;
const DisabledIcon = /*#__PURE__*/styled(Icon)`
  color: #c1c7d0;
  :hover {
    cursor: inherit;
  }
`;
const Pagination = ({
  changePage,
  pageNumber,
  pageSize,
  totalResults,
  totalPages
}) => {
  if (totalPages === 1) return null; // No pagination required
  const calcPages = () => {
    const paging = {
      // Number of records per page
      pageSize,
      resultCount: totalResults,
      records: 0,
      maxPages: 0,
      pageNumber: 0,
      beginning: 0,
      ending: 0,
      pagesContext: {
        current: 0,
        first: 0,
        last: 0,
        next: 0,
        pages: [""],
        previous: 0
      }
    };
    paging.records = totalResults;
    // Maximum page number to show
    paging.maxPages = 8;
    // Current page as returned from the server
    paging.pageNumber = pageNumber + 1;
    // Beginning of records shown
    paging.beginning = paging.pageSize * (paging.pageNumber - 1) + 1;
    // Records count ending from current page
    paging.ending = paging.resultCount + paging.beginning - 1;
    // Pagination pages to render on screen
    paging.pagesContext = calcPagingData(paging.pageNumber, Math.ceil(paging.records / paging.pageSize), paging.maxPages);
    return paging;
  };
  //         Pagination format is one of:
  // < | 1 | 2 | 3 | 4 | 5 | 6 | 7 | > - num pages < a pre designated
  // maximum to show
  // < | 1 | 2 | 3 | 4 | 5 | ... | 20 | > OR
  // < | 1 | ... | 16 | 17 | 18 | 19 | 20 | > - current page more than two
  // away from either first or last page
  // < | 1 | ... | 8 | 9 | 10 | ... | 20 | > - current page more than two
  // away from both first and last pages
  var calcPagingData = function (pageNumber, numPages, maxPages) {
    // Calculate the pagination format
    const data = {
      current: pageNumber,
      first: 1,
      previous: pageNumber > 1 ? pageNumber - 1 : 1,
      next: pageNumber < numPages ? pageNumber + 1 : numPages,
      last: numPages,
      pages: ["1"]
    };
    if (pageNumber === 1) {
      data.first = 0;
      data.previous = 0;
    }
    if (pageNumber === numPages) {
      data.last = 0;
      data.next = 0;
    }
    if (numPages <= maxPages) {
      data.pages = range(1, numPages + 1);
    } else if (pageNumber > 4 && pageNumber < numPages - 3) {
      data.pages = ["1", "..."].concat(range(pageNumber - 1, pageNumber + 2)).concat(["...", numPages + ""]);
    } else if (pageNumber > 4) {
      data.pages = ["1", "..."].concat(range(numPages - maxPages + 3, numPages + 1));
    } else {
      data.pages = range(1, maxPages - 2).concat(["...", numPages]);
    }
    return data;
  };
  const range = (start, stop) => {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    const step = stop < start ? -1 : 1;
    const length = Math.max(Math.ceil((stop - start) / step), 0);
    const range = Array(length);
    for (let i = 0; i < length; i++, start += step) {
      range[i] = start;
    }
    return range;
  };
  const paging = calcPages();
  return /*#__PURE__*/React.createElement(StyledPagination, {
    alignItems: "center"
  }, paging.pagesContext.current === 1 ? /*#__PURE__*/React.createElement(DisabledIcon, {
    icon: "fa-chevron-left",
    mr: "sp8"
  }) : /*#__PURE__*/React.createElement(Flex, {
    onClick: () => changePage(pageNumber - 1)
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "fa-chevron-left",
    mr: "sp8"
  })), /*#__PURE__*/React.createElement(UnorderedList, {
    display: "flex",
    m: "0",
    styleType: "none"
  }, paging.pagesContext.pages.map((page, i) => /*#__PURE__*/React.createElement(ListItem, {
    key: i,
    py: "sp2",
    px: "sp8",
    borderRadius: "4px",
    bgColor: paging.pagesContext.current === +page ? "neutrals.500" : "",
    color: paging.pagesContext.current === +page ? "neutrals.0" : "",
    onClick: () => page !== "..." && changePage(+page - 1)
  }, page))), paging.pagesContext.current === totalPages ? /*#__PURE__*/React.createElement(DisabledIcon, {
    icon: "fa-chevron-right",
    mr: "sp8"
  }) : /*#__PURE__*/React.createElement(Flex, {
    onClick: () => changePage(pageNumber + 1)
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "fa-chevron-right",
    mr: "sp8"
  })));
};

const StyledFab = /*#__PURE__*/styled("button")`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: ${props => props.size || "38px"};
  height: ${props => props.size || "38px"};
  cursor: ${props => props.disabled ? "default" : "pointer"};
  background: ${props => props.active ? colors.brand[500] : colors.neutrals[500]};
  border-radius: 50%;
  transition: background-color 400ms;
  &:hover {
    transition: background-color 400ms;
    background: ${props => props.disabled ? colors.neutrals[500] : colors.brand[500]};
  }
`;
const Fab = props => {
  const handleClick = e => {
    if (!props.disabled) {
      props.onClick(e);
    }
  };
  return /*#__PURE__*/React.createElement(StyledFab, Object.assign({}, props, {
    onClick: handleClick
  }));
};

const StyledOverlay = /*#__PURE__*/styled("div")`
  position: fixed;
  display: flex;
  z-index: ${props => props.zIndex || 1002};
  ${props => props.flexDirection !== undefined ? `flex-direction: ${props.flexDirection};` : ""}
  ${props => props.justifyContent !== undefined ? `justify-content: ${props.justifyContent};` : ""}
  ${props => props.justifyItems !== undefined ? `justify-items: ${props.justifyItems};` : ""}
  ${props => props.alignContent !== undefined ? `align-content: ${props.alignContent};` : ""}
  ${props => props.alignItems !== undefined ? `align-items: ${props.alignItems};` : ""}
  ${props => props.bottom !== undefined ? `bottom: ${props.bottom};` : ""}
  ${props => props.left !== undefined ? `left: ${props.left};` : ""}
  ${props => props.right !== undefined ? `right: ${props.right};` : ""}
  ${props => props.top !== undefined ? `top: ${props.top};` : ""}
  ${props => props.center !== undefined ? `center: ${props.center};` : ""}
  ${props => props.width !== undefined ? `width: ${props.width};` : ""}
  ${props => props.height !== undefined ? `height: ${props.height};` : ""}
  ${props => props.background !== undefined ? `background: ${props.background};` : ""}
  ${props => props.backgroundColor !== undefined ? `background-color: ${props.backgroundColor};` : ""}
`;
const Overlay = ({
  ...props
}) => {
  return /*#__PURE__*/React.createElement(StyledOverlay, Object.assign({}, props));
};

const initI18n = resources => i18n.use(initReactI18next) // passes i18n down to react-i18next
.init({
  // the translations
  // (tip move them in a JSON file and import them,
  // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});

const Icons = () => /*#__PURE__*/React.createElement("script", {
  src: "https://kit.fontawesome.com/b56161fd23.js",
  crossOrigin: "anonymous"
});

const DraggableTbody = ({
  items,
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(SortableContext, {
    items: items,
    strategy: verticalListSortingStrategy
  }, /*#__PURE__*/React.createElement(Tbody, Object.assign({}, props), children));
};

const DraggableTr = ({
  id,
  draggingProps,
  ...props
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id
  });
  const boxShadow = isDragging ? "rgba(0, 0, 0, 0.24) 0px 3px 8px;" : undefined;
  const extraProps = isDragging ? draggingProps || {} : {};
  return /*#__PURE__*/React.createElement(Tr, Object.assign({
    transform: CSS.Transform.toString(transform),
    transition: transition,
    boxShadow: boxShadow,
    ref: setNodeRef,
    "data-testid": id
  }, attributes, listeners, props, extraProps));
};

const DraggableTable = ({
  onMove = () => {},
  ...props
}) => {
  const sensors = useSensors(useSensor(PointerSensor, {
    activationConstraint: {
      distance: 8
    }
  }), useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates
  }));
  const handleDragEnd = e => {
    const {
      active,
      over
    } = e;
    if (!over) return;
    if (active.id !== over.id) {
      onMove(active.id, over.id);
    }
  };
  return /*#__PURE__*/React.createElement(DndContext, {
    sensors: sensors,
    collisionDetection: closestCenter,
    onDragEnd: handleDragEnd,
    modifiers: [restrictToVerticalAxis, restrictToWindowEdges]
  }, /*#__PURE__*/React.createElement(Table, Object.assign({}, props)));
};

const hexToRGBA = (hex, alpha) => {
  let r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);
  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
};
const accordionBGColor = /*#__PURE__*/hexToRGBA(colors.neutrals[20], 0.6);
const Accordion = ({
  title,
  titleContent,
  isOpen,
  accordionItemProps,
  accordionButtonProps,
  accordionPanelProps,
  children,
  ...props
}) => {
  const isControlled = isOpen !== undefined;
  const openIndex = isControlled && isOpen ? 0 : isControlled && !isOpen ? -1 : undefined;
  return /*#__PURE__*/React.createElement(Accordion$1, Object.assign({
    index: openIndex,
    allowToggle: true,
    border: `1px solid ${colors.neutrals[30]}`,
    borderRadius: space.sp4
  }, props), /*#__PURE__*/React.createElement(AccordionItem, Object.assign({}, accordionItemProps), ({
    isExpanded
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement(AccordionButton, Object.assign({
    padding: `${space.sp12} ${space.sp16}`,
    bgColor: accordionBGColor
  }, accordionButtonProps), /*#__PURE__*/React.createElement(Icon, {
    icon: "fa-chevron-down",
    boxSize: space.sp12,
    transition: "all 0.2s",
    transform: isExpanded ? "" : "rotate(-90deg)",
    color: colors.neutrals[200],
    mr: space.sp12
  }), /*#__PURE__*/React.createElement(Box, {
    as: "span",
    mr: space.sp12
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: fontWeights.medium,
    fontSize: fontSizes.md
  }, title)), titleContent)), /*#__PURE__*/React.createElement(AccordionPanel, Object.assign({
    padding: `${space.sp12} ${space.sp16}`
  }, accordionPanelProps), children))));
};

const CheckboxSVG = ({
  isChecked = false
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "15",
    height: "15",
    rx: "1.5",
    fill: "#DFE1E6"
  }), isChecked && /*#__PURE__*/React.createElement("path", {
    d: "M6.37891 11.8438C6.57422 12.0391 6.90625 12.0391 7.10156 11.8438L12.8438 6.10156C13.0391 5.90625 13.0391 5.57422 12.8438 5.37891L12.1406 4.67578C11.9453 4.48047 11.6328 4.48047 11.4375 4.67578L6.75 9.36328L4.54297 7.17578C4.34766 6.98047 4.03516 6.98047 3.83984 7.17578L3.13672 7.87891C2.94141 8.07422 2.94141 8.40625 3.13672 8.60156L6.37891 11.8438Z",
    fill: "#7A869A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "15",
    height: "15",
    rx: "1.5",
    stroke: "#DFE1E6"
  }));
};
const CheckboxTree = ({
  title,
  isChecked = false,
  onToggle = () => {},
  children,
  baseProps,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Box, Object.assign({}, props), /*#__PURE__*/React.createElement(Box, Object.assign({
    as: "button",
    display: "flex",
    alignItems: "center",
    onClick: onToggle,
    userSelect: "none",
    pt: space.sp8,
    pb: space.sp8
  }, baseProps), /*#__PURE__*/React.createElement(Box, {
    mr: space.sp8
  }, /*#__PURE__*/React.createElement(CheckboxSVG, {
    isChecked: isChecked
  })), title), children !== undefined && /*#__PURE__*/React.createElement(Box, {
    borderLeft: `1px solid ${colors.neutrals[40]}`,
    pl: space.sp16
  }, children));
};

const CategoryNode = ({
  icon,
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Box, Object.assign({
    display: "flex",
    alignItems: "center"
  }, props), icon !== undefined && /*#__PURE__*/React.createElement(Box, {
    mr: space.sp4
  }, icon), /*#__PURE__*/React.createElement(Text, {
    ml: space.sp2,
    fontWeight: fontWeights.regular,
    fontSize: fontSizes.md,
    lineHeight: space.sp16,
    color: colors.neutrals[500]
  }, children));
};

export { ABTester, Accordion, Animation, Breadcrumb, Button, ButtonTd, Card, CategoryNode, Checkbox, CheckboxGroup, CheckboxTree, CircularProgress, DateTimePicker, DraggableTable, DraggableTbody, DraggableTr, InternalDrawer as Drawer, Fab, FamilyZoneLogo, FamilyZoneLogoWithText, FileUpload, FormWrapper, Icon, IconButton, Icons as IconImport, InfiniteScroll, InlineNotification, Input, LinewizeLogo, LinewizeLogoWithFamilyZone as LinewizeLogoWIthFamilyZone, LinewizeLogoWithText, Menu, MenuButton, MenuGroup, MenuItem, MenuLink, MenuList, Modal, ModalBody, MultiSearchSelector$1 as MultiHierarchySelector, MultiSearchSelector, MultiSelect, Overlay, Pagination, PasswordInput as Password, PinInput, Portal, Radio, RadioGroup, SearchBox, Select, SingleSearchSelector$1 as SingleHierarchySelector, SingleSearchSelector, Spinner, Tab, TabList, TabPanel, TabPanels, Table, TableButton, TableIconButton, Tabs, Tag, Tbody, Td, Text, TextArea, TextInput, Th, Thead, ThemeProvider, TimePicker, Toggle, ToolTip as Tooltip, Tr, initI18n, theme, useToast };
//# sourceMappingURL=component-library.esm.js.map
